import { Component, OnInit, ViewEncapsulation, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import { AllCommunityModules } from '@ag-grid-community/all-modules';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl } from '@angular/forms';
import { Location } from '@angular/common';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import {MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import {  MatChipInputEvent } from '@angular/material/chips';
import * as XLSX from 'xlsx';
import { Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DropdownRendererComponent } from 'src/common/dropdown-renderer';
import { ConfigurationService } from 'src/services/configuration.service';
import { LocalstorageService } from 'src/services/localstorage.service';
import { NgxToasterService } from 'src/services/ngx-toaster.service';

@Component({
  selector: 'app-bestbuy-forecast',
  templateUrl: './bestbuy-forecast.component.html',
  styleUrls: ['./bestbuy-forecast.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class BestbuyForecastComponent implements OnInit {
  width = '100%';
  height = '500';
  type = "msline";
  dataFormat = "json";
  dataSource;
  public submitted = false;
  public isEdit = false;
  public columnDefs = [];
  private gridApi: any;
  dropdownSettings = {};
  dropdownSettingsSingle = {};
  public tenureTypeList = [];
  public tenureTypeListTemp = [];
  public rowList = [];
  public goalTypeList = [];
  public gridOptions: any;
  public getRowHeight;
  public getRowStyle;
  public headerHeight;
  public modules = AllCommunityModules;
  public clientId = 1;
  public channelList = [{ channelId: 1, channelName: 'Retail' }];
  public channel = null;
  public csvRecords: any;
  public customerSelectedList = [];
  public selectedItemIds = [];
  public itemIdList = ['FB000038',
    'FB000084',
    'FB000063'];
  public customerList = [
    'Amazon AU',
    'Amazon CA',
    'Amazon JPN',
    'Amazon US',
    'Best Buy CA',
    'Best Buy US',
    'Synnex CA',
    'Synnex US',
    'WMT'

  ];
  public timeframeSelectedList = [];
  public itemSeletedList = [];
  public timeframeList = [];
  public versionList = [];
  public monthList = [];
  public itemList = [
    'Quest 64GB - US/CA/JP/TW',
    'Quest 128GB - US/CA/JP/TW',
    'Portal+ Black',
    'Oculus Go Relaxed Facial Interface',
    'Oculus Go Charging Cable',
    'Oculus Rift S Headband',
    'Oculus Rift Headset (only)',
    'Oculus Rift S',
    'Audio Arms',
    'Oculus Touch - Left Controller',
    'Oculus Quest UK/IE/HK/SG 64GB',
    'Rock Band VR connector',
    'Earphones',
    'Quest 64GB - EU',
    'Portal Black',
    'Quest 64GB - UK/IE/HK/SG',
    'Oculus Go Controller (Grade B)',
    'Portal Black (Gen 2)',
    'Touch',
    'Portal TV (Catalina)',
    'Oculus Rift S Standard Facial Interface',
    'Portal Mini - Dark (CA)',
    'Portal Dark - (CA)',
    'Oculus Go Carry Case',
    'Portal TV (UK/IE)',
    'Oculus Go Standalone VR 32 GB',
    'Portal+ White',
    'Rift - Marvel Bundle',
    'Unknown Oculus Product',
    'Portal Mini - White',
    'Portal Light - (CA)',
    'Oculus Go - 64GB',
    'Quest 64GB - AU/NZ',
    'Oculus Quest 128GB',
    'Sensor',
    'Quest 128GB and Case Bundle (S10252627@AMA+S10260629)',
    'Portal + White - CA',
    'Quest 128GB - AU/NZ',
    'Portal White - CA',
    'Oculus Go Controller',
    'Portal Mini (Omni)',
    'Portal White',
    'Portal White (Gen 2)',
    'Portal Mini - Black',
    'Oculus Quest IEM',
    'Portal Mini - Dark (EU)',
    'Oculus Quest Travel case',
    'Portal (Atlas)',
    'Oculus Quest UK/IE/HK/SG 128GB',
    'Portal+ Dark - (EU)',
    'Portal Mini - White (CA)',
    'Quest 64GB and Case Bundle (S10252626@AMA+S10260629)',
    'Portal TV (CA)',
    'Oculus Go - 32GB',
    'Oculus Go 64GB Headset (Grade B)',
    'Rift S',
    'Rift S Device',
    'Oculus Rift',
    '15W USB-C Power Adapter for the United Kingdom, Ireland, Hong Kong and Singapore',
    'SID (Simple Input Device)',
    '15W USB-C Power Adapter for EU',
    'Quest 128GB -EU',
    'HMD cable',
    'Oculus Go - 32GB ROW',
    'Online Game Code',
    'Oculus Touch - Right Controller',
    'Hardbundle',
    'Oculus Go Facial Interface Eye Rings',
    'Portal Mini - White (EU)',
    'Portal+ Light - (EU)',
    'Oculus Quest 64GB',
    'Oculus Go - 64GB ROW',
    'Oculus Touch Right Hand Controller',
    '15W USB-C Power Adapter for USA, Canada, Japan and Taiwan',
    'Portal TV (EU)',
    'Portal TV',
    'Portal Dark - (UK/IE)',
    'Portal + Black - CA',
    'Quest 128GB - UK/IE/HK/SG',
    'Oculus Go - Carrying Case',
    'Oculus Go Fitted Facial Interface',
    'Portal+ Light - (UK/IE)',
    'Oculus Sensor',
    'Oculus Go Controller Lanyard',
    'Portal+ Dark - (UK/IE)"',
    'Quest In-ear Headphones',
    'Portal Dark - (EU)',
    '15W USB-C Power Adapter for Australia and New Zealand',
    'Oculus Go Glasses Spacer',
    'Oculus Go Power Adapter',
    'Portal Light - (UK/IE)',
    'Oculus Go 32GB Headset (Grade B)',
    'Quest Travel Case',
    'Oculus Quest Standard Facial Interface',
    'Portal Light - (EU)',
    'Rift',
    'Portal Black - CA',
    'Portal Mini - White (UK/IE)',
    'Oculus Go Standalone VR 64 GB',
    'Portal Mini - Dark (UK/IE)',
    'Oculus Touch Left Hand Controller'
  ];
  separatorKeysCodes: number[] = [ENTER, COMMA];
  filteredCustomers: Observable<any[]>;
  filteredItems: Observable<any[]>;
  filteredTimeframe: Observable<any[]>;
  public seletedYear = null;
  public seletedVersion = null;
  public selectedMonth = null;
  public defaultRow = {};
  public selectAll = true;
  searchCustomer = new FormControl();
  searchItem = new FormControl();
  searchTimeframe = new FormControl();
  files: File[] = [];
  @ViewChild('ExcelImport') excelImport: TemplateRef<any>;
  @ViewChild('dialog') dialogTemplate: TemplateRef<any>;
  @ViewChild('searchItemInput', { static: true }) searchItemInput: ElementRef;
  @ViewChild('searchCustomerInput', { static: true }) searchCustomerInput: ElementRef;
  tempList = [];
  totalCalculatedList = [];
  chartDatasets = [];
  simulatedChartDatasets = [];
  barChartDatasets = [];
  simulatedBarChartDatasets = [];
  xAxis = [];
  yAxis = [];
  xAxisSimulated = [];
  view = [700, 700];
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = false;
  legendTitle = 'Legend';
  legendPosition = 'right';
  showXAxisLabel = true;
  xAxisLabel = 'Sales QTY';
  showYAxisLabel = true;
  yAxisLabel = 'Time Period';
  showGridLines = true;
  innerPadding = '10%';
  animations: boolean = true;
  lineChartScheme = {
    name: 'coolthree',
    selectable: true,
    group: 'Ordinal',
    domain: ['#01579b', '#7aa3e5', '#a8385d', '#00bfa5']
  };

  comboBarScheme = {
    name: 'singleLightBlue',
    selectable: true,
    group: 'Ordinal',
    domain: ['#7aa3e5']
  };

  showRightYAxisLabel: boolean = true;
  yAxisLabelRight: string = '';
  tempColDefs = [];
  chooserList = [
    { name: 'Algo Base Fcst (ST)', checked: false },
    { name: 'Algo Promo lift (ST)', checked: false },
    { name: 'Algo Seasonality (ST)', checked: false },
    { name: 'Algo Final Fcst (ST)', checked: false },
    { name: 'FB Channel Ops Manual Adjustment Fcst (ST)', checked: false },
    { name: 'FB Channel Ops Fcst (ST)', checked: false },
    { name: 'FB UDP (ST)', checked: false },
    { name: 'FB CDP (ST)', checked: false },
    { name: 'FB Budget (ST)', checked: false },
    { name: 'FB Consensus Fcst (ST)', checked: false },
    { name: 'TY Actual (ST)', checked: false },
    { name: 'LY Actual (ST)', checked: false },
    { name: 'Algo Fcst to Consensus (ST Var)', checked: false },
    { name: 'Algo Fcst to Actual (ST Var)', checked: false },
    { name: 'Customer ST Fcst to Actual (ST Var)', checked: false },
    { name: 'FB UDP to Actual (ST Var)', checked: false },
    { name: 'FB CDP to Actual (ST Var)', checked: false },
    { name: 'FB Consensus Fcst to Actual (ST Var)', checked: false },
    { name: 'Algo Fcst vs. Act. (ST Acc)', checked: false },
    { name: 'Customer Fcst vs. Act. (ST Acc)', checked: false },
    { name: 'FB Channel Ops Fcst vs. Act. (ST Acc)', checked: false },
    { name: 'FB UDP vs Act. (ST Acc)', checked: false },
    { name: 'FB ODP vs. Act. (ST Acc)', checked: false },
    { name: 'FB Consensus vs. Act. (ST Acc)', checked: false },
    { name: 'Algo Total Fcst (SI)', checked: false },
    { name: 'Customer Fcst (SI)', checked: false },
    { name: 'FB Channel Ops Unstrained Fcst (SI)', checked: false },
    { name: 'FB Channel Ops Constrained Fcst (SI)', checked: false },
    { name: 'Actual (SI)', checked: false },
    { name: 'FB Available Allocation', checked: false },
    { name: 'On-Order', checked: false },
    { name: 'Backlog (in-transit)', checked: false },
    { name: 'Customer Store OH', checked: false },
    { name: 'Customer Act. Total DC OH', checked: false },
    { name: 'Customer Target Inventory OH', checked: false },
    { name: 'Customer TGT Inventory WOS', checked: false },
    { name: 'Channel Ops Ideal WOS', checked: false },
    { name: 'Projected WOS', checked: false },
    { name: 'Algo Fcst to Override (SI Var)', checked: false },
    { name: 'Customer Fcst to Actual (SI Var)', checked: false },
    { name: 'FB Channel Ops Fcst to Actual (SI Var)', checked: false },
    { name: 'FB CPFR Fcst to Actual (SI Var)', checked: false },
    { name: 'Algo Fcst vs. Act. (SI Acc)', checked: false },
    { name: 'Customer Fcst vs. Act. (SI Acc)', checked: false },
    { name: 'FB Channel Ops Fcst vs. Act. (SI Acc)', checked: false },
    { name: 'FB CPFR Fcst vs. Act. (SI Acc)', checked: false },
    { name: 'In-stock %', checked: false },
    { name: '# Stores OOS', checked: false },
    { name: 'On Time Delivery Performance', checked: false },
    { name: 'On Time In Full', checked: false },
    { name: 'Customer Chargebacks', checked: false },
    { name: 'Profitability', checked: false },
    { name: 'Cost to Serve Customer', checked: false },
    { name: 'DC Retailer Count', checked: false },
    { name: 'Door Count', checked: false },
    { name: 'Delivery method', checked: false },
  ]
  // public  date = { begin: new Date(2018, 7, 5), end: new Date(2018, 7, 25) };
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public location: Location,
    public spinner: NgxSpinnerService,
    public toastr: NgxToasterService,
    public storage: LocalstorageService,
    public dialogRef: MatDialogRef<any>,
    public configurationService: ConfigurationService,
    public dialog: MatDialog) {
    this.gridOptions = {
      rowClassRules: {
        // apply green to 2008
        'rag-green-outer': function (params) { return params.data.secondValue === 'Final Total Forecast'; },
        'rag-grey-outer': function (params) {
          return params.rowIndex % 2 === 0
        },
        'rag-border-outer': function (params) {
          return params.data.secondValue === 'Notes';
        },
        'rag-border-top-outer': function (params) {
          return params.data.secondValue === 'Algo Base Fcst (ST)';
        },
        // // apply amber 2004
        // 'rag-amber-outer': function(params) { return params.data.year === 2004; },

        // // apply red to 2000
        // 'rag-red-outer': function(params) { return params.data.year === 2000; }
      },
      frameworkComponents: {
        dropdownRenderer: DropdownRendererComponent
      },
      // pagination: true,
      // paginationAutoPageSize: true,
      // suppressMenuHide: true,
    };
    this.headerHeight = 30;
    this.gridOptions.getRowHeight = function (params) {
      return 30;
    };
    this.gridOptions.getRowStyle = function (params) {
      if (params.data && params.data.apBudgetTenureName && typeof params.data.apBudgetTenureName === 'string') {
        if (params.data && params.data.apBudgetTenureName && params.data.apBudgetTenureName.endsWith('FY21')) {
          return { 'background-color': '#D6EAF8' };
        }
        if (params.data && params.data.apBudgetTenureName && params.data.apBudgetTenureName.startsWith('Q')) {
          return { 'background-color': '#3498DB' };
        }
        if (params.data && params.data.apBudgetTenureName && params.data.apBudgetTenureName.startsWith('WK')) {
          return { 'background-color': '' };
        }
      }
    };
  }
  openDialog(data, templateRef?: TemplateRef<any>): void {
    this.dialogRef = this.dialog.open(this.dialogTemplate, { width: '500px', data: data || {} });
  }
  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 0,
      allowSearchFilter: true
    };
    this.dropdownSettingsSingle = {
      singleSelection: true,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 0,
      allowSearchFilter: true
    };
    this.customerList = (this.customerList as any).map(customer => ({
      item_id: customer,
      item_text: customer
    }));
    this.itemList = (this.itemList as any).map(item => ({
      item_id: item,
      item_text: item
    }));
    this.versionList.push(
      'Commit',
      'V1',
      'V2',
      'V3'
    );
    for (let index = 0; index < 12; index++) {
      const date = new Date(2009, index, 10);  // 2009-11-10
      const month = date.toLocaleString('default', { month: 'long' });
      const shortMonth = date.toLocaleString('default', { month: 'short' });
      this.monthList.push(
        {
          item_id: `${shortMonth}`, item_text: `${month} FY20`
        });
    }
    this.customerList = (this.customerList as any).sort((a, b) => a.item_id < b.item_id ? -1 : 1)
    this.itemList = (this.itemList as any).sort((a, b) => a.item_id < b.item_id ? -1 : 1)
    this.searchCustomer.setValue('');
    this.searchItem.setValue('');
    this.columnDefs = [
      // {
      //   headerName: '',
      //   width: 150,
      //   field: 'firstValue',
      //   pinned: 'abcd',
      //   cellRenderer: params => `<b>${params.value ? params.value : ''}</b>`,
      //   cellStyle: { 'background-color': 'white' }
      // },
      {
        headerName: 'Quest 128GB',
        field: '',
        children: [
          {
            headerName: 'Best Buy US',
            width: 200,
            pinned: 'abcd',
            field: 'secondValue',
            cellRenderer: 'dropdownRenderer',
            cellRendererParams: (params) => {
              const items = ['Algo Base Fcst (ST)', 'Linear',
                'Curve',
                'Exponential',
                'Logarithmic',
                'Power',
                'Parabola',
                'Moving Average',
                'Single Expotential Smoothing',
                'Adaptive Smoothing',
                'Holts Linear Trend',
                'Period Percentage Change',
                'Seasonal Smoothing Method',
                'Seasonal Smoothing Average',
                'Seasonal Percentage Change',
                'Additive Decomposition',
                'Winters Additive'];
              const obj = {
                isDropDown: items.includes(params.data.secondValue) ? true : false, // pass the field value here
                items: items,
                onChange: this.filterData.bind(this),
              }
              return obj;

            },
            // cellStyle: params => {
            //   return params.node && params.value && params.node.childIndex % 2 === 0 ? { 'background-color': 'lightgray' } : { 'background-color': 'white' }
            // }
          }
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '01/05/2020',
            width: 120,
            field: 'janw1',
            suppressSizeToFit: true,
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          }
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '01/12/2020',
            width: 120,
            field: 'janw2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '01/19/2020',
            width: 120,
            field: 'janw3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '01/26/2020',
            width: 120,
            field: 'janw4',
            pivotIndex: 0,
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },

        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '02/02/2020',
            width: 120,
            field: 'febw1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '02/09/2020',
            width: 120,
            field: 'febw2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '02/16/2020',
            width: 120,
            field: 'febw3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '02/23/2020',
            width: 120,
            field: 'febw4',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },

      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '03/01/2020',
            width: 120,
            field: 'marchw1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: '03/08/2020',
            width: 120,
            field: 'marchw2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: '03/15/2020',
            width: 120,
            field: 'marchw3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '03/22/2020',
            width: 120,
            field: 'marchw4',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '03/29/2020',
            width: 120,
            field: 'marchw5',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },


      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '04/05/2020',
            width: 120,
            field: 'aprilw1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '04/12/2020',
            width: 120,
            field: 'aprilw2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '04/19/2020',
            width: 120,
            field: 'aprilw3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '04/26/2020',
            width: 120,
            field: 'aprilw4',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },

      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '05/03/2020',
            width: 120,
            field: 'mayw1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '05/10/2020',
            width: 120,
            field: 'mayw2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: '05/17/2020',
            width: 120,
            field: 'mayw3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '05/24/2020',
            width: 120,
            field: 'mayw4',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },

      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: '05/31/2020',
            width: 120,
            field: 'mayw5',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: '06/07/2020',
            width: 120,
            field: 'junew1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '06/14/2020',
            width: 120,
            field: 'junew2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '06/21/2020',
            width: 120,
            field: 'junew3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '06/28/2020',
            width: 120,
            field: 'junew4',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },


      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: '07/05/2020',
            width: 120,
            field: 'julyw1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: '07/12/2020',
            width: 120,
            field: 'julyw2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '07/19/2020',
            width: 120,
            field: 'julyw3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: '07/26/2020',
            width: 120,
            field: 'julyw4',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },

      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '08/02/2020',
            width: 120,
            field: 'augw1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '08/09/2020',
            width: 120,
            field: 'augw2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '08/16/2020',
            width: 120,
            field: 'augw3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: '08/23/2020',
            width: 120,
            field: 'augw4',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '08/30/2020',
            width: 120,
            field: 'sepw1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '09/13/2020',
            width: 120,
            field: 'sepw2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '09/20/2020',
            width: 120,
            field: 'sepw3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '09/27/2020',
            width: 120,
            field: 'sepw4',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: '10/04/2020',
            width: 120,
            field: 'octw1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '10/11/2020',
            width: 120,
            field: 'octw2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '10/18/2020',
            width: 120,
            field: 'octw3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ],
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: '10/25/2020',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' },
            width: 120,
            field: 'octw4',
          },
        ]
      },

      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: '11/01/2020',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' },
            width: 120,
            field: 'novw1',
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: '11/08/2020',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' },
            width: 120,
            field: 'novw2',
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: '11/15/2020',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' },
            width: 120,
            field: 'novw3',
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: '11/22/2020',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' },
            width: 120,
            field: 'novw4',
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: '11/29/2020',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' },
            width: 120,
            field: 'novw5',
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: '12/06/2020',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' },
            width: 120,
            field: 'decw1',
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: '12/13/2020',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' },
            width: 120,
            field: 'decw2',
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: '12/20/2020',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' },
            width: 120,
            field: 'decw3',
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: '12/27/2020',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' },
            width: 120,
            field: 'decw4',
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: 'Ttl January',
            width: 150,
            field: 'ttlJanuary',
            valueGetter: (params) => {
              if (params.data.ttlJanuary) {
                return params.data.ttlJanuary;
              } else {
                return '';
              }
            },
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
          },

        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: 'Ttl February',
            width: 150,
            valueGetter: (params) => {
              if (params.data.ttlFebruary) {
                return params.data.ttlFebruary;
              } else {
                return '';
              }
            },
            field: 'ttlFebruary',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: 'Ttl March',
            width: 150,
            valueGetter: (params) => {
              if (params.data.ttlMarch) {
                return params.data.ttlMarch;
              } else {
                return '';
              }
            },
            field: 'ttlMarch',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: 'Ttl April',
            width: 150,
            valueGetter: (params) => {
              if (params.data.ttlApril) {
                return params.data.ttlApril;
              } else {
                return '';
              }
            },
            field: 'ttlApril',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: 'Ttl May',
            width: 150,
            valueGetter: (params) => {
              if (params.data.ttlMay) {
                return params.data.ttlMay;
              } else {
                return '';
              }
            },
            field: 'ttlMay',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: 'Ttl June',
            width: 150,
            valueGetter: (params) => {
              if (params.data.ttlJune) {
                return params.data.ttlJune;
              } else {
                return '';
              }
            },
            field: 'ttlJune',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: 'Ttl July',
            width: 150,
            valueGetter: (params) => {
              if (params.data.ttlJuly) {
                return params.data.ttlJuly;
              } else {
                return '';
              }
            },
            field: 'ttlJuly',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: 'Ttl August',
            width: 150,
            valueGetter: (params) => {
              if (params.data.ttlAugust) {
                return params.data.ttlAugust;
              } else {
                return '';
              }
            },
            field: 'ttlAugust',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: 'Ttl September',
            width: 150,
            valueGetter: (params) => {
              if (params.data.ttlSeptember) {
                return params.data.ttlSeptember;
              } else {
                return '';
              }
            },
            field: 'ttlSeptember',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: 'Ttl October',
            width: 150,
            valueGetter: (params) => {
              if (params.data.ttlOctober) {
                return params.data.ttlOctober;
              } else {
                return '';
              }
            },
            field: 'ttlOctober',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: 'Ttl November',
            width: 150,
            field: 'ttlNovember',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            valueGetter: (params) => {
              if (params.data.ttlNovember) {
                return params.data.ttlNovember;
              } else {
                return '';
              }
            }
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: 'Ttl December',
            width: 150,
            field: 'ttlDecember',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            valueGetter: (params) => {
              if (params.data.ttlDecember) {
                return params.data.ttlDecember;
              } else {
                return '';
              }
            }
          },
        ],
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: 'Q1',
            width: 120,
            field: 'q1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            valueGetter: (params) => {
              if (params.data.q1) {
                return params.data.q1;
              } else {
                return '';
              }
            },
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: 'Q2',
            width: 120,
            field: 'q2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            valueGetter: (params) => {
              if (params.data.q2) {
                return params.data.q2;
              } else {
                return '';
              }
            },
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: 'Q3',
            width: 120,
            field: 'q3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            valueGetter: (params) => {
              if (params.data.q3) {
                return params.data.q3;
              } else {
                return '';
              }
            },
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: 'Q4',
            width: 120,
            field: 'q4',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            valueGetter: (params) => {
              if (params.data.q4 && params.data.secondValue === 'Seasonality') {
                return Number(params.data.q4).toFixed(2);
              } else {
                if (params.data.q4) {
                  return Number(params.data.q4);
                } else {
                  return '';
                }
              }
            }
          }
        ],
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: 'H1',
            width: 120,
            field: 'h1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            valueGetter: (params) => {
              if (params.data.h1 && params.data.secondValue === 'Seasonality') {
                return Number(params.data.h1).toFixed(2);
              } else {
                if (params.data.q4) {
                  return Number(params.data.q4);
                } else {
                  return '';
                }
              }
            }
          }
        ],
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: 'H2',
            width: 120,
            field: 'h2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            valueGetter: (params) => {
              if (params.data.h2 && params.data.secondValue === 'Seasonality') {
                return Number(params.data.h2).toFixed(2);
              } else {
                if (params.data.h2) {
                  return Number(params.data.h2);
                } else {
                  return '';
                }
              }
            }
          }
        ],
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: 'Total Year',
            width: 120,
            field: 'totalYear',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            valueGetter: (params) => {
              if (params.data.totalYear) {
                return params.data.totalYear;
              } else {
                return '';
              }
            }
          }
        ]
      },

    ];
    this.tempColDefs = JSON.parse(JSON.stringify(this.columnDefs));
    // this.columnDefs.forEach((column) => this.defaultRow[column.field] = Math.random());
    // this.configurationService.importExcel('forcast-data').subscribe(res => {
    //   this.loadFile(res);
    // });
    this.rowList = [{ "columnValue": "Sell-Through", "secondValue": "Algo Base Fcst (ST)  ", "janw1": 998.1437199999999, "janw2": 1015.47894, "janw3": 866.761, "janw4": 1010.00466, "febw1": 714.3935399999999, "febw2": 987.1951599999999, "febw3": 809.2810599999999, "febw4": 1376.7814199999998, "marchw1": 1145.9492799999998, "marchw2": 1260.5442079999998, "marchw3": 1386.5986288, "marchw4": 1525.2584916800001, "marchw5": 793.0863149999999, "aprilw1": 946.146439, "aprilw2": 976.839647, "aprilw3": 1074.5236117000002, "aprilw4": 1093.94362, "mayw1": 1028.25226, "mayw2": 1149.5988, "mayw3": 1264.5586799999999, "mayw4": 1391.014548, "mayw5": 1530.1160028000002, "junew1": 1683.1276030800004, "junew2": 1851.4403633880004, "junew3": 1082.08268, "junew4": 1082.08268, "julyw1": 1190.2909479999998, "julyw2": 1014.5665599999999, "julyw3": 1051.97414, "julyw4": 1157.1715540000002, "augw1": 1272.8887094000004, "augw2": 1057.44842, "augw3": 1780.9657599999998, "augw4": 1602.869184, "augw5": 1442.5822655999998, "sepw1": 1298.32403904, "sepw2": 1168.4916351359998, "sepw3": 1051.6424716224, "sepw4": 1041.1260469061758, "octw1": 1030.7147864371143, "octw2": 1020.4076385727429, "octw3": 1010.2035621870156, "octw4": 1000.1015265651455, "novw1": 990.100511299494, "novw2": 980.199506186499, "novw3": 970.3975111246339, "novw4": 960.6935360133875, "novw5": 951.0866006532536, "decw1": 941.5757346467211, "decw2": 932.1599773002539, "decw3": 922.8383775272514, "decw4": 913.6099937519789, "ttlJanuary": 3890.38832, "ttlFebrurary": 3887.65118, "ttlMarch": 6111.43692348, "ttlApril": 4091.4533177, "ttlMay": 4833.424288, "ttlJune": 7228.849329268, "ttlJuly": 4414.003202, "ttlAugust": 5714.1720734, "ttlSeptember": 6002.1664583045795, "ttlOctober": 4061.4275137620198, "ttlNovember": 3901.391064624018, "ttlDecember": 4661.270683879459, "q1": 13889.476423479999, "q2": 16153.726934968, "q3": 16130.341733704581, "q4": 12624.089262265501, "h1": 30043.203358448, "h2": 28754.4309959701, "ty": 58797.6343544181 }, { "columnValue": "Sell-Through", "secondValue": "Algo Promo lift (ST)", "janw1": 100, "janw3": 75, "febw2": 200, "marchw1": 200, "marchw4": 200, "aprilw1": 100, "aprilw4": 100, "mayw3": 50, "junew2": 200, "junew4": 100, "julyw3": 300, "augw2": 500, "augw5": 200, "sepw2": 100, "octw1": 50, "octw4": 50, "novw4": 219.9, "decw1": 219.9, "decw4": 219.9, "ttlJanuary": 175, "ttlFebrurary": 200, "ttlMarch": 400, "ttlApril": 200, "ttlMay": 50, "ttlJune": 300, "ttlJuly": 300, "ttlAugust": 500, "ttlSeptember": 300, "ttlOctober": 100, "ttlNovember": 219.9, "ttlDecember": 439.8, "q1": 775, "q2": 550, "q3": 1100, "q4": 759.7, "h1": 1325, "h2": 1859.7, "ty": 3184.7 }, { "columnValue": "Sell-Through", "secondValue": "Algo Seasonality (ST)", "janw1": 1.1, "janw2": 1.1, "janw3": 1.1, "janw4": 1.1, "febw1": 1.1, "febw2": 1.1, "febw3": 1.1, "febw4": 1.1, "marchw1": 1.1, "marchw2": 1.1, "marchw3": 1.1, "marchw4": 1.1, "marchw5": 1.1, "aprilw1": 1.1, "aprilw2": 1.1, "aprilw3": 1.1, "aprilw4": 1.1, "mayw1": 1.1, "mayw2": 1.1, "mayw3": 1.1, "mayw4": 1.1, "mayw5": 1.1, "junew1": 1.1, "junew2": 1.1, "junew3": 1.1, "junew4": 1.1, "julyw1": 1.1, "julyw2": 1.1, "julyw3": 1.1, "julyw4": 1.1, "augw1": 1.1, "augw2": 1.1, "augw3": 1.1, "augw4": 1.1, "augw5": 1.1, "sepw1": 1.1, "sepw2": 1.1, "sepw3": 1.1, "sepw4": 1.1, "octw1": 1.1, "octw2": 1.1, "octw3": 1.1, "octw4": 1.1, "novw1": 1.1, "novw2": 1.1, "novw3": 1.1, "novw4": 1.1, "novw5": 1.1, "decw1": 1.1, "decw2": 1.1, "decw3": 1.1, "decw4": 1.1 }, { "columnValue": "Sell-Through", "secondValue": "Algo Final Fcst (ST)", "janw1": 1098.14372, "janw2": 1015.47894, "janw3": 941.761, "janw4": 1010.00466, "febw1": 714.39354, "febw2": 1187.19516, "febw3": 809.28106, "febw4": 1376.78142, "marchw1": 1345.94928, "marchw2": 1260.544208, "marchw3": 1386.5986288, "marchw4": 1725.25849168, "marchw5": 793.086315, "aprilw1": 1046.146439, "aprilw2": 976.839647, "aprilw3": 1074.5236117, "aprilw4": 1193.94362, "mayw1": 1028.25226, "mayw2": 1149.5988, "mayw3": 1314.55868, "mayw4": 1391.014548, "mayw5": 1530.1160028, "junew1": 1683.12760308, "junew2": 2051.440363388, "junew3": 1082.08268, "junew4": 1182.08268, "julyw1": 1190.290948, "julyw2": 1014.56656, "julyw3": 1351.97414, "julyw4": 1157.171554, "augw1": 1272.8887094, "augw2": 1557.44842, "augw3": 1780.96576, "augw4": 1602.869184, "augw5": 1642.5822656, "sepw1": 1298.32403904, "sepw2": 1268.491635136, "sepw3": 1051.6424716224, "sepw4": 1041.12604690618, "octw1": 1080.71478643711, "octw2": 1020.40763857274, "octw3": 1010.20356218702, "octw4": 1050.10152656515, "novw1": 990.100511299494, "novw2": 980.199506186499, "novw3": 970.397511124634, "novw4": 1180.593536013388, "novw5": 951.086600653254, "decw1": 1161.475734646721, "decw2": 932.159977300254, "decw3": 922.838377527251, "decw4": 1133.509993751979, "ttlJanuary": 4065.38832, "ttlFebrurary": 4087.65118, "ttlMarch": 6511.43692348, "ttlApril": 4291.453317699999, "ttlMay": 4883.424288, "ttlJune": 7528.849329268, "ttlJuly": 4714.003202, "ttlAugust": 6214.1720734, "ttlSeptember": 6302.1664583045795, "ttlOctober": 4161.42751376202, "ttlNovember": 4121.29106462402, "ttlDecember": 5101.0706838794595, "q1": 14664.476423479999, "q2": 16703.726934968, "q3": 17230.341733704583, "q4": 13383.789262265498, "h1": 31368.203358448, "h2": 30614.130995970103, "ty": 61982.3343544181 }, { "columnValue": "Sell-Through", "secondValue": "FB Channel Ops Manual Adjustment Fcst (ST)", "janw1": 652.35628, "janw2": 671.1210599999999, "janw3": 874.4390000000001, "janw4": 806.1953400000001, "febw1": 2133.20646, "febw2": 563.30484, "febw3": 877.3189399999999, "febw4": 439.41858, "marchw1": 340.65071999999986, "marchw2": 594.715792, "marchw3": 654.1873712000001, "marchw4": 519.60610832, "marchw5": 957.413685, "aprilw1": 640.4535609999998, "aprilw2": 839.360353, "aprilw3": 923.2963883, "aprilw4": -114.8436200000001, "mayw1": -13.952260000000024, "mayw2": -15.598799999999983, "mayw3": -67.15868, "mayw4": -18.874548000000004, "mayw5": -20.76200279999989, "junew1": -22.838203080000085, "junew2": -225.12202338800012, "junew3": -14.682679999999891, "junew4": -114.68267999999989, "julyw1": -16.15094799999997, "julyw2": -13.766560000000027, "julyw3": -314.27414, "julyw4": -15.701553999999987, "augw1": -17.271709399999963, "augw2": -514.34842, "augw3": -24.16576000000009, "augw4": 66.09081600000013, "augw5": -57.070265600000084, "sepw1": 207.91236096000011, "sepw2": 162.4329448640001, "sepw3": 307.7358793776, "sepw4": 304.65852058382006, "octw1": 251.61193537799, "octw2": 298.59581602420997, "octw3": 295.6098578639601, "octw4": 242.65375928532012, "novw1": 289.72722169246595, "novw2": 286.82994947554096, "novw3": 283.9616499807861, "novw4": 61.222033480980144, "novw5": 278.3108131461761, "decw1": 55.627705014710045, "decw2": 272.7724279645661, "decw3": 270.044703684919, "decw4": 47.444256648069995, "ttlJanuary": 3004.11168, "ttlFebrurary": 4013.24882, "ttlMarch": 3066.57367652, "ttlApril": 2288.2666823, "ttlMay": -115.584288, "ttlJune": -398.087589268, "ttlJuly": -359.893202, "ttlAugust": -489.69507339999984, "ttlSeptember": 925.66944018542, "ttlOctober": 1088.47136855148, "ttlNovember": 921.7408546297731, "ttlDecember": 924.199906458441, "q1": 10083.93417652, "q2": 1774.5948050319998, "q3": 76.0811647854199, "q4": 2934.4121296396897, "h1": 11858.528981552001, "h2": 3010.49329442511, "ty": 14869.02227597711 }, { "columnValue": "Sell-Through", "secondValue": "FB Channel Ops Fcst (ST)", "janw1": 1750.5, "janw2": 1686.6000000000001, "janw3": 1816.2, "janw4": 1816.2, "febw1": 2847.6, "febw2": 1750.5, "febw3": 1686.6000000000001, "febw4": 1816.2, "marchw1": 1686.6000000000001, "marchw2": 1855.2600000000002, "marchw3": 2040.7860000000005, "marchw4": 2244.864600000001, "marchw5": 1750.5, "aprilw1": 1686.6000000000001, "aprilw2": 1816.2, "aprilw3": 1997.8200000000002, "aprilw4": 1079.1000000000001, "mayw1": 1014.3000000000001, "mayw2": 1134, "mayw3": 1247.4, "mayw4": 1372.14, "mayw5": 1509.3540000000003, "junew1": 1660.2894000000003, "junew2": 1826.3183400000005, "junew3": 1067.4, "junew4": 1067.4, "julyw1": 1174.14, "julyw2": 1000.8000000000001, "julyw3": 1037.7, "julyw4": 1141.4700000000003, "augw1": 1255.6170000000004, "augw2": 1043.1000000000001, "augw3": 1756.8, "augw4": 1668.9599999999998, "augw5": 1585.5119999999997, "sepw1": 1506.2363999999995, "sepw2": 1430.9245799999994, "sepw3": 1359.3783509999994, "sepw4": 1345.7845674899993, "octw1": 1332.3267218150993, "octw2": 1319.0034545969484, "octw3": 1305.813420050979, "octw4": 1292.7552858504691, "novw1": 1279.8277329919645, "novw2": 1267.0294556620447, "novw3": 1254.3591611054242, "novw4": 1241.8155694943698, "novw5": 1229.3974137994262, "decw1": 1217.1034396614318, "decw2": 1204.9324052648176, "decw3": 1192.8830812121694, "decw4": 1180.9542504000476, "ttlJanuary": 7069.5, "ttlFebrurary": 8100.9, "ttlMarch": 9578.0106, "ttlApril": 6579.719999999999, "ttlMay": 4767.84, "ttlJune": 7130.76174, "ttlJuly": 4354.11, "ttlAugust": 5724.477, "ttlSeptember": 7227.83589849, "ttlOctober": 5249.8988823135005, "ttlNovember": 5043.0319192538, "ttlDecember": 6025.27059033789, "q1": 24748.4106, "q2": 18478.32174, "q3": 17306.42289849, "q4": 16318.2013919052, "h1": 43226.73234, "h2": 33624.6242903952, "ty": 76851.3566303952 }, { "columnValue": "Sell-Through", "secondValue": "Customer Fcst (ST)", "janw1": 1094, "janw2": 1113, "janw3": 950, "janw4": 1107, "febw1": 783, "febw2": 1082, "febw3": 887, "febw4": 1509, "marchw1": 1256, "marchw2": 1381.6000000000001, "marchw3": 1519.7600000000002, "marchw4": 1671.7360000000003, "marchw5": 1945, "aprilw1": 1874, "aprilw2": 2018, "aprilw3": 2219.8, "aprilw4": 1199, "mayw1": 1127, "mayw2": 1260, "mayw3": 1386, "mayw4": 1524.6000000000001, "mayw5": 1677.0600000000002, "junew1": 1844.7660000000003, "junew2": 2029.2426000000005, "junew3": 1186, "junew4": 1186, "julyw1": 1304.6000000000001, "julyw2": 1112, "julyw3": 1153, "julyw4": 1268.3000000000002, "augw1": 1395.1300000000003, "augw2": 1159, "augw3": 1952, "augw4": 1756.8, "augw5": 1581.12, "sepw1": 1423.008, "sepw2": 1280.7072, "sepw3": 1152.6364800000001, "sepw4": 1141.1101152, "octw1": 1129.6990140480002, "octw2": 1118.4020239075203, "octw3": 1107.2180036684451, "octw4": 1096.1458236317608, "novw1": 1085.1843653954431, "novw2": 1074.3325217414888, "novw3": 1063.589196524074, "novw4": 1052.9533045588332, "novw5": 1042.423771513245, "decw1": 1031.9995337981125, "decw2": 1021.6795384601313, "decw3": 1011.4627430755299, "decw4": 1001.3481156447747, "ttlJanuary": 4264, "ttlFebrurary": 4261, "ttlMarch": 7774.096, "ttlApril": 7310.8, "ttlMay": 5297.6, "ttlJune": 7923.0686, "ttlJuly": 4837.9, "ttlAugust": 6262.93, "ttlSeptember": 6578.5817952, "ttlOctober": 4451.46486525573, "ttlNovember": 4276.05938821984, "ttlDecember": 5108.91370249179, "q1": 16299.096, "q2": 20531.4686, "q3": 17679.4117952, "q4": 13836.43795596736, "h1": 36830.5646, "h2": 31515.8497511674, "ty": 68346.41435116739 }, { "columnValue": "Sell-Through", "secondValue": "FB UDP (ST)", "janw1": 1083.0600000000002, "janw2": 1101.8700000000001, "janw3": 940.5000000000001, "janw4": 1095.93, "febw1": 775.1700000000001, "febw2": 1071.18, "febw3": 878.1300000000001, "febw4": 1493.9100000000003, "marchw1": 1243.4400000000003, "marchw2": 1367.7840000000003, "marchw3": 1504.5624000000005, "marchw4": 1655.0186400000007, "marchw5": 1925.5500000000002, "aprilw1": 1855.2600000000002, "aprilw2": 1997.8200000000002, "aprilw3": 2197.6020000000003, "aprilw4": 1187.0100000000002, "mayw1": 1115.7300000000002, "mayw2": 1247.4, "mayw3": 1372.14, "mayw4": 1509.3540000000003, "mayw5": 1660.2894000000003, "junew1": 1826.3183400000005, "junew2": 2008.9501740000007, "junew3": 1174.14, "junew4": 1174.14, "julyw1": 1291.5540000000003, "julyw2": 1100.88, "julyw3": 1141.4700000000003, "julyw4": 1255.6170000000004, "augw1": 1381.1787000000006, "augw2": 1147.4100000000003, "augw3": 1932.48, "augw4": 1739.232, "augw5": 1565.3088, "sepw1": 1408.77792, "sepw2": 1267.900128, "sepw3": 1141.1101152, "sepw4": 1129.6990140480002, "octw1": 1118.4020239075203, "octw2": 1107.2180036684451, "octw3": 1096.1458236317608, "octw4": 1085.1843653954431, "novw1": 1074.3325217414888, "novw2": 1063.589196524074, "novw3": 1052.9533045588332, "novw4": 1042.423771513245, "novw5": 1031.9995337981125, "decw1": 1021.6795384601313, "decw2": 1011.4627430755299, "decw3": 1001.3481156447747, "decw4": 991.334634488327, "ttlJanuary": 4221.36, "ttlFebrurary": 4218.39, "ttlMarch": 7696.35504, "ttlApril": 7237.692, "ttlMay": 5244.624, "ttlJune": 7843.837914000001, "ttlJuly": 4789.521, "ttlAugust": 6200.3007, "ttlSeptember": 6512.795977248, "ttlOctober": 4406.95021660317, "ttlNovember": 4233.29879433765, "ttlDecember": 5057.824565466877, "q1": 16136.10504, "q2": 20326.153914000002, "q3": 17502.617677248, "q4": 13698.0735764077, "h1": 36462.258954, "h2": 31200.6912536557, "ty": 67662.9502076557 }, { "columnValue": "Sell-Through", "secondValue": "FB CDP (ST)", "janw1": 1039.3, "janw2": 1057.35, "janw3": 902.5, "janw4": 1051.6499999999999, "febw1": 743.8499999999999, "febw2": 1027.8999999999999, "febw3": 842.65, "febw4": 1433.55, "marchw1": 1193.2, "marchw2": 1312.5200000000002, "marchw3": 1443.7720000000004, "marchw4": 1588.1492000000005, "marchw5": 1847.75, "aprilw1": 1780.3, "aprilw2": 1917.1, "aprilw3": 2108.81, "aprilw4": 1139.05, "mayw1": 1070.6499999999999, "mayw2": 1197, "mayw3": 1316.7, "mayw4": 1448.3700000000001, "mayw5": 1593.2070000000003, "junew1": 1752.5277000000006, "junew2": 1927.7804700000008, "junew3": 1126.7, "junew4": 1126.7, "julyw1": 1239.3700000000001, "julyw2": 1056.3999999999999, "julyw3": 1095.35, "julyw4": 1204.885, "augw1": 1325.3735000000001, "augw2": 1101.05, "augw3": 1854.3999999999999, "augw4": 1668.9599999999998, "augw5": 1502.0639999999999, "sepw1": 1351.8575999999998, "sepw2": 1216.67184, "sepw3": 1095.004656, "sepw4": 1084.0546094400001, "octw1": 1073.2140633456002, "octw2": 1062.481922712144, "octw3": 1051.8571034850227, "octw4": 1041.3385324501724, "novw1": 1030.9251471256707, "novw2": 1020.615895654414, "novw3": 1010.4097366978698, "novw4": 1000.305639330891, "novw5": 990.3025829375821, "decw1": 980.3995571082063, "decw2": 970.5955615371242, "decw3": 960.889605921753, "decw4": 951.2807098625354, "ttlJanuary": 4050.8, "ttlFebrurary": 4047.95, "ttlMarch": 7385.3912, "ttlApril": 6945.26, "ttlMay": 5032.719999999999, "ttlJune": 7526.91517, "ttlJuly": 4596.005, "ttlAugust": 5949.7835000000005, "ttlSeptember": 6249.652705439999, "ttlOctober": 4228.89162199294, "ttlNovember": 4062.25641880884, "ttlDecember": 4853.468017367205, "q1": 15484.1412, "q2": 19504.89517, "q3": 16795.44120544, "q4": 13144.61605816899, "h1": 34989.03637, "h2": 29940.057263609, "ty": 64929.093633609 }, { "columnValue": "Sell-Through", "secondValue": "FB Budget (ST)", "janw1": 1120.3654, "janw2": 1139.8233, "janw3": 972.895, "janw4": 1133.6787000000002, "febw1": 801.8703, "febw2": 1108.0762, "febw3": 908.3767, "febw4": 1545.3669, "marchw1": 1286.2695999999999, "marchw2": 1414.89656, "marchw3": 1556.386216, "marchw4": 1712.0248376000002, "marchw5": 890.1989249999999, "aprilw1": 1062.001105, "aprilw2": 1096.4526650000003, "aprilw3": 1206.0979315000004, "aprilw4": 1227.8959000000002, "mayw1": 1154.1607000000001, "mayw2": 1290.366, "mayw3": 1419.4026000000001, "mayw4": 1561.3428600000002, "mayw5": 1717.4771460000004, "junew1": 1889.2248606000005, "junew2": 2078.147346660001, "junew3": 1214.5826, "junew4": 1214.5826, "julyw1": 1336.04086, "julyw2": 1138.7992, "julyw3": 1180.7873000000002, "julyw4": 1298.8660300000004, "augw1": 1428.7526330000005, "augw2": 1186.9319, "augw3": 1999.0432, "augw4": 1799.1388800000002, "augw5": 1619.2249920000002, "sepw1": 1457.3024928, "sepw2": 1311.57224352, "sepw3": 1180.415019168, "sepw4": 1168.61086897632, "octw1": 1156.9247602865569, "octw2": 1145.3555126836911, "octw3": 1133.9019575568543, "octw4": 1122.5629379812858, "novw1": 1111.3373086014728, "novw2": 1100.2239355154582, "novw3": 1089.2216961603035, "novw4": 1078.3294791987005, "novw5": 1067.5461844067133, "decw1": 1056.8707225626463, "decw2": 970.5955615371242, "decw3": 960.889605921753, "decw4": 951.2807098625354, "ttlJanuary": 4366.7624, "ttlFebrurary": 4363.6901, "ttlMarch": 6859.776138599999, "ttlApril": 4592.4476015, "ttlMay": 5425.2721599999995, "ttlJune": 8114.01455326, "ttlJuly": 4954.49339, "ttlAugust": 6413.866613, "ttlSeptember": 6737.12561646432, "ttlOctober": 4558.74516850839, "ttlNovember": 4379.11241947593, "ttlDecember": 5007.182784290775, "q1": 15590.2286386, "q2": 18131.73431476, "q3": 18105.48561946432, "q4": 13945.0403722751, "h1": 33721.96295336, "h2": 32050.5259917394, "ty": 65772.48894509941 }, { "columnValue": "Sell-Through", "secondValue": "FB Consensus Fcst (ST)", "janw1": 1072.12, "janw2": 1090.74, "janw3": 931, "janw4": 1084.86, "febw1": 767.34, "febw2": 1060.36, "febw3": 869.26, "febw4": 1478.82, "marchw1": 1230.8799999999999, "marchw2": 1353.968, "marchw3": 1489.3648000000003, "marchw4": 1638.3012800000004, "marchw5": 1906.1, "aprilw1": 1836.52, "aprilw2": 1977.6399999999999, "aprilw3": 2175.404, "aprilw4": 1175.02, "mayw1": 1104.46, "mayw2": 1234.8, "mayw3": 1358.28, "mayw4": 1494.1080000000002, "mayw5": 1643.5188000000003, "junew1": 1807.8706800000004, "junew2": 1988.6577480000008, "junew3": 1162.28, "junew4": 1162.28, "julyw1": 1278.508, "julyw2": 1089.76, "julyw3": 1129.94, "julyw4": 1242.9340000000002, "augw1": 1367.2274000000002, "augw2": 1135.82, "augw3": 1912.96, "augw4": 1721.664, "augw5": 1549.4976, "sepw1": 1394.54784, "sepw2": 1255.093056, "sepw3": 1129.5837503999999, "sepw4": 1118.2879128959999, "octw1": 1107.10503376704, "octw2": 1096.0339834293695, "octw3": 1085.0736435950757, "octw4": 1074.222907159125, "novw1": 1063.4806780875338, "novw2": 1052.8458713066584, "novw3": 1042.3174125935918, "novw4": 1031.894238467656, "novw5": 1021.5752960829793, "decw1": 1011.3595431221495, "decw2": 1001.245947690928, "decw3": 991.2334882140187, "decw4": 981.3211533318786, "ttlJanuary": 4178.72, "ttlFebrurary": 4175.78, "ttlMarch": 7618.614079999999, "ttlApril": 7164.584000000001, "ttlMay": 5191.648, "ttlJune": 7764.607228, "ttlJuly": 4741.142, "ttlAugust": 6137.6714, "ttlSeptember": 6447.010159296, "ttlOctober": 4362.435567950621, "ttlNovember": 4190.53820045544, "ttlDecember": 5006.735428441959, "q1": 15973.11408, "q2": 20120.839228, "q3": 17325.823559295997, "q4": 13559.70919684802, "h1": 36093.953308, "h2": 30885.532756144, "ty": 66979.486064144 }, { "columnValue": "Sell-Through", "secondValue": "TY Actual (ST)", "janw1": 1018.5139999999999, "janw2": 1036.203, "janw3": 884.4499999999999, "janw4": 1030.617, "febw1": 728.973, "febw2": 1007.3419999999999, "febw3": 825.7969999999999, "febw4": 1404.879, "marchw1": 1169.3359999999998, "marchw2": 1286.2695999999999, "marchw3": 1414.89656, "marchw4": 1556.386216, "marchw5": 809.2717499999999, "aprilw1": 965.45555, "aprilw2": 996.77515, "aprilw3": 1096.4526650000003, "aprilw4": 1116.269, "mayw1": 1049.237, "mayw2": 1173.06, "mayw3": 1290.366, "mayw4": 1419.4026000000001, "mayw5": 1561.3428600000002, "junew1": 1717.4771460000004, "junew2": 1889.2248606000005, "junew3": 1104.166, "junew4": 1104.166, "julyw1": 1214.5826, "julyw2": 1035.272, "julyw3": 1073.443, "julyw4": 1180.7873000000002, "augw1": 1298.8660300000004, "augw2": 1079.029, "augw3": 1817.312, "augw4": 1635.5808, "augw5": 1472.02272, "sepw1": 1324.820448, "sepw2": 1192.3384032, "sepw3": 1073.10456288, "sepw4": 1062.3735172512, "octw1": 1051.749782078688, "octw2": 1041.232284257901, "octw3": 1030.819961415322, "octw4": 1020.5117618011689, "novw1": 1010.3066441831571, "novw2": 1000.2035777413255, "novw3": 990.2015419639122, "novw4": 980.299526544273, "novw5": 970.4965312788303, "decw1": 960.791565966042, "ttlJanuary": 3969.7839999999997, "ttlFebrurary": 3966.991, "ttlMarch": 6236.160126, "ttlApril": 4174.952365, "ttlMay": 4932.0656, "ttlJune": 7376.3768666000005, "ttlJuly": 4504.0849, "ttlAugust": 5830.787829999999, "ttlSeptember": 6124.6596513312, "ttlOctober": 4144.31378955308, "ttlNovember": 3981.0112904326634, "ttlDecember": 1931.28809724487, "q1": 14172.935126, "q2": 16483.3948316, "q3": 16459.5323813312, "q4": 10056.61317723061, "h1": 30656.3299576, "h2": 26516.1455585618, "ty": 57172.475516161794 }, { "columnValue": "Sell-Through", "secondValue": "LY Actual (ST)", "janw1": 916.6625999999999, "janw2": 932.5827, "janw3": 796.005, "janw4": 927.5553, "febw1": 656.0757, "febw2": 906.6077999999999, "febw3": 743.2172999999999, "febw4": 1264.3911, "marchw1": 1052.4024, "marchw2": 1157.6426399999998, "marchw3": 1273.406904, "marchw4": 1400.7475944, "marchw5": 728.344575, "aprilw1": 868.909995, "aprilw2": 897.0976350000001, "aprilw3": 986.8073985000002, "aprilw4": 1004.6421, "mayw1": 944.3133000000001, "mayw2": 1055.754, "mayw3": 1161.3294, "mayw4": 1277.46234, "mayw5": 1405.2085740000002, "junew1": 1545.7294314000003, "junew2": 1700.3023745400005, "junew3": 993.7493999999999, "junew4": 993.7493999999999, "julyw1": 1093.12434, "julyw2": 931.7447999999999, "julyw3": 966.0987, "julyw4": 1062.7085700000002, "augw1": 1168.9794270000004, "augw2": 971.1261000000001, "augw3": 1635.5808, "augw4": 1472.02272, "augw5": 1324.820448, "sepw1": 1192.3384032, "sepw2": 1073.10456288, "sepw3": 965.794106592, "sepw4": 956.1361655260799, "octw1": 946.5748038708192, "octw2": 937.1090558321109, "octw3": 927.7379652737899, "octw4": 918.460585621052, "novw1": 909.2759797648414, "novw2": 900.1832199671929, "novw3": 891.181387767521, "novw4": 882.2695738898458, "novw5": 873.4468781509472, "decw1": 864.7124093694378, "decw2": 970.4965312788303, "decw3": 960.791565966042, "decw4": 970.5955615371242, "ttlJanuary": 3572.8056, "ttlFebrurary": 3570.2919, "ttlMarch": 5612.5441134, "ttlApril": 3757.4571285, "ttlMay": 4438.859039999999, "ttlJune": 6638.739179939999, "ttlJuly": 4053.67641, "ttlAugust": 5247.709047, "ttlSeptember": 5512.193686198079, "ttlOctober": 3729.882410597772, "ttlNovember": 3582.910161389406, "ttlDecember": 4640.042946302384, "q1": 12755.6416134, "q2": 14835.05534844, "q3": 14813.57914319808, "q4": 11952.835518289561, "h1": 27590.69696184, "h2": 26766.4146614877, "ty": 54357.1116233277 }, { "columnValue": "Quest 128GB", "secondValue": "Promo Indicator Flag", "janw1": "Y", "janw2": "N", "janw3": "Y", "janw4": "N", "febw1": "N", "febw2": "Y", "febw3": "N", "febw4": "N", "marchw1": "Y", "marchw2": "N", "marchw3": "N", "marchw4": "Y" }, { "columnValue": "Quest 128GB", "secondValue": "Comments:", "janw1": "Online ad", "janw3": "Email ad", "febw2": "Print ad", "marchw1": "Price drop", "marchw4": "Online ad", "aprilw1": "Email ad", "aprilw4": "Print ad", "mayw3": "Price drop", "junew2": "Online ad", "junew4": "Email ad", "julyw3": "Print ad", "augw2": "Price drop", "augw5": "Online ad", "sepw2": "Email ad", "octw1": "Print ad", "octw4": "Price drop", "novw4": "Online ad", "decw1": "Email ad", "decw4": "Print ad" }, { "columnValue": "Quest 128GB" }, { "columnValue": "Sell-Through Variance", "secondValue": "Sell-Through Variance" }, { "columnValue": "Sell-Through Variance", "secondValue": "Algo Fcst to Consensus (ST Var)", "janw1": 26.02372000000014, "janw2": -75.26106000000004, "janw3": 10.760999999999967, "janw4": -74.85533999999996, "febw1": -52.94646, "febw2": 126.83516000000009, "febw3": -59.978939999999966, "febw4": -102.03857999999991, "marchw1": 115.06927999999994, "marchw2": -93.42379200000005, "marchw3": -102.76617120000014, "marchw4": 86.95721168, "marchw5": -1113.013685, "aprilw1": -790.3735609999999, "aprilw2": -1000.8003530000001, "aprilw3": -1100.8803883, "aprilw4": 18.923620000000028, "mayw1": -76.20774000000006, "mayw2": -85.20119999999997, "mayw3": -43.72131999999988, "mayw4": -103.09345199999984, "mayw5": -113.40279720000012, "junew1": -124.74307692000002, "junew2": 62.78261538800007, "junew3": -80.19731999999999, "junew4": 19.80268000000001, "julyw1": -88.21705199999997, "julyw2": -75.19344000000001, "julyw3": 222.03413999999998, "julyw4": -85.76244599999995, "augw1": -94.33869060000006, "augw2": 421.62842, "augw3": -131.99424, "augw4": -118.79481600000008, "augw5": 93.08466560000011, "sepw1": -96.22380096000006, "sepw2": 13.39857913600008, "sepw3": -77.94127877760002, "sepw4": -77.16186598982017, "octw1": -26.390247329929934, "octw2": -75.62634485663, "octw3": -74.87008140806006, "octw4": -24.12138059398012, "novw1": -73.38016678803592, "novw2": -72.64636512016102, "novw3": -71.91990146895603, "novw4": 148.6992975457299, "novw5": -70.48869542972602, "decw1": 150.11619152457, "decw2": -69.08597039067604, "decw3": -68.39511068676791, "decw4": 152.18884042010086, "ttlJanuary": -113.33167999999989, "ttlFebrurary": -88.12881999999989, "ttlMarch": -1107.1771565200002, "ttlApril": -2873.1306823, "ttlMay": -308.223712, "ttlJune": -235.757898732, "ttlJuly": -27.138797999999994, "ttlAugust": 76.50067340000001, "ttlSeptember": -144.8437009914201, "ttlOctober": -201.00805418860008, "ttlNovember": -69.24713583142301, "ttlDecember": 94.335255437501, "q1": -1308.6376565199998, "q2": -3417.112293032, "q3": -95.48182559142, "q4": -175.919934582522, "h1": -4725.749949552, "h2": -271.40176017394197, "ty": -4997.151709725942 }, { "columnValue": "Sell-Through Variance", "secondValue": "Algo Fcst to Actual (ST Var)", "janw1": 79.62972000000002, "janw2": -20.72406000000001, "janw3": 57.31099999999992, "janw4": -20.612340000000017, "febw1": -14.579459999999926, "febw2": 179.85316, "febw3": -16.51594, "febw4": -28.09757999999988, "marchw1": 176.61328000000003, "marchw2": -25.725392000000056, "marchw3": -28.297931199999994, "marchw4": 168.8722756799998, "marchw5": -16.185434999999984, "aprilw1": 80.69088900000008, "aprilw2": -19.93550300000004, "aprilw3": -21.929053300000078, "aprilw4": 77.67462, "mayw1": -20.9847400000001, "mayw2": -23.461199999999963, "mayw3": 24.19268000000011, "mayw4": -28.38805199999979, "mayw5": -31.22685720000004, "junew1": -34.349542919999976, "junew2": 162.2155027880001, "junew3": -22.083319999999958, "junew4": 77.91668000000004, "julyw1": -24.291651999999885, "julyw2": -20.705439999999953, "julyw3": 278.53114000000005, "julyw4": -23.615745999999945, "augw1": -25.977320599999985, "augw2": 478.41941999999995, "augw3": -36.34623999999985, "augw4": -32.71161600000005, "augw5": 170.5595456000001, "sepw1": -26.496408960000053, "sepw2": 76.15323193600011, "sepw3": -21.462091257599923, "sepw4": -21.24747034502002, "octw1": 28.965004358419947, "octw2": -20.824645685159908, "octw3": -20.616399228299997, "octw4": 29.58976476397993, "novw1": -20.206132883665987, "novw2": -20.004071554831057, "novw3": -19.80403083927797, "novw4": 200.29400946911687, "novw5": -19.409930625576067, "decw1": 200.684168680678, "decw2": 932.159977300254, "decw3": 922.838377527251, "decw4": 1133.50999375198, "ttlJanuary": 95.60432, "ttlFebrurary": 120.66018000000008, "ttlMarch": 275.27679748, "ttlApril": 116.5009527, "ttlMay": -48.6413119999998, "ttlJune": 152.4724626680001, "ttlJuly": 209.91830200000012, "ttlAugust": 383.3842433999999, "ttlSeptember": 177.50680697338, "ttlOctober": 17.1137242089399, "ttlNovember": 140.27977419134197, "ttlDecember": 3169.78258663459, "q1": 491.54129748, "q2": 220.3321033680002, "q3": 770.80935237338, "q4": 3327.17608503487, "h1": 711.8734008480001, "h2": 4097.98543740825, "ty": 4809.858838256249 }, { "columnValue": "Sell-Through Variance", "secondValue": "Customer ST Fcst to Actual (ST Var)", "janw1": 75.48599999999999, "janw2": 76.79700000000003, "janw3": 65.54999999999995, "janw4": 76.38300000000004, "febw1": 54.027000000000044, "febw2": 74.65800000000002, "febw3": 61.202999999999975, "febw4": 104.1210000000001, "marchw1": 86.66399999999999, "marchw2": 95.33039999999983, "marchw3": 104.86344000000008, "marchw4": 115.349784, "marchw5": 1135.7282500000001, "aprilw1": 908.54445, "aprilw2": 1021.22485, "aprilw3": 1123.3473350000002, "aprilw4": 82.731, "mayw1": 77.76299999999992, "mayw2": 86.94000000000005, "mayw3": 95.63400000000001, "mayw4": 105.19740000000002, "mayw5": 115.71713999999997, "junew1": 127.28885400000013, "junew2": 140.01773939999998, "junew3": 81.83400000000006, "junew4": 81.83400000000006, "julyw1": 90.01739999999995, "julyw2": 76.72800000000007, "julyw3": 79.55700000000002, "julyw4": 87.5127, "augw1": 96.2639700000002, "augw2": 79.971, "augw3": 134.6880000000001, "augw4": 121.2192, "augw5": 109.09727999999996, "sepw1": 98.1875520000001, "sepw2": 88.36879680000015, "sepw3": 79.53191711999989, "sepw4": 78.73659794880018, "octw1": 77.94923196930995, "octw2": 77.16973964962017, "octw3": 76.39804225312992, "octw4": 75.6340618305901, "novw1": 74.87772121228, "novw2": 74.12894400015989, "novw3": 73.38765456015813, "novw4": 72.65377801455702, "novw5": 71.92724023441986, "decw1": 71.207967832068, "decw2": 1021.67953846013, "decw3": 1011.46274307553, "decw4": 1001.34811564477, "ttlJanuary": 294.216, "ttlFebrurary": 294.009, "ttlMarch": 1537.9358739999998, "ttlApril": 3135.847635, "ttlMay": 365.5344, "ttlJune": 546.6917334000001, "ttlJuly": 333.81510000000003, "ttlAugust": 432.14217, "ttlSeptember": 453.92214386880016, "ttlOctober": 307.15107570265013, "ttlNovember": 0, "ttlDecember": 3177.6256052469203, "q1": 2126.160874, "q2": 4048.0737684, "q3": 1219.8794138688, "q4": 3484.7766809495697, "h1": 6174.234642400001, "h2": 4704.656094818371, "ty": 10878.89073721837 }, { "columnValue": "Sell-Through Variance", "secondValue": "FB Channel Ops Fcst to Actual (ST Var)", "janw1": 5949.7835000000005, "janw2": 650.3969999999999, "janw3": 931.75, "janw4": 785.5830000000001, "febw1": 2118.627, "febw2": 743.158, "febw3": 860.8029999999999, "febw4": 411.32100000000014, "marchw1": 517.2639999999999, "marchw2": 568.9903999999999, "marchw3": 625.8894400000001, "marchw4": 688.4783839999998, "marchw5": 941.22825, "aprilw1": 721.1444499999999, "aprilw2": 819.42485, "aprilw3": 901.3673349999999, "aprilw4": -37.169000000000096, "mayw1": -34.937000000000126, "mayw2": -39.059999999999945, "mayw3": -42.965999999999894, "mayw4": -47.26259999999979, "mayw5": -51.98885999999993, "junew1": -57.18774600000006, "junew2": -62.90652060000002, "junew3": -36.76599999999985, "junew4": -36.76599999999985, "julyw1": -40.44259999999986, "julyw2": -34.47199999999998, "julyw3": -35.74299999999994, "julyw4": -39.31729999999993, "augw1": -43.24902999999995, "augw2": -35.92900000000009, "augw3": -60.511999999999944, "augw4": 33.37920000000008, "augw5": 113.48928000000001, "sepw1": 181.41595200000006, "sepw2": 238.5861768000002, "sepw3": 286.27378812000006, "sepw4": 283.41105023880004, "octw1": 280.57693973640994, "octw2": 277.77117033905006, "octw3": 274.9934586356601, "octw4": 272.24352404930005, "novw1": 269.52108880879996, "novw2": 266.8258779207099, "novw3": 264.1576191415081, "novw4": 261.516042950097, "novw5": 258.9008825206, "decw1": 256.31187369538804, "decw2": 1204.93240526482, "decw3": 1192.88308121217, "decw4": 1180.95425040005, "ttlJanuary": 8317.513500000001, "ttlFebrurary": 4133.909000000001, "ttlMarch": 3341.8504740000003, "ttlApril": 2404.7676349999997, "ttlMay": -164.2255999999998, "ttlJune": -245.6151265999999, "ttlJuly": -149.9748999999999, "ttlAugust": -106.31082999999991, "ttlSeptember": 1103.1762471588, "ttlOctober": 1105.58509276042, "ttlNovember": 1062.020628821115, "ttlDecember": 4093.98249309303, "q1": 15793.272974, "q2": 1994.9269084, "q3": 846.8905171587999, "q4": 6261.58821467457, "h1": 17788.1998824, "h2": 7108.47873183337, "ty": 24896.67861423337 }, { "columnValue": "Sell-Through Variance", "secondValue": "FB UDP to Actual (ST Var)", "janw1": 64.54599999999994, "janw2": 65.66699999999992, "janw3": 56.049999999999955, "janw4": 65.3130000000001, "febw1": 46.197, "febw2": 63.83800000000008, "febw3": 52.33299999999997, "febw4": 89.03100000000018, "marchw1": 74.10400000000004, "marchw2": 81.51440000000002, "marchw3": 89.66584000000012, "marchw4": 98.6324239999999, "marchw5": 1116.2782499999998, "aprilw1": 889.80445, "aprilw2": 1001.0448499999999, "aprilw3": 1101.1493349999998, "aprilw4": 70.74099999999999, "mayw1": 66.49299999999994, "mayw2": 74.34000000000015, "mayw3": 81.77400000000011, "mayw4": 89.95140000000015, "mayw5": 98.94653999999991, "junew1": 108.84119400000009, "junew2": 119.7253134, "junew3": 69.97400000000016, "junew4": 69.97400000000016, "julyw1": 76.97140000000013, "julyw2": 65.60800000000017, "julyw3": 68.02700000000004, "julyw4": 74.8297, "augw1": 82.31267000000003, "augw2": 68.38100000000009, "augw3": 115.16800000000012, "augw4": 103.65120000000002, "augw5": 93.28608000000008, "sepw1": 83.95747200000005, "sepw2": 75.56172480000009, "sepw3": 68.0055523200001, "sepw4": 67.32549679680005, "octw1": 66.65224182883003, "octw2": 65.98571941055002, "octw3": 65.3258622164401, "octw4": 64.67260359426996, "novw1": 64.02587755832997, "novw2": 63.38561878274004, "novw3": 62.75176259491809, "novw4": 62.12424496897688, "novw5": 61.5030025192799, "decw1": 60.88797249408799, "decw2": 1011.46274307553, "decw3": 1001.34811564477, "decw4": 991.334634488327, "ttlJanuary": 251.5760000000001, "ttlFebrurary": 251.3990000000002, "ttlMarch": 1460.1949140000002, "ttlApril": 3062.739635, "ttlMay": 312.55840000000023, "ttlJune": 467.4610474000002, "ttlJuly": 285.4361, "ttlAugust": 369.51287, "ttlSeptember": 388.1363259168001, "ttlOctober": 262.63642705009, "ttlNovember": 252.28750390496492, "ttlDecember": 3126.536468221997, "q1": 1963.169914, "q2": 3842.7590824, "q3": 1043.0852959168, "q4": 3641.46039917705, "h1": 5805.9289964, "h2": 4684.54569509385, "ty": 10490.47469149385 }, { "columnValue": "Sell-Through Variance", "secondValue": "FB CDP to Actual (ST Var)", "janw1": 20.785999999999945, "janw2": 21.146999999999935, "janw3": 18.049999999999955, "janw4": 21.03300000000013, "febw1": 14.877000000000066, "febw2": 20.558000000000106, "febw3": 16.852999999999952, "febw4": 28.67100000000005, "marchw1": 23.864000000000033, "marchw2": 26.2503999999999, "marchw3": 28.875440000000026, "marchw4": 31.76298399999996, "marchw5": 1038.4782500000001, "aprilw1": 814.8444499999999, "aprilw2": 920.3248499999999, "aprilw3": 1012.3573349999999, "aprilw4": 22.78099999999995, "mayw1": 21.41300000000001, "mayw2": 23.940000000000055, "mayw3": 26.33400000000006, "mayw4": 28.967399999999998, "mayw5": 31.864140000000134, "junew1": 35.05055400000015, "junew2": 38.55560939999987, "junew3": 22.534000000000106, "junew4": 22.534000000000106, "julyw1": 24.787399999999934, "julyw2": 21.128000000000156, "julyw3": 21.906999999999925, "julyw4": 24.09770000000003, "augw1": 26.507470000000012, "augw2": 22.020999999999958, "augw3": 37.08800000000019, "augw4": 33.37920000000008, "augw5": 30.041280000000143, "sepw1": 27.037152000000106, "sepw2": 24.333436800000072, "sepw3": 21.900093120000065, "sepw4": 21.681092188799994, "octw1": 21.464281266909893, "octw2": 21.249638454240085, "octw3": 21.03714206969994, "octw4": 20.826770649000082, "novw1": 20.618502942510077, "novw2": 20.41231791307996, "novw3": 20.208194733958067, "novw4": 20.006112786616995, "novw5": 19.806051658751926, "decw1": 19.607991142163996, "decw2": 970.595561537124, "decw3": 960.889605921753, "decw4": 951.280709862535, "ttlJanuary": 81.0159999999999, "ttlFebrurary": 80.9590000000002, "ttlMarch": 1149.2310739999998, "ttlApril": 2770.307635, "ttlMay": 100.6544000000001, "ttlJune": 150.5383034000001, "ttlJuly": 91.9201, "ttlAugust": 118.9956700000003, "ttlSeptember": 124.99305410880001, "ttlOctober": 84.57783243985, "ttlNovember": 81.2451283761651, "ttlDecember": 2922.179920122325, "q1": 1311.206074, "q2": 3021.5003384, "q3": 335.9088241088, "q4": 3088.0028809383402, "h1": 4332.7064124, "h2": 3423.9117050471395, "ty": 7756.61811744714 }, { "columnValue": "Sell-Through Variance", "secondValue": "FB Consensus Fcst to Actual (ST Var)", "janw1": 53.60599999999988, "janw2": 54.537000000000035, "janw3": 46.549999999999955, "janw4": 54.24299999999994, "febw1": 38.367000000000075, "febw2": 53.017999999999915, "febw3": 43.462999999999965, "febw4": 73.94100000000003, "marchw1": 61.544000000000096, "marchw2": 67.69839999999999, "marchw3": 74.46824000000015, "marchw4": 81.9150639999998, "marchw5": 1096.82825, "aprilw1": 871.06445, "aprilw2": 980.86485, "aprilw3": 1078.951335, "aprilw4": 58.750999999999976, "mayw1": 55.222999999999956, "mayw2": 61.74000000000001, "mayw3": 67.91399999999999, "mayw4": 74.70540000000005, "mayw5": 82.17594000000008, "junew1": 90.39353400000005, "junew2": 99.43288740000003, "junew3": 58.11400000000003, "junew4": 58.11400000000003, "julyw1": 63.92540000000008, "julyw2": 54.488000000000056, "julyw3": 56.49700000000007, "julyw4": 62.14670000000001, "augw1": 68.36137000000008, "augw2": 56.79099999999994, "augw3": 95.64800000000014, "augw4": 86.08320000000003, "augw5": 77.47487999999998, "sepw1": 69.72739200000001, "sepw2": 62.75465280000003, "sepw3": 56.479187520000096, "sepw4": 55.91439564480015, "octw1": 55.35525168834988, "octw2": 54.80169917147009, "octw3": 54.25368217976006, "octw4": 53.71114535796005, "novw1": 53.174033904369935, "novw2": 52.642293565329965, "novw3": 52.11587062967806, "novw4": 51.59471192338697, "novw5": 51.078764804149955, "decw1": 50.567977156107986, "decw2": 1001.24594769093, "decw3": 991.233488214019, "decw4": 981.321153331879, "ttlJanuary": 208.93599999999992, "ttlFebrurary": 208.78900000000002, "ttlMarch": 1382.453954, "ttlApril": 2989.631635, "ttlMay": 259.5824000000001, "ttlJune": 388.2303614, "ttlJuly": 237.05710000000002, "ttlAugust": 306.88356999999996, "ttlSeptember": 322.3505079648002, "ttlOctober": 218.1217783975401, "ttlNovember": 209.526910022765, "ttlDecember": 3075.447331197089, "q1": 1800.178954, "q2": 3637.4443964, "q3": 866.2911779648, "q4": 3503.0960196173896, "h1": 5437.6233504, "h2": 4369.38719758219, "ty": 9807.01054798219 }, { "columnValue": "Quest 128GB" }, { "columnValue": "Sell-Through Accuracy", "secondValue": "Sell-Through Accuracy" }, { "columnValue": "Sell-Through Accuracy", "secondValue": "Algo Fcst vs. Act. (ST Acc)", "janw1": 1.0781822537539987, "janw2": 0.98, "janw3": 1.0647984623212166, "janw4": 0.98, "febw1": 0.9800000000000001, "febw2": 1.1785423024156643, "febw3": 0.9800000000000001, "febw4": 0.9800000000000001, "marchw1": 1.1510372382275071, "marchw2": 0.9800000000000001, "marchw3": 0.98, "marchw4": 1.108502808585655, "marchw5": 0.9800000000000002, "aprilw1": 1.0835780466537275, "aprilw2": 0.98, "aprilw3": 0.9799999999999998, "aprilw4": 1.0695841414569427, "mayw1": 0.9799999999999999, "mayw2": 0.98, "mayw3": 1.018748696106376, "mayw4": 0.98, "mayw5": 0.9799999999999999, "junew1": 0.9799999999999998, "junew2": 1.0858635232740275, "junew3": 0.98, "junew4": 1.0705660924172633, "julyw1": 0.9800000000000001, "julyw2": 0.9800000000000001, "julyw3": 1.2594745505816332, "julyw4": 0.9799999999999999, "augw1": 0.9799999999999996, "augw2": 1.4433795755257737, "augw3": 0.9800000000000001, "augw4": 0.98, "augw5": 1.115867468132557, "sepw1": 0.98, "sepw2": 1.0638688074892328, "sepw3": 0.9800000000000001, "sepw4": 0.9800000000000038, "octw1": 1.0275398244449125, "octw2": 0.9799999999999971, "octw3": 0.9800000000000043, "octw4": 1.0289950257033356, "novw1": 0.98, "novw2": 0.98, "novw3": 0.9800000000000001, "novw4": 1.2043191943335791, "novw5": 0.9800000000000003, "decw1": 1.2088737826074674 }, { "columnValue": "Sell-Through Accuracy", "secondValue": "Customer Fcst vs. Act. (ST Acc)", "janw1": 1.0741138560687433, "janw2": 1.0741138560687433, "janw3": 1.0741138560687433, "janw4": 1.0741138560687433, "febw1": 1.0741138560687433, "febw2": 1.0741138560687433, "febw3": 1.0741138560687433, "febw4": 1.0741138560687433, "marchw1": 1.0741138560687435, "marchw2": 1.0741138560687435, "marchw3": 1.0741138560687435, "marchw4": 1.0741138560687433, "marchw5": 2.4033953983936795, "aprilw1": 1.9410525942908505, "aprilw2": 2.024528801706182, "aprilw3": 2.024528801706182, "aprilw4": 1.0741138560687433, "mayw1": 1.074113856068743, "mayw2": 1.0741138560687433, "mayw3": 1.0741138560687433, "mayw4": 1.0741138560687433, "mayw5": 1.0741138560687433, "junew1": 1.0741138560687433, "junew2": 1.0741138560687433, "junew3": 1.0741138560687433, "junew4": 1.0741138560687433, "julyw1": 1.0741138560687435, "julyw2": 1.0741138560687433, "julyw3": 1.0741138560687433, "julyw4": 1.0741138560687433, "augw1": 1.0741138560687433, "augw2": 1.0741138560687433, "augw3": 1.0741138560687433, "augw4": 1.0741138560687433, "augw5": 1.0741138560687433, "sepw1": 1.0741138560687433, "sepw2": 1.0741138560687433, "sepw3": 1.0741138560687433, "sepw4": 1.0741138560687435, "octw1": 1.0741138560687435, "octw2": 1.0741138560687438, "octw3": 1.0741138560687438, "octw4": 1.0741138560687438, "novw1": 1.0741138560687438, "novw2": 1.074113856068744, "novw3": 1.074113856068744, "novw4": 1.074113856068744, "novw5": 1.074113856068744, "decw1": 1.0741138560687442 }, { "columnValue": "Sell-Through Accuracy", "secondValue": "FB Channel Ops Fcst vs. Act. (ST Acc)", "janw1": 1.7186803519637435, "janw2": 1.627673341999589, "janw3": 2.0534795635705807, "janw4": 1.7622453345908327, "febw1": 3.906317517932763, "febw2": 1.737741501893101, "febw3": 2.042390563298244, "febw4": 1.2927803746799547, "marchw1": 1.442357029972566, "marchw2": 1.4423570299725659, "marchw3": 1.442357029972566, "marchw4": 1.442357029972566, "marchw5": 2.1630558585543116, "aprilw1": 1.7469473348617657, "aprilw2": 1.822075921535564, "aprilw3": 1.8220759215355637, "aprilw4": 0.9667024704618691, "mayw1": 0.966702470461869, "mayw2": 0.966702470461869, "mayw3": 0.9667024704618691, "mayw4": 0.966702470461869, "mayw5": 0.966702470461869, "junew1": 0.966702470461869, "junew2": 0.966702470461869, "junew3": 0.9667024704618691, "junew4": 0.9667024704618691, "julyw1": 0.9667024704618691, "julyw2": 0.9667024704618691, "julyw3": 0.966702470461869, "julyw4": 0.966702470461869, "augw1": 0.966702470461869, "augw2": 0.9667024704618691, "augw3": 0.966702470461869, "augw4": 1.0204081632653061, "augw5": 1.077097505668934, "sepw1": 1.1369362559838747, "sepw2": 1.200099381316312, "sepw3": 1.2667715691672181, "sepw4": 1.2667715691672181, "octw1": 1.2667715691672181, "octw2": 1.2667715691672183, "octw3": 1.2667715691672183, "octw4": 1.2667715691672183, "novw1": 1.2667715691672183, "novw2": 1.2667715691672183, "novw3": 1.2667715691672183, "novw4": 1.2667715691672181, "novw5": 1.2667715691672183, "decw1": 1.2667715691672181 }, { "columnValue": "Sell-Through Accuracy", "secondValue": "FB UDP vs Act. (ST Acc)", "janw1": 1.063372717508056, "janw2": 1.063372717508056, "janw3": 1.063372717508056, "janw4": 1.063372717508056, "febw1": 1.063372717508056, "febw2": 1.063372717508056, "febw3": 1.063372717508056, "febw4": 1.063372717508056, "marchw1": 1.0633727175080563, "marchw2": 1.0633727175080563, "marchw3": 1.0633727175080563, "marchw4": 1.0633727175080563, "marchw5": 2.379361444409743, "aprilw1": 1.9216420683479423, "aprilw2": 2.0042835136891206, "aprilw3": 2.00428351368912, "aprilw4": 1.063372717508056, "mayw1": 1.063372717508056, "mayw2": 1.063372717508056, "mayw3": 1.0633727175080558, "mayw4": 1.0633727175080558, "mayw5": 1.0633727175080558, "junew1": 1.0633727175080558, "junew2": 1.063372717508056, "junew3": 1.063372717508056, "junew4": 1.063372717508056, "julyw1": 1.063372717508056, "julyw2": 1.063372717508056, "julyw3": 1.063372717508056, "julyw4": 1.063372717508056, "augw1": 1.063372717508056, "augw2": 1.063372717508056, "augw3": 1.0633727175080558, "augw4": 1.0633727175080558, "augw5": 1.0633727175080558, "sepw1": 1.0633727175080558, "sepw2": 1.0633727175080558, "sepw3": 1.0633727175080558, "sepw4": 1.063372717508056, "octw1": 1.063372717508056, "octw2": 1.0633727175080563, "octw3": 1.0633727175080563, "octw4": 1.0633727175080563, "novw1": 1.0633727175080565, "novw2": 1.0633727175080565, "novw3": 1.0633727175080565, "novw4": 1.0633727175080567, "novw5": 1.0633727175080567, "decw1": 1.0633727175080567 }, { "columnValue": "Sell-Through Accuracy", "secondValue": "FB ODP vs. Act. (ST Acc)", "janw1": 1.0204081632653061, "janw2": 1.0204081632653061, "janw3": 1.0204081632653061, "janw4": 1.020408163265306, "febw1": 1.0204081632653061, "febw2": 1.0204081632653061, "febw3": 1.0204081632653061, "febw4": 1.0204081632653061, "marchw1": 1.0204081632653064, "marchw2": 1.0204081632653064, "marchw3": 1.0204081632653064, "marchw4": 1.0204081632653064, "marchw5": 2.283225628473996, "aprilw1": 1.8439999645763079, "aprilw2": 1.9233023616208729, "aprilw3": 1.9233023616208726, "aprilw4": 1.0204081632653061, "mayw1": 1.020408163265306, "mayw2": 1.0204081632653061, "mayw3": 1.0204081632653061, "mayw4": 1.0204081632653061, "mayw5": 1.0204081632653061, "junew1": 1.0204081632653061, "junew2": 1.0204081632653064, "junew3": 1.0204081632653061, "junew4": 1.0204081632653061, "julyw1": 1.0204081632653064, "julyw2": 1.0204081632653061, "julyw3": 1.0204081632653061, "julyw4": 1.020408163265306, "augw1": 1.020408163265306, "augw2": 1.0204081632653061, "augw3": 1.0204081632653061, "augw4": 1.0204081632653061, "augw5": 1.0204081632653061, "sepw1": 1.020408163265306, "sepw2": 1.0204081632653061, "sepw3": 1.0204081632653061, "sepw4": 1.0204081632653064, "octw1": 1.0204081632653064, "octw2": 1.0204081632653064, "octw3": 1.0204081632653064, "octw4": 1.0204081632653061, "novw1": 1.0204081632653064, "novw2": 1.0204081632653064, "novw3": 1.0204081632653064, "novw4": 1.0204081632653064, "novw5": 1.0204081632653064, "decw1": 1.0204081632653064 }, { "columnValue": "Sell-Through Accuracy", "secondValue": "FB Consensus vs. Act. (ST Acc)", "janw1": 1.0526315789473684, "janw2": 1.0526315789473684, "janw3": 1.0526315789473686, "janw4": 1.0526315789473684, "febw1": 1.0526315789473686, "febw2": 1.0526315789473684, "febw3": 1.0526315789473686, "febw4": 1.0526315789473684, "marchw1": 1.0526315789473686, "marchw2": 1.0526315789473686, "marchw3": 1.0526315789473686, "marchw4": 1.0526315789473686, "marchw5": 2.3553274904258057, "aprilw1": 1.9022315424050336, "aprilw2": 1.9840382256720583, "aprilw3": 1.9840382256720581, "aprilw4": 1.0526315789473684, "mayw1": 1.0526315789473684, "mayw2": 1.0526315789473684, "mayw3": 1.0526315789473684, "mayw4": 1.0526315789473684, "mayw5": 1.0526315789473684, "junew1": 1.0526315789473684, "junew2": 1.0526315789473686, "junew3": 1.0526315789473684, "junew4": 1.0526315789473684, "julyw1": 1.0526315789473686, "julyw2": 1.0526315789473686, "julyw3": 1.0526315789473686, "julyw4": 1.0526315789473684, "augw1": 1.0526315789473684, "augw2": 1.0526315789473684, "augw3": 1.0526315789473686, "augw4": 1.0526315789473684, "augw5": 1.0526315789473684, "sepw1": 1.0526315789473684, "sepw2": 1.0526315789473684, "sepw3": 1.0526315789473684, "sepw4": 1.0526315789473684, "octw1": 1.0526315789473684, "octw2": 1.0526315789473684, "octw3": 1.0526315789473684, "octw4": 1.0526315789473684, "novw1": 1.0526315789473684, "novw2": 1.0526315789473684, "novw3": 1.0526315789473686, "novw4": 1.0526315789473686, "novw5": 1.0526315789473686, "decw1": 1.0526315789473686 }, { "columnValue": "Quest 128GB" }, { "columnValue": "Sell In", "secondValue": "Sell In" }, { "columnValue": "Sell In", "secondValue": "Algo Total Fcst (SI)", "janw1": 1197.772464, "janw2": 1218.5747279999998, "janw3": 1040.1132, "janw4": 1212.005592, "febw1": 1199.88553608, "febw2": 1184.6341919999998, "febw3": 1172.7878500799998, "febw4": 1652.1377039999998, "marchw1": 1375.1391359999998, "marchw2": 1361.3877446399997, "marchw3": 1347.7738671935997, "marchw4": 1334.2961285216636, "marchw5": 1320.953167236447, "aprilw1": 1307.7436355640825, "aprilw2": 1294.6661992084416, "aprilw3": 1001.7932399999999, "aprilw4": 1312.732344, "mayw1": 1233.9027119999998, "mayw2": 1379.5185599999998, "mayw3": 1365.7233743999998, "mayw4": 1407.9848159999997, "mayw5": 1393.9049678399997, "junew1": 1379.9659181615998, "junew2": 1053.251472, "junew3": 1298.499216, "junew4": 1298.499216, "julyw1": 1285.5142238399999, "julyw2": 1217.479872, "julyw3": 1262.368968, "julyw4": 1249.74527832, "augw1": 1237.2478255367998, "augw2": 1268.9381039999998, "augw3": 1256.24872296, "augw4": 1243.6862357303999, "augw5": 1029.16464, "sepw1": 1064.2000319999997, "sepw2": 1031.3543519999998, "sepw3": 991.939536, "sepw4": 1167.1164959999999, "octw1": 935.0070239999999, "octw2": 925.6569537599999, "octw3": 916.4003842223998, "octw4": 907.2363803801758, "novw1": 898.164016576374, "novw2": 889.1823764106102, "novw3": 880.2905526465041, "novw4": 871.4876471200391, "novw5": 862.7727706488387, "decw1": 854.1450429423503, "decw2": 935.0070239999999, "decw3": 925.6569537599999, "decw4": 916.4003842223998, "ttlJanuary": 4668.465984, "ttlFebrurary": 5209.44528216, "ttlMarch": 6739.55004359171, "ttlApril": 4916.93541877252, "ttlMay": 5387.1294624, "ttlJune": 6424.1207900016, "ttlJuly": 5015.10834216, "ttlAugust": 5006.1208882272, "ttlSeptember": 5283.775056, "ttlOctober": 3684.300742362576, "ttlNovember": 3539.124592753529, "ttlDecember": 4493.98217557359, "q1": 16617.46130975171, "q2": 16728.1856711741, "q3": 15305.0042863872, "q4": 11717.4075106897, "h1": 33345.6469809258, "h2": 27022.4117970769, "ty": 60368.0587780027 }, { "columnValue": "Sell In", "secondValue": "Customer Fcst (SI)", "janw1": 1161.1059599999999, "janw2": 1181.2714199999998, "janw3": 1008.2729999999999, "janw4": 1174.90338, "febw1": 1163.1543462, "febw2": 1148.3698799999997, "febw3": 1136.8861811999998, "febw4": 1601.5620599999997, "marchw1": 1333.0430399999996, "marchw2": 1319.7126095999995, "marchw3": 1306.5154835039996, "marchw4": 1293.4503286689596, "marchw5": 1280.5158253822701, "aprilw1": 1267.7106671284473, "aprilw2": 1255.0335604571628, "aprilw3": 971.1260999999998, "aprilw4": 1272.54666, "mayw1": 1196.1301799999999, "mayw2": 1337.2883999999997, "mayw3": 1323.9155159999996, "mayw4": 1364.8832399999997, "mayw5": 1351.2344075999997, "junew1": 1337.7220635239996, "junew2": 1021.0090799999999, "junew3": 1258.7492399999999, "junew4": 1258.7492399999999, "julyw1": 1246.1617476, "julyw2": 1180.2100799999998, "julyw3": 1223.7250199999999, "julyw4": 1211.4877697999998, "augw1": 1199.3728921019997, "augw2": 1230.0930599999997, "augw3": 1217.7921293999998, "augw4": 1205.6142081059998, "augw5": 997.6595999999998, "sepw1": 1031.6224799999998, "sepw2": 999.7822799999999, "sepw3": 961.5740399999999, "sepw4": 1131.38844, "octw1": 906.3843599999998, "octw2": 897.3205163999997, "octw3": 888.3473112359998, "octw4": 879.4638381236398, "novw1": 870.6691997424034, "novw2": 861.9625077449793, "novw3": 853.3428826675296, "novw4": 844.8094538408543, "novw5": 836.3613593024457, "decw1": 827.9977457094213, "decw2": 906.3843599999998, "decw3": 897.3205163999997, "decw4": 888.3473112359998, "ttlJanuary": 4525.55376, "ttlFebrurary": 5049.9724674, "ttlMarch": 6533.23728715523, "ttlApril": 4766.41698758561, "ttlMay": 5222.217336, "ttlJune": 6227.464031124, "ttlJuly": 4861.5846174, "ttlAugust": 4852.872289608, "ttlSeptember": 5122.0268399999995, "ttlOctober": 3571.51602575964, "ttlNovember": 3430.784043995764, "ttlDecember": 4356.41129264787, "q1": 16108.76351455523, "q2": 16216.09835470961, "q3": 14836.483747008, "q4": 11358.71136240327, "h1": 32324.8618692648, "h2": 26195.195109411303, "ty": 58520.056978676104 }, { "columnValue": "Sell In", "secondValue": "FB Channel Ops Unstrained Fcst (SI)", "janw1": 1283.32764, "janw2": 1305.6157799999999, "janw3": 1114.407, "janw4": 1298.5774199999998, "febw1": 1285.5916458, "febw2": 1269.25092, "febw3": 1256.5584108, "febw4": 1770.14754, "marchw1": 1473.3633599999998, "marchw2": 1458.6297263999998, "marchw3": 1444.0434291359998, "marchw4": 1429.6029948446399, "marchw5": 1415.3069648961934, "aprilw1": 1401.1538952472315, "aprilw2": 1387.142356294759, "aprilw3": 1073.3499, "aprilw4": 1406.49894, "mayw1": 1322.03862, "mayw2": 1478.0556, "mayw3": 1463.275044, "mayw4": 1508.55516, "mayw5": 1493.4696084, "junew1": 1478.534912316, "junew2": 1128.48372, "junew3": 1391.24916, "junew4": 1391.24916, "julyw1": 1377.3366684, "julyw2": 1304.44272, "julyw3": 1352.53818, "julyw4": 1339.0127982, "augw1": 1325.622670218, "augw2": 1359.57654, "augw3": 1345.9807746, "augw4": 1332.5209668539999, "augw5": 1102.6763999999998, "sepw1": 1140.2143199999998, "sepw2": 1105.02252, "sepw3": 1062.79236, "sepw4": 1250.4819599999998, "octw1": 1001.79324, "octw2": 991.7753075999999, "octw3": 981.8575545239999, "octw4": 972.0389789787598, "novw1": 962.3185891889722, "novw2": 952.6954032970824, "novw3": 943.1684492641116, "novw4": 933.7367647714705, "novw5": 924.3993971237558, "decw1": 915.1554031525181, "decw2": 1001.79324, "decw3": 991.7753075999999, "decw4": 981.8575545239999, "ttlJanuary": 5001.92784, "ttlFebrurary": 5581.5485166, "ttlMarch": 7220.94647527683, "ttlApril": 5268.14509154199, "ttlMay": 5771.924424, "ttlJune": 6882.986560716, "ttlJuly": 5373.330366599999, "ttlAugust": 5363.700951672, "ttlSeptember": 5661.18756, "ttlOctober": 3947.46508110276, "ttlNovember": 3791.9192065216407, "ttlDecember": 4814.98090240027, "q1": 17804.42283187683, "q2": 17923.056076258, "q3": 16398.218878272, "q4": 12554.36519002467, "h1": 35727.4789081348, "h2": 28952.584068296703, "ty": 64680.062976431494 }, { "columnValue": "Sell In", "secondValue": "FB Channel Ops Constrained Fcst (SI)", "janw1": 1344.43848, "janw2": 1367.7879599999999, "janw3": 1167.474, "janw4": 1360.41444, "febw1": 1346.8102956, "febw2": 1329.6914399999998, "febw3": 1316.3945255999997, "febw4": 1854.44028, "marchw1": 1543.5235199999997, "marchw2": 1528.0882847999997, "marchw3": 1512.8074019519997, "marchw4": 1497.6793279324797, "marchw5": 1482.702534653155, "aprilw1": 1467.8755093066234, "aprilw2": 1453.1967542135571, "aprilw3": 1124.4617999999998, "aprilw4": 1473.4750800000002, "mayw1": 1384.9928400000001, "mayw2": 1548.4391999999998, "mayw3": 1532.9548079999997, "mayw4": 1580.3911199999998, "mayw5": 1564.5872087999999, "junew1": 1548.9413367119998, "junew2": 1182.2210400000001, "junew3": 1457.4991200000002, "junew4": 1457.4991200000002, "julyw1": 1442.9241288, "julyw2": 1366.55904, "julyw3": 1416.94476, "julyw4": 1402.7753124, "augw1": 1388.7475592760002, "augw2": 1424.31828, "augw3": 1410.0750971999998, "augw4": 1395.9743462279998, "augw5": 1155.1848, "sepw1": 1194.5102399999998, "sepw2": 1157.64264, "sepw3": 1113.4015200000001, "sepw4": 1310.02872, "octw1": 1049.49768, "octw2": 1039.0027032, "octw3": 1028.612676168, "octw4": 1018.3265494063199, "novw1": 1008.1432839122567, "novw2": 998.0618510731341, "novw3": 988.0812325624028, "novw4": 978.2004202367788, "novw5": 968.4184160344109, "decw1": 958.7342318740668, "decw2": 1049.49768, "decw3": 1039.0027032, "decw4": 1028.612676168, "ttlJanuary": 5240.11488, "ttlFebrurary": 5847.3365412, "ttlMarch": 7564.80106933764, "ttlApril": 5519.00914352018, "ttlMay": 6046.777968, "ttlJune": 7210.747825512, "ttlJuly": 5629.2032412, "ttlAugust": 5619.1152827040005, "ttlSeptember": 5930.76792, "ttlOctober": 4135.43960877432, "ttlNovember": 3972.486787784569, "ttlDecember": 5044.26570727648, "q1": 18652.25249053764, "q2": 18776.5349370322, "q3": 17179.086443904, "q4": 13152.192103835368, "h1": 37428.7874275698, "h2": 30331.2785477394, "ty": 67760.0659753092 }, { "columnValue": "Sell In", "secondValue": "Actual (SI)", "janw1": 1222.2168, "janw2": 1243.4435999999998, "janw3": 1061.34, "janw4": 1236.7404, "febw1": 1224.3729959999998, "febw2": 1208.8103999999998, "febw3": 1196.722296, "febw4": 1685.8547999999998, "marchw1": 1403.2031999999997, "marchw2": 1389.1711679999996, "marchw3": 1375.2794563199996, "marchw4": 1361.5266617567995, "marchw5": 1347.9113951392314, "aprilw1": 1334.4322811878392, "aprilw2": 1321.0879583759609, "aprilw3": 1022.2379999999998, "aprilw4": 1339.5228, "mayw1": 1259.0844, "mayw2": 1407.6719999999998, "mayw3": 1393.5952799999998, "mayw4": 1436.7191999999998, "mayw5": 1422.3520079999998, "junew1": 1408.1284879199998, "junew2": 1074.7464, "junew3": 1324.9992, "junew4": 1324.9992, "julyw1": 1311.749208, "julyw2": 1242.3264, "julyw3": 1288.1316, "julyw4": 1275.250284, "augw1": 1262.49778116, "augw2": 1294.8347999999999, "augw3": 1281.8864519999997, "augw4": 1269.0675874799997, "augw5": 1050.168, "sepw1": 1085.9183999999998, "sepw2": 1052.4024, "sepw3": 1012.1831999999999, "sepw4": 1190.9352, "octw1": 954.0887999999999, "octw2": 944.5479119999999, "octw3": 935.1024328799999, "octw4": 925.7514085511999, "novw1": 916.493894465688, "novw2": 907.328955521031, "novw3": 898.2556659658208, "novw4": 889.2731093061625, "novw5": 880.3803782131008, "decw1": 871.5765744309698, "ttlJanuary": 4763.7408, "ttlFebrurary": 5315.760491999999, "ttlMarch": 6877.09188121603, "ttlApril": 5017.2810395638, "ttlMay": 5497.07088, "ttlJune": 6555.2252959200005, "ttlJuly": 5117.457492, "ttlAugust": 5108.2866206399995, "ttlSeptember": 5391.6071999999995, "ttlOctober": 3759.4905534312, "ttlNovember": 3611.351625258703, "ttlDecember": 1751.95695264407, "q1": 16956.59317321603, "q2": 17069.577215483798, "q3": 15617.351312640001, "q4": 9122.79913133397, "h1": 34026.1703886998, "h2": 24740.15044397397, "ty": 58766.320832673795 }, { "columnValue": "Quest 128GB", "secondValue": "Comments:", "janw1": "Online ad", "janw3": "Email ad", "febw2": "Print ad", "marchw1": "Price drop", "marchw4": "Online ad", "aprilw1": "Email ad", "aprilw4": "Print ad", "mayw3": "Price drop", "junew2": "Online ad", "junew4": "Email ad", "julyw3": "Print ad", "augw2": "Price drop", "augw5": "Online ad", "sepw2": "Email ad", "octw1": "Print ad", "octw4": "Price drop", "novw4": "Online ad", "decw1": "Email ad", "decw4": "Print ad" }, { "columnValue": "Quest 128GB" }, { "columnValue": "Sell In Inventory", "secondValue": "Sell In Inventory" }, { "columnValue": "Sell In Inventory", "secondValue": "FB Available Allocation", "janw1": 10000, "janw2": 9800, "janw3": 9604, "janw4": 9411.92, "febw1": 9223.6816, "febw2": 9039.207968, "febw3": 8858.42380864, "febw4": 10000, "marchw1": 9800, "marchw2": 9604, "marchw3": 9411.92, "marchw4": 9223.6816, "marchw5": 9039.207968, "aprilw1": 8858.42380864, "aprilw2": 10000, "aprilw3": 9800, "aprilw4": 9604, "mayw1": 9411.92, "mayw2": 9223.6816, "mayw3": 9039.207968, "mayw4": 8858.42380864, "mayw5": 10000, "junew1": 9800, "junew2": 9604, "junew3": 9411.92, "junew4": 9223.6816, "julyw1": 9039.207968, "julyw2": 8858.42380864, "julyw3": 10000, "julyw4": 9800, "augw1": 9604, "augw2": 9411.92, "augw3": 9223.6816, "augw4": 9039.207968, "augw5": 8858.42380864, "sepw1": 10000, "sepw2": 9800, "sepw3": 9604, "sepw4": 9411.92, "octw1": 9223.6816, "octw2": 9039.207968, "octw3": 8858.42380864, "octw4": 10000, "novw1": 9800, "novw2": 9604, "novw3": 9411.92, "novw4": 9223.6816, "novw5": 9039.207968, "decw1": 8858.42380864, "decw2": 8681.2553324672, "decw3": 8507.630225817857, "decw4": 8337.4776213015, "ttlJanuary": 38815.92, "ttlFebrurary": 37121.31337664, "ttlMarch": 47078.809568000004, "ttlApril": 38262.42380864, "ttlMay": 36533.23337664, "ttlJune": 48039.601599999995, "ttlJuly": 37697.63177664, "ttlAugust": 37278.809568000004, "ttlSeptember": 47674.34380864, "ttlOctober": 37121.31337664, "ttlNovember": 38039.601599999995, "ttlDecember": 43423.9949562266, "q1": 123016.04294464, "q2": 122835.25878527999, "q3": 122650.78515328, "q4": 118584.9099328666, "h1": 245851.30172992, "h2": 241235.695086147, "ty": 487086.996816067 }, { "columnValue": "Sell In Inventory", "secondValue": "On-Order", "janw1": 532, "janw2": 521.36, "janw3": 510.9328, "janw4": 500.714144, "febw1": 490.69986112, "febw2": 480.88586389759996, "febw3": 471.26814661964795, "febw4": 532, "marchw1": 521.36, "marchw2": 510.9328, "marchw3": 500.714144, "marchw4": 490.69986112, "marchw5": 480.88586389759996, "aprilw1": 471.26814661964795, "aprilw2": 532, "aprilw3": 521.36, "aprilw4": 510.9328, "mayw1": 500.714144, "mayw2": 490.69986112, "mayw3": 480.88586389759996, "mayw4": 471.26814661964795, "mayw5": 532, "junew1": 521.36, "junew2": 510.9328, "junew3": 500.714144, "junew4": 490.69986112, "julyw1": 480.88586389759996, "julyw2": 471.26814661964795, "julyw3": 532, "julyw4": 521.36, "augw1": 510.9328, "augw2": 500.714144, "augw3": 490.69986112, "augw4": 480.88586389759996, "augw5": 471.26814661964795, "sepw1": 532, "sepw2": 521.36, "sepw3": 510.9328, "sepw4": 500.714144, "octw1": 490.69986112, "octw2": 480.88586389759996, "octw3": 471.26814661964795, "octw4": 532, "novw1": 521.36, "novw2": 510.9328, "novw3": 500.714144, "novw4": 490.69986112, "novw5": 480.88586389759996, "decw1": 471.26814661964795, "decw2": 461.842783687255, "decw3": 452.6059280135099, "decw4": 443.5538094532397, "ttlJanuary": 2065.0069439999997, "ttlFebrurary": 1974.85387163725, "ttlMarch": 2504.5926690175997, "ttlApril": 2035.56094661965, "ttlMay": 1943.568015637248, "ttlJune": 2555.7068051200004, "ttlJuly": 2005.51401051725, "ttlAugust": 1983.2326690176, "ttlSeptember": 2536.2750906196497, "ttlOctober": 1974.85387163725, "ttlNovember": 2023.70680512, "ttlDecember": 2310.15653167125, "q1": 6544.45348465485, "q2": 6534.835767376901, "q3": 6525.021770154501, "q4": 6308.717208428499, "h1": 13079.289252031751, "h2": 12833.738978583, "ty": 25913.0282306148 }, { "columnValue": "Sell In Inventory", "secondValue": "Backlog (in-transit)", "janw1": 123, "janw2": 120.53999999999999, "janw3": 118.12919999999998, "janw4": 115.76661599999998, "febw1": 113.45128367999999, "febw2": 111.18225800639999, "febw3": 108.95861284627199, "febw4": 123, "marchw1": 120.53999999999999, "marchw2": 118.12919999999998, "marchw3": 115.76661599999998, "marchw4": 113.45128367999999, "marchw5": 111.18225800639999, "aprilw1": 108.95861284627199, "aprilw2": 123, "aprilw3": 120.53999999999999, "aprilw4": 118.12919999999998, "mayw1": 115.76661599999998, "mayw2": 113.45128367999999, "mayw3": 111.18225800639999, "mayw4": 108.95861284627199, "mayw5": 123, "junew1": 120.53999999999999, "junew2": 118.12919999999998, "junew3": 115.76661599999998, "junew4": 113.45128367999999, "julyw1": 111.18225800639999, "julyw2": 108.95861284627199, "julyw3": 123, "julyw4": 120.53999999999999, "augw1": 118.12919999999998, "augw2": 115.76661599999998, "augw3": 113.45128367999999, "augw4": 111.18225800639999, "augw5": 108.95861284627199, "sepw1": 123, "sepw2": 120.53999999999999, "sepw3": 118.12919999999998, "sepw4": 115.76661599999998, "octw1": 113.45128367999999, "octw2": 111.18225800639999, "octw3": 108.95861284627199, "octw4": 123, "novw1": 120.53999999999999, "novw2": 118.12919999999998, "novw3": 115.76661599999998, "novw4": 113.45128367999999, "novw5": 111.18225800639999, "decw1": 108.95861284627199, "decw2": 106.77944058934655, "decw3": 104.64385177755962, "decw4": 102.55097474200842, "ttlJanuary": 477.435816, "ttlFebrurary": 456.592154532672, "ttlMarch": 579.0693576864, "ttlApril": 470.62781284627204, "ttlMay": 449.358770532672, "ttlJune": 590.88709968, "ttlJuly": 463.680870852672, "ttlAugust": 458.5293576864, "ttlSeptember": 586.3944288462719, "ttlOctober": 456.592154532672, "ttlNovember": 467.88709968, "ttlDecember": 534.115137961586, "q1": 1513.097328219072, "q2": 1510.8736830589442, "q3": 1508.6046573853441, "q4": 1458.5943921742619, "h1": 3023.9710112780103, "h2": 16617.46130975171, "ty": 19641.432321029708 }, { "columnValue": "Sell In Inventory", "secondValue": "Customer Store OH", "janw1": 3430.7839999999997, "janw2": 3490.3680000000004, "janw3": 2979.2000000000003, "janw4": 3471.5519999999997, "febw1": 2455.4880000000003, "febw2": 3393.152, "febw3": 2781.632, "febw4": 4732.224, "marchw1": 3938.816, "marchw2": 4332.6976, "marchw3": 4765.9673600000015, "marchw4": 5242.564096000002, "marchw5": 6099.52, "aprilw1": 5876.8640000000005, "aprilw2": 6328.448, "aprilw3": 6961.2928, "aprilw4": 3760.0640000000003, "mayw1": 3534.2720000000004, "mayw2": 3951.36, "mayw3": 4346.496, "mayw4": 4781.145600000001, "mayw5": 5259.260160000002, "junew1": 5785.186176000002, "junew2": 6363.704793600003, "junew3": 3719.2960000000003, "junew4": 3719.2960000000003, "julyw1": 4091.2256, "julyw2": 3487.232, "julyw3": 3615.8080000000004, "julyw4": 3977.3888000000006, "augw1": 4375.1276800000005, "augw2": 3634.624, "augw3": 6121.472000000001, "augw4": 5509.3248, "augw5": 4958.39232, "sepw1": 4462.553088, "sepw2": 4016.2977792, "sepw3": 3614.6680012799998, "sepw4": 3578.5213212671997, "octw1": 3542.736108054528, "octw2": 3507.3087469739826, "octw3": 3472.2356595042424, "octw4": 3437.5133029092003, "novw1": 3403.1381698801083, "novw2": 3369.106788181307, "novw3": 3335.415720299494, "novw4": 3302.061563096499, "novw5": 3269.040947465534, "decw1": 3236.3505379908784, "decw2": 3203.98703261097, "decw3": 3171.94716228486, "decw4": 3140.227690662012 }, { "columnValue": "Sell In Inventory", "secondValue": "Customer Act. Total DC OH", "janw1": 4288.48, "janw2": 4362.96, "janw3": 3724, "janw4": 4339.44, "febw1": 3069.36, "febw2": 4241.44, "febw3": 3477.04, "febw4": 5915.28, "marchw1": 4923.5199999999995, "marchw2": 5415.872, "marchw3": 5957.459200000001, "marchw4": 6553.205120000001, "marchw5": 7624.4, "aprilw1": 7346.08, "aprilw2": 7910.5599999999995, "aprilw3": 8701.616, "aprilw4": 4700.08, "mayw1": 4417.84, "mayw2": 4939.2, "mayw3": 5433.12, "mayw4": 5976.432000000001, "mayw5": 6574.075200000001, "junew1": 7231.482720000002, "junew2": 7954.630992000003, "junew3": 4649.12, "junew4": 4649.12, "julyw1": 5114.032, "julyw2": 4359.04, "julyw3": 4519.76, "julyw4": 4971.736000000001, "augw1": 5468.909600000001, "augw2": 4543.28, "augw3": 7651.84, "augw4": 6886.656, "augw5": 6197.9904, "sepw1": 5578.19136, "sepw2": 5020.372224, "sepw3": 4518.3350015999995, "sepw4": 4473.151651583999, "octw1": 4428.42013506816, "octw2": 4384.135933717478, "octw3": 4340.294574380303, "octw4": 4296.8916286365, "novw1": 4253.922712350135, "novw2": 4211.383485226634, "novw3": 4169.269650374367, "novw4": 4127.576953870624, "novw5": 4086.3011843319173, "decw1": 4045.438172488598, "decw2": 4004.983790763712, "decw3": 3964.933952856075, "decw4": 3925.2846133275143 }, { "columnValue": "Sell In Inventory", "secondValue": "Customer Target Inventory OH", "janw1": 3829, "janw2": 3895.5, "janw3": 3325, "janw4": 3874.5, "febw1": 2740.5, "febw2": 3787, "febw3": 3104.5, "febw4": 5281.5, "marchw1": 4396, "marchw2": 4835.6, "marchw3": 5319.160000000001, "marchw4": 5851.076000000001, "marchw5": 6807.5, "aprilw1": 6559, "aprilw2": 7063, "aprilw3": 7769.300000000001, "aprilw4": 4196.5, "mayw1": 3944.5, "mayw2": 4410, "mayw3": 4851, "mayw4": 5336.1, "mayw5": 5869.710000000001, "junew1": 6456.681000000001, "junew2": 7102.349100000001, "junew3": 4151, "junew4": 4151, "julyw1": 4566.1, "julyw2": 3892, "julyw3": 4035.5, "julyw4": 4439.050000000001, "augw1": 4882.955000000001, "augw2": 4056.5, "augw3": 6832, "augw4": 6148.8, "augw5": 5533.92, "sepw1": 4980.528, "sepw2": 4482.4752, "sepw3": 4034.2276800000004, "sepw4": 3993.8854032000004, "octw1": 3953.9465491680007, "octw2": 3914.4070836763212, "octw3": 3875.263012839558, "octw4": 3836.5103827111625, "novw1": 3798.145278884051, "novw2": 3760.163826095211, "novw3": 3722.562187834259, "novw4": 3685.3365659559163, "novw5": 3648.483200296357, "decw1": 3611.9983682933935, "decw2": 3575.8783846104598, "decw3": 3540.119600764355, "decw4": 3504.7184047567116 }, { "columnValue": "Sell In Inventory", "secondValue": "Customer TGT Inventory WOS", "janw1": 3.5, "janw2": 3.5, "janw3": 3.5, "janw4": 3.5, "febw1": 3.5, "febw2": 3.5, "febw3": 3.5, "febw4": 3.5, "marchw1": 3.5, "marchw2": 3.5, "marchw3": 3.5, "marchw4": 3.5, "marchw5": 3.5, "aprilw1": 3.5, "aprilw2": 3.5, "aprilw3": 3.5, "aprilw4": 3.5, "mayw1": 3.5, "mayw2": 3.5, "mayw3": 3.5, "mayw4": 3.5, "mayw5": 3.5, "junew1": 3.5, "junew2": 3.5, "junew3": 3.5, "junew4": 3.5, "julyw1": 3.5, "julyw2": 3.5, "julyw3": 3.5, "julyw4": 3.5, "augw1": 3.5, "augw2": 3.5, "augw3": 3.5, "augw4": 3.5, "augw5": 3.5, "sepw1": 3.5, "sepw2": 3.5, "sepw3": 3.5, "sepw4": 3.5, "octw1": 3.5, "octw2": 3.5, "octw3": 3.5, "octw4": 3.5, "novw1": 3.5, "novw2": 3.5, "novw3": 3.5, "novw4": 3.5, "novw5": 3.5, "decw1": 3.5, "decw2": 3.5, "decw3": 3.5, "decw4": 3.5 }, { "columnValue": "Sell In Inventory", "secondValue": "Channel Ops Ideal WOS", "janw1": 4, "janw2": 4, "janw3": 4, "janw4": 4, "febw1": 4, "febw2": 4, "febw3": 4, "febw4": 4, "marchw1": 4, "marchw2": 4, "marchw3": 4, "marchw4": 4, "marchw5": 4, "aprilw1": 4, "aprilw2": 4, "aprilw3": 4, "aprilw4": 4, "mayw1": 4, "mayw2": 4, "mayw3": 4, "mayw4": 4, "mayw5": 4, "junew1": 4, "junew2": 4, "junew3": 4, "junew4": 4, "julyw1": 4, "julyw2": 4, "julyw3": 4, "julyw4": 4, "augw1": 4, "augw2": 4, "augw3": 4, "augw4": 4, "augw5": 4, "sepw1": 4, "sepw2": 4, "sepw3": 4, "sepw4": 4, "octw1": 4, "octw2": 4, "octw3": 4, "octw4": 4, "novw1": 4, "novw2": 4, "novw3": 4, "novw4": 4, "novw5": 4, "decw1": 4, "decw2": 4, "decw3": 4, "decw4": 4 }, { "columnValue": "Sell In Inventory", "secondValue": "Projected WOS", "janw1": 4.2105263157894735, "janw2": 4.2105263157894735, "janw3": 4.210526315789474, "janw4": 4.2105263157894735, "febw1": 4.210526315789474, "febw2": 4.2105263157894735, "febw3": 4.210526315789474, "febw4": 4.2105263157894735, "marchw1": 4.210526315789474, "marchw2": 4.210526315789474, "marchw3": 4.210526315789474, "marchw4": 4.210526315789474, "marchw5": 9.421309961703223, "aprilw1": 7.608926169620134, "aprilw2": 7.936152902688233, "aprilw3": 7.9361529026882325, "aprilw4": 4.2105263157894735, "mayw1": 4.2105263157894735, "mayw2": 4.2105263157894735, "mayw3": 4.2105263157894735, "mayw4": 4.2105263157894735, "mayw5": 4.2105263157894735, "junew1": 4.2105263157894735, "junew2": 4.210526315789474, "junew3": 4.2105263157894735, "junew4": 4.2105263157894735, "julyw1": 4.210526315789474, "julyw2": 4.210526315789474, "julyw3": 4.210526315789474, "julyw4": 4.2105263157894735, "augw1": 4.2105263157894735, "augw2": 4.2105263157894735, "augw3": 4.210526315789474, "augw4": 4.2105263157894735, "augw5": 4.2105263157894735, "sepw1": 4.2105263157894735, "sepw2": 4.2105263157894735, "sepw3": 4.2105263157894735, "sepw4": 4.2105263157894735, "octw1": 4.2105263157894735, "octw2": 4.2105263157894735, "octw3": 4.2105263157894735, "octw4": 4.2105263157894735, "novw1": 4.2105263157894735, "novw2": 4.2105263157894735, "novw3": 4.210526315789474, "novw4": 4.210526315789474, "novw5": 4.210526315789474, "decw1": 4.210526315789474, "decw2": 4, "decw3": 4, "decw4": 4 }, { "columnValue": "Quest 128GB" }, { "columnValue": "Sell In Variance", "secondValue": "Sell In Variance" }, { "columnValue": "Sell In Variance", "secondValue": "Algo Fcst to Override (SI Var)", "janw1": -146.66601600000013, "janw2": -149.21323200000006, "janw3": -127.36079999999993, "janw4": -148.40884800000003, "febw1": -146.92475951999995, "febw2": -145.05724800000007, "febw3": -143.60667551999995, "febw4": -202.30257600000004, "marchw1": -168.38438399999995, "marchw2": -166.70054016000017, "marchw3": -165.03353475840004, "marchw4": -163.38319941082, "marchw5": -161.7493674167099, "aprilw1": -160.13187374253994, "aprilw2": -158.53055500512005, "aprilw3": -122.66856000000007, "aprilw4": -160.74273599999992, "mayw1": -151.09012799999982, "mayw2": -168.92064000000005, "mayw3": -167.23143359999995, "mayw4": -172.4063040000001, "mayw5": -170.68224096000017, "junew1": -168.97541855040004, "junew2": -128.96956799999998, "junew3": -158.99990400000002, "junew4": -158.99990400000002, "julyw1": -157.40990495999995, "julyw2": -149.0791680000002, "julyw3": -154.5757920000001, "julyw4": -153.03003408000018, "augw1": -151.49973373919988, "augw2": -155.3801759999999, "augw3": -153.82637424000018, "augw4": -152.28811049759997, "augw5": -126.02016000000003, "sepw1": -130.3102080000001, "sepw2": -126.28828799999997, "sepw3": -121.46198399999992, "sepw4": -142.91222399999992, "octw1": -114.49065599999994, "octw2": -113.34574944000008, "octw3": -112.21229194559999, "octw4": -111.09016902614405, "novw1": -109.979267335886, "novw2": -108.87947466252399, "novw3": -107.79067991589898, "novw4": -106.71277311673998, "novw5": -105.64564538557204, "decw1": -104.58918893171699, "decw2": -114.49065599999994, "decw3": -113.34574944000008, "decw4": -112.21229194559999, "ttlJanuary": -571.648896, "ttlFebrurary": -637.89125904, "ttlMarch": -825.2510257459301, "ttlApril": -602.07372474766, "ttlMay": -659.6485056, "ttlJune": -786.6270355104, "ttlJuly": -614.09489904, "ttlAugust": -612.9943944768, "ttlSeptember": -646.992864, "ttlOctober": -451.138866411744, "ttlNovember": -433.362195031049, "ttlDecember": -550.283531702889, "q1": -2034.79118078593, "q2": -2048.34926585806, "q3": -1874.0821575168, "q4": -1434.784593145682, "h1": -4083.14044664399, "h2": -3308.8667506624797, "ty": -7392.00719730647 }, { "columnValue": "Sell In Variance", "secondValue": "Algo Fcst to Actual (SI Var)", "janw1": -24.44433600000002, "janw2": -24.86887200000001, "janw3": -21.226799999999912, "janw4": -24.73480799999993, "febw1": -24.487459919999992, "febw2": -24.176208000000088, "febw3": -23.934445919999916, "febw4": -33.71709600000008, "marchw1": -28.064063999999917, "marchw2": -27.783423360000143, "marchw3": -27.505589126400082, "marchw4": -27.23053323514, "marchw5": -26.95822790277998, "aprilw1": -26.688645623760067, "aprilw2": -26.421759167519895, "aprilw3": -20.444760000000088, "aprilw4": -26.79045599999995, "mayw1": -25.181687999999895, "mayw2": -28.153440000000046, "mayw3": -27.87190559999999, "mayw4": -28.73438400000009, "mayw5": -28.447040160000142, "junew1": -28.162569758399968, "junew2": -21.494928000000073, "junew3": -26.49998400000004, "junew4": -26.49998400000004, "julyw1": -26.23498415999984, "julyw2": -24.846528000000035, "julyw3": -25.76263199999994, "julyw4": -25.505005680000068, "augw1": -25.249955623199867, "augw2": -25.89669600000002, "augw3": -25.637729040000067, "augw4": -25.381351749599844, "augw5": -21.00335999999993, "sepw1": -21.718368000000055, "sepw2": -21.04804799999988, "sepw3": -20.24366400000008, "sepw4": -23.818703999999798, "octw1": -19.08177599999999, "octw2": -18.89095824000003, "octw3": -18.702048657600017, "octw4": -18.515028171024028, "novw1": -18.329877889313934, "novw2": -18.146579110421044, "novw3": -17.96511331931697, "novw4": -17.785462186123937, "novw5": -17.607607564262025, "decw1": -17.431531488620067, "decw2": 935.007024, "decw3": 925.65695376, "decw4": 916.4003842224, "ttlJanuary": -95.2748159999998, "ttlFebrurary": -106.3152098400001, "ttlMarch": -137.54183762432, "ttlApril": -100.34562079128011, "ttlMay": -109.94141760000001, "ttlJune": -131.1045059184, "ttlJuly": -102.3491498399999, "ttlAugust": -102.1657324127998, "ttlSeptember": -107.8321439999998, "ttlOctober": -75.189811068624, "ttlNovember": -72.2270325051759, "ttlDecember": 2742.02522292952, "q1": -339.13186346432, "q2": -341.39154430968, "q3": -312.3470262528, "q4": 2594.6083793557164, "h1": -680.523407774, "h2": 2282.26135310292, "ty": 1601.73794532892 }, { "columnValue": "Sell In Variance", "secondValue": "Customer Fcst to Actual (SI Var)", "janw1": -61.110839999999826, "janw2": -62.172180000000026, "janw3": -53.066999999999894, "janw4": -61.83701999999994, "febw1": -61.218649800000094, "febw2": -60.440520000000106, "febw3": -59.836114799999905, "febw4": -84.2927400000001, "marchw1": -70.1601599999999, "marchw2": -69.45855840000013, "marchw3": -68.76397281599998, "marchw4": -68.07633308783988, "marchw5": -67.39556975696019, "aprilw1": -66.72161405939005, "aprilw2": -66.05439791879985, "aprilw3": -51.111900000000105, "aprilw4": -66.97613999999999, "mayw1": -62.95421999999985, "mayw2": -70.38360000000011, "mayw3": -69.67976399999998, "mayw4": -71.83596000000011, "mayw5": -71.11760040000013, "junew1": -70.40642439599992, "junew2": -53.737319999999954, "junew3": -66.24995999999987, "junew4": -66.24995999999987, "julyw1": -65.58746040000005, "julyw2": -62.11631999999986, "julyw3": -64.40657999999985, "julyw4": -63.76251419999994, "augw1": -63.12488905800001, "augw2": -64.74174000000016, "augw3": -64.09432259999994, "augw4": -63.45337937399995, "augw5": -52.50839999999994, "sepw1": -54.295920000000024, "sepw2": -52.62011999999993, "sepw3": -50.60916000000009, "sepw4": -59.54675999999995, "octw1": -47.70443999999998, "octw2": -47.22739560000002, "octw3": -46.75512164400004, "octw4": -46.28757042756001, "novw1": -45.824694723285006, "novw2": -45.36644777605204, "novw3": -44.91278329829095, "novw4": -44.46365546530899, "novw5": -44.01901891065506, "decw1": -43.57882872154903, "decw2": 906.38436, "decw3": 897.3205164, "decw4": 888.347311236, "ttlJanuary": -238.1870399999999, "ttlFebrurary": -265.7880246000001, "ttlMarch": -343.8545940608002, "ttlApril": -250.86405197819, "ttlMay": -274.8535440000001, "ttlJune": -327.76126479599986, "ttlJuly": -255.87287459999988, "ttlAugust": -255.414331032, "ttlSeptember": -269.58036, "ttlOctober": -187.97452767156, "ttlNovember": -180.56758126293698, "ttlDecember": 2604.4543400038, "q1": -847.8296586608001, "q2": -853.47886077419, "q3": -780.8675656319999, "q4": 2235.9122310693, "h1": -1701.30851943499, "h2": 1455.0446654373, "ty": -246.26385399769015 }, { "columnValue": "Sell In Variance", "secondValue": "FB Channel Ops Fcst to Actual (SI Var)", "janw1": 61.11084000000005, "janw2": 62.172180000000026, "janw3": 53.06700000000001, "janw4": 61.837020000000166, "febw1": 61.218649799999866, "febw2": 60.44051999999988, "febw3": 59.83611480000013, "febw4": 84.29273999999987, "marchw1": 70.16016000000013, "marchw2": 69.4585583999999, "marchw3": 68.76397281599998, "marchw4": 68.07633308784011, "marchw5": 67.39556975695996, "aprilw1": 66.72161405938982, "aprilw2": 66.05439791880008, "aprilw3": 51.11189999999988, "aprilw4": 66.97613999999999, "mayw1": 62.95422000000008, "mayw2": 70.38359999999989, "mayw3": 69.67976399999998, "mayw4": 71.83595999999989, "mayw5": 71.1176003999999, "junew1": 70.40642439599992, "junew2": 53.737319999999954, "junew3": 66.2499600000001, "junew4": 66.2499600000001, "julyw1": 65.58746040000005, "julyw2": 62.11632000000009, "julyw3": 64.40658000000008, "julyw4": 63.76251419999994, "augw1": 63.12488905800001, "augw2": 64.74173999999994, "augw3": 64.09432259999994, "augw4": 63.45337937400018, "augw5": 52.508400000000165, "sepw1": 54.295920000000024, "sepw2": 52.62012000000004, "sepw3": 50.60915999999986, "sepw4": 59.54676000000018, "octw1": 47.70443999999998, "octw2": 47.22739560000002, "octw3": 46.75512164399993, "octw4": 46.28757042756001, "novw1": 45.8246947232841, "novw2": 45.366447776050904, "novw3": 44.91278329829106, "novw4": 44.46365546530808, "novw5": 44.01901891065495, "decw1": 43.57882872154801, "decw2": 1001.79324, "decw3": 991.7753076, "decw4": 981.857554524, "ttlJanuary": 238.1870400000002, "ttlFebrurary": 265.78802459999986, "ttlMarch": 343.8545940608, "ttlApril": 250.86405197819, "ttlMay": 274.8535439999999, "ttlJune": 327.7612647960001, "ttlJuly": 255.87287459999988, "ttlAugust": 255.4143310320002, "ttlSeptember": 269.5803600000002, "ttlOctober": 187.97452767156, "ttlNovember": 180.5675812629341, "ttlDecember": 3063.0239497562, "q1": 847.8296586608001, "q2": 853.47886077419, "q3": 780.8675656319999, "q4": 3431.5660586906897, "h1": 1701.30851943499, "h2": 4212.43362432269, "ty": 5913.7421437576795 }, { "columnValue": "Sell In Variance", "secondValue": "FB CPFR Fcst to Actual (SI Var)", "janw1": 122.2216800000001, "janw2": 124.34436000000005, "janw3": 106.13400000000001, "janw4": 123.6740400000001, "febw1": 122.43729959999996, "febw2": 120.88103999999998, "febw3": 119.67222960000004, "febw4": 168.58547999999996, "marchw1": 140.32032000000004, "marchw2": 138.91711680000003, "marchw3": 137.52794563199996, "marchw4": 136.15266617568, "marchw5": 134.79113951392992, "aprilw1": 133.44322811877987, "aprilw2": 132.10879583760016, "aprilw3": 102.22379999999998, "aprilw4": 133.95227999999997, "mayw1": 125.90843999999993, "mayw2": 140.7672, "mayw3": 139.35952799999995, "mayw4": 143.67192, "mayw5": 142.23520080000003, "junew1": 140.81284879200007, "junew2": 107.47463999999991, "junew3": 132.49991999999997, "junew4": 132.49991999999997, "julyw1": 131.1749208000001, "julyw2": 124.23264000000017, "julyw3": 128.81316000000015, "julyw4": 127.52502840000011, "augw1": 126.24977811600002, "augw2": 129.48347999999987, "augw3": 128.1886452000001, "augw4": 126.90675874800013, "augw5": 105.0168000000001, "sepw1": 108.59184000000005, "sepw2": 105.24024000000009, "sepw3": 101.21831999999984, "sepw4": 119.09352000000013, "octw1": 95.40887999999995, "octw2": 94.45479120000005, "octw3": 93.51024328799997, "octw4": 92.57514085512003, "novw1": 91.64938944657206, "novw2": 90.73289555210295, "novw3": 89.82556659658201, "novw4": 88.92731093061604, "novw5": 88.03803782131001, "decw1": 87.15765744309692, "decw2": 1049.49768, "decw3": 1039.0027032, "decw4": 1028.612676168, "ttlJanuary": 476.37408, "ttlFebrurary": 531.5760491999999, "ttlMarch": 687.70918812161, "ttlApril": 501.72810395638, "ttlMay": 549.707088, "ttlJune": 655.522529592, "ttlJuly": 511.7457492, "ttlAugust": 510.828662064, "ttlSeptember": 539.16072, "ttlOctober": 375.94905534312, "ttlNovember": 361.135162525873, "ttlDecember": 3292.3087546324105, "q1": 1695.6593173216102, "q2": 1706.95772154838, "q3": 1561.7351312639998, "q4": 4029.3929725014, "h1": 3402.61703886999, "h2": 5591.1281037654, "ty": 8993.745142635391 }, { "columnValue": "Quest 128GB" }, { "columnValue": "Sell In Accuracy", "secondValue": "Sell In Accuracy" }, { "columnValue": "Sell In Accuracy", "secondValue": "Algo Fcst vs. Act. (SI Acc)", "janw1": 0.98, "janw2": 0.98, "janw3": 0.9800000000000001, "janw4": 0.9800000000000001, "febw1": 0.9800000000000002, "febw2": 0.9799999999999999, "febw3": 0.9799999999999999, "febw4": 0.98, "marchw1": 0.9800000000000001, "marchw2": 0.9800000000000001, "marchw3": 0.9800000000000001, "marchw4": 0.9800000000000001, "marchw5": 0.9800000000000001, "aprilw1": 0.9800000000000001, "aprilw2": 0.98, "aprilw3": 0.98, "aprilw4": 0.98, "mayw1": 0.9799999999999999, "mayw2": 0.98, "mayw3": 0.98, "mayw4": 0.98, "mayw5": 0.9799999999999999, "junew1": 0.98, "junew2": 0.98, "junew3": 0.98, "junew4": 0.98, "julyw1": 0.98, "julyw2": 0.98, "julyw3": 0.9800000000000001, "julyw4": 0.98, "augw1": 0.9799999999999999, "augw2": 0.98, "augw3": 0.9800000000000001, "augw4": 0.9800000000000001, "augw5": 0.9800000000000001, "sepw1": 0.98, "sepw2": 0.9799999999999999, "sepw3": 0.98, "sepw4": 0.98, "octw1": 0.98, "octw2": 0.98, "octw3": 0.9799999999999999, "octw4": 0.9799999999999999, "novw1": 0.9799999999999998, "novw2": 0.9799999999999998, "novw3": 0.9799999999999998, "novw4": 0.9799999999999999, "novw5": 0.9799999999999999, "decw1": 0.9799999999999999 }, { "columnValue": "Sell In Accuracy", "secondValue": "Customer Fcst vs. Act. (SI Acc)", "janw1": 0.95, "janw2": 0.95, "janw3": 0.95, "janw4": 0.9500000000000001, "febw1": 0.9500000000000001, "febw2": 0.95, "febw3": 0.9499999999999998, "febw4": 0.95, "marchw1": 0.9499999999999998, "marchw2": 0.9499999999999998, "marchw3": 0.95, "marchw4": 0.9500000000000001, "marchw5": 0.9500000000000002, "aprilw1": 0.9500000000000001, "aprilw2": 0.95, "aprilw3": 0.95, "aprilw4": 0.95, "mayw1": 0.95, "mayw2": 0.95, "mayw3": 0.9499999999999998, "mayw4": 0.95, "mayw5": 0.95, "junew1": 0.9499999999999998, "junew2": 0.95, "junew3": 0.95, "junew4": 0.95, "julyw1": 0.95, "julyw2": 0.95, "julyw3": 0.95, "julyw4": 0.9499999999999998, "augw1": 0.9499999999999998, "augw2": 0.9499999999999998, "augw3": 0.9500000000000001, "augw4": 0.9500000000000001, "augw5": 0.95, "sepw1": 0.95, "sepw2": 0.95, "sepw3": 0.95, "sepw4": 0.9500000000000001, "octw1": 0.9499999999999998, "octw2": 0.9499999999999998, "octw3": 0.9499999999999998, "octw4": 0.9499999999999998, "novw1": 0.9499999999999998, "novw2": 0.9499999999999998, "novw3": 0.9499999999999998, "novw4": 0.95, "novw5": 0.95, "decw1": 0.9500000000000001 }, { "columnValue": "Sell In Accuracy", "secondValue": "FB Channel Ops Fcst vs. Act. (SI Acc)", "janw1": 1.05, "janw2": 1.05, "janw3": 1.05, "janw4": 1.05, "febw1": 1.05, "febw2": 1.05, "febw3": 1.05, "febw4": 1.05, "marchw1": 1.05, "marchw2": 1.05, "marchw3": 1.0500000000000003, "marchw4": 1.0500000000000003, "marchw5": 1.0500000000000003, "aprilw1": 1.0500000000000003, "aprilw2": 1.0500000000000003, "aprilw3": 1.05, "aprilw4": 1.05, "mayw1": 1.05, "mayw2": 1.05, "mayw3": 1.05, "mayw4": 1.05, "mayw5": 1.05, "junew1": 1.05, "junew2": 1.05, "junew3": 1.05, "junew4": 1.05, "julyw1": 1.05, "julyw2": 1.05, "julyw3": 1.05, "julyw4": 1.05, "augw1": 1.05, "augw2": 1.05, "augw3": 1.05, "augw4": 1.05, "augw5": 1.05, "sepw1": 1.05, "sepw2": 1.05, "sepw3": 1.05, "sepw4": 1.05, "octw1": 1.05, "octw2": 1.05, "octw3": 1.0499999999999998, "octw4": 1.0499999999999998, "novw1": 1.0499999999999998, "novw2": 1.0499999999999998, "novw3": 1.0499999999999998, "novw4": 1.0499999999999998, "novw5": 1.0499999999999998, "decw1": 1.0499999999999998 }, { "columnValue": "Sell In Accuracy", "secondValue": "FB CPFR Fcst vs. Act. (SI Acc)", "janw1": 1.1, "janw2": 1.1, "janw3": 1.1, "janw4": 1.1, "febw1": 1.1, "febw2": 1.1, "febw3": 1.0999999999999999, "febw4": 1.1, "marchw1": 1.1, "marchw2": 1.1, "marchw3": 1.1, "marchw4": 1.1000000000000003, "marchw5": 1.1000000000000003, "aprilw1": 1.1000000000000003, "aprilw2": 1.1, "aprilw3": 1.1, "aprilw4": 1.1, "mayw1": 1.1, "mayw2": 1.1, "mayw3": 1.1, "mayw4": 1.1, "mayw5": 1.1, "junew1": 1.1, "junew2": 1.1, "junew3": 1.1, "junew4": 1.1, "julyw1": 1.1, "julyw2": 1.1, "julyw3": 1.1, "julyw4": 1.1, "augw1": 1.1, "augw2": 1.1, "augw3": 1.1, "augw4": 1.1, "augw5": 1.1, "sepw1": 1.1, "sepw2": 1.1, "sepw3": 1.1, "sepw4": 1.1, "octw1": 1.1, "octw2": 1.1, "octw3": 1.1, "octw4": 1.1, "novw1": 1.0999999999999999, "novw2": 1.0999999999999999, "novw3": 1.0999999999999999, "novw4": 1.1, "novw5": 1.1, "decw1": 1.1 }, { "columnValue": "Quest 128GB" }, { "columnValue": "Quest 128GB", "secondValue": "KPIs:" }, { "columnValue": "Quest 128GB", "secondValue": "In-stock %", "janw1": 0.98, "janw2": 0.97, "janw3": 0.96, "janw4": 0.95, "febw1": 0.98, "febw2": 0.98, "febw3": 0.97, "febw4": 0.96, "marchw1": 0.95, "marchw2": 0.98, "marchw3": 0.98, "marchw4": 0.97, "marchw5": 0.96, "aprilw1": 0.95, "aprilw2": 0.98, "aprilw3": 0.98, "aprilw4": 0.97, "mayw1": 0.96, "mayw2": 0.95, "mayw3": 0.98, "mayw4": 0.98, "mayw5": 0.97, "junew1": 0.96, "junew2": 0.95, "junew3": 0.98, "junew4": 0.98, "julyw1": 0.97, "julyw2": 0.96, "julyw3": 0.95, "julyw4": 0.98, "augw1": 0.98, "augw2": 0.97, "augw3": 0.96, "augw4": 0.95, "augw5": 0.98, "sepw1": 0.98, "sepw2": 0.97, "sepw3": 0.96, "sepw4": 0.95, "octw1": 0.98, "octw2": 0.98, "octw3": 0.97, "octw4": 0.96, "novw1": 0.95, "novw2": 0.98, "novw3": 0.98, "novw4": 0.97, "novw5": 0.96, "decw1": 0.95, "decw2": 0.98, "decw3": 0.95, "decw4": 0.98 }, { "columnValue": "Quest 128GB", "secondValue": "# Stores OOS", "janw1": 20, "janw2": 30, "janw3": 40, "janw4": 50, "febw1": 20, "febw2": 20, "febw3": 30, "febw4": 40, "marchw1": 50, "marchw2": 20, "marchw3": 20, "marchw4": 30, "marchw5": 40, "aprilw1": 50, "aprilw2": 20, "aprilw3": 20, "aprilw4": 30, "mayw1": 40, "mayw2": 50, "mayw3": 20, "mayw4": 20, "mayw5": 30, "junew1": 40, "junew2": 50, "junew3": 20, "junew4": 20, "julyw1": 30, "julyw2": 40, "julyw3": 50, "julyw4": 20, "augw1": 20, "augw2": 30, "augw3": 40, "augw4": 50, "augw5": 20, "sepw1": 20, "sepw2": 30, "sepw3": 40, "sepw4": 50, "octw1": 20, "octw2": 20, "octw3": 30, "octw4": 40, "novw1": 50, "novw2": 20, "novw3": 20, "novw4": 30, "novw5": 40, "decw1": 50, "decw2": 20, "decw3": 50, "decw4": 20 }, { "columnValue": "Quest 128GB", "secondValue": "On Time Delivery Performance", "janw1": 0.98, "janw2": 0.97, "janw3": 0.96, "janw4": 0.95, "febw1": 0.98, "febw2": 0.98, "febw3": 0.97, "febw4": 0.96, "marchw1": 0.95, "marchw2": 0.98, "marchw3": 0.98, "marchw4": 0.97, "marchw5": 0.96, "aprilw1": 0.95, "aprilw2": 0.98, "aprilw3": 0.98, "aprilw4": 0.97, "mayw1": 0.96, "mayw2": 0.95, "mayw3": 0.98, "mayw4": 0.98, "mayw5": 0.97, "junew1": 0.96, "junew2": 0.95, "junew3": 0.98, "junew4": 0.98, "julyw1": 0.97, "julyw2": 0.96, "julyw3": 0.95, "julyw4": 0.98, "augw1": 0.98, "augw2": 0.97, "augw3": 0.96, "augw4": 0.95, "augw5": 0.98, "sepw1": 0.98, "sepw2": 0.97, "sepw3": 0.96, "sepw4": 0.95, "octw1": 0.98, "octw2": 0.98, "octw3": 0.97, "octw4": 0.96, "novw1": 0.95, "novw2": 0.98, "novw3": 0.98, "novw4": 0.97, "novw5": 0.96, "decw1": 0.95, "decw2": 0.98, "decw3": 0.95, "decw4": 0.98 }, { "columnValue": "Quest 128GB", "secondValue": "On Time In Full", "janw1": 0.98, "janw2": 0.97, "janw3": 0.96, "janw4": 0.95, "febw1": 0.98, "febw2": 0.98, "febw3": 0.97, "febw4": 0.96, "marchw1": 0.95, "marchw2": 0.98, "marchw3": 0.98, "marchw4": 0.97, "marchw5": 0.96, "aprilw1": 0.95, "aprilw2": 0.98, "aprilw3": 0.98, "aprilw4": 0.97, "mayw1": 0.96, "mayw2": 0.95, "mayw3": 0.98, "mayw4": 0.98, "mayw5": 0.97, "junew1": 0.96, "junew2": 0.95, "junew3": 0.98, "junew4": 0.98, "julyw1": 0.97, "julyw2": 0.96, "julyw3": 0.95, "julyw4": 0.98, "augw1": 0.98, "augw2": 0.97, "augw3": 0.96, "augw4": 0.95, "augw5": 0.98, "sepw1": 0.98, "sepw2": 0.97, "sepw3": 0.96, "sepw4": 0.95, "octw1": 0.98, "octw2": 0.98, "octw3": 0.97, "octw4": 0.96, "novw1": 0.95, "novw2": 0.98, "novw3": 0.98, "novw4": 0.97, "novw5": 0.96, "decw1": 0.95, "decw2": 0.98, "decw3": 0.95, "decw4": 0.98 }, { "columnValue": "Quest 128GB", "secondValue": "Customer Chargebacks", "janw1": 10005, "janw2": 8004, "janw3": 9004.5, "janw4": 9804.9, "febw1": 10005, "febw2": 8004, "febw3": 9004.5, "febw4": 9804.9, "marchw1": 10005, "marchw2": 8004, "marchw3": 9004.5, "marchw4": 9804.9, "marchw5": 10005, "aprilw1": 8004, "aprilw2": 9004.5, "aprilw3": 9804.9, "aprilw4": 10005, "mayw1": 8004, "mayw2": 9004.5, "mayw3": 9804.9, "mayw4": 10005, "mayw5": 8004, "junew1": 9004.5, "junew2": 9804.9, "junew3": 10005, "junew4": 8004, "julyw1": 9004.5, "julyw2": 9804.9, "julyw3": 10005, "julyw4": 8004, "augw1": 9004.5, "augw2": 9804.9, "augw3": 10005, "augw4": 8004, "augw5": 9004.5, "sepw1": 9804.9, "sepw2": 10005, "sepw3": 8004, "sepw4": 9004.5, "octw1": 9804.9, "octw2": 10005, "octw3": 8004, "octw4": 9004.5, "novw1": 9804.9, "novw2": 10005, "novw3": 8004, "novw4": 9004.5, "novw5": 9804.9, "decw1": 10005, "decw2": 8004, "decw3": 9004.5, "decw4": 9804.9, "ttlJanuary": 36818.4, "ttlFebrurary": 36818.4, "ttlMarch": 46823.4, "ttlApril": 36818.4, "ttlMay": 36818.4, "ttlJune": 44822.4, "ttlJuly": 36818.4, "ttlAugust": 36818.4, "ttlSeptember": 45822.9, "ttlOctober": 36818.4, "ttlNovember": 36818.4, "ttlDecember": 46623.3, "q1": 120460.20000000001, "q2": 118459.20000000001, "q3": 119459.70000000001, "q4": 120260.1, "h1": 238919.4, "h2": 239719.8, "ty": 478639.19999999995 }, { "columnValue": "Quest 128GB", "secondValue": "Profitability", "janw1": 0.5, "janw2": 0.5, "janw3": 0.5, "janw4": 0.5, "febw1": 0.5, "febw2": 0.5, "febw3": 0.5, "febw4": 0.5, "marchw1": 0.5, "marchw2": 0.5, "marchw3": 0.5, "marchw4": 0.5, "marchw5": 0.5, "aprilw1": 0.5, "aprilw2": 0.5, "aprilw3": 0.5, "aprilw4": 0.5, "mayw1": 0.5, "mayw2": 0.5, "mayw3": 0.5, "mayw4": 0.5, "mayw5": 0.5, "junew1": 0.5, "junew2": 0.5, "junew3": 0.5, "junew4": 0.5, "julyw1": 0.5, "julyw2": 0.5, "julyw3": 0.5, "julyw4": 0.5, "augw1": 0.5, "augw2": 0.5, "augw3": 0.5, "augw4": 0.5, "augw5": 0.5, "sepw1": 0.5, "sepw2": 0.5, "sepw3": 0.5, "sepw4": 0.5, "octw1": 0.5, "octw2": 0.5, "octw3": 0.5, "octw4": 0.5, "novw1": 0.5, "novw2": 0.5, "novw3": 0.5, "novw4": 0.5, "novw5": 0.5, "decw1": 0.5, "decw2": 0.5, "decw3": 0.5, "decw4": 0.5 }, { "columnValue": "Quest 128GB", "secondValue": "Cost to Serve Customer", "janw1": 50025, "janw2": 40020, "janw3": 45022.5, "janw4": 49024.5, "febw1": 50025, "febw2": 40020, "febw3": 45022.5, "febw4": 49024.5, "marchw1": 50025, "marchw2": 40020, "marchw3": 45022.5, "marchw4": 49024.5, "marchw5": 50025, "aprilw1": 40020, "aprilw2": 45022.5, "aprilw3": 49024.5, "aprilw4": 50025, "mayw1": 40020, "mayw2": 45022.5, "mayw3": 49024.5, "mayw4": 50025, "mayw5": 40020, "junew1": 45022.5, "junew2": 49024.5, "junew3": 50025, "junew4": 40020, "julyw1": 45022.5, "julyw2": 49024.5, "julyw3": 50025, "julyw4": 40020, "augw1": 45022.5, "augw2": 49024.5, "augw3": 50025, "augw4": 40020, "augw5": 45022.5, "sepw1": 49024.5, "sepw2": 50025, "sepw3": 40020, "sepw4": 45022.5, "octw1": 49024.5, "octw2": 50025, "octw3": 40020, "octw4": 45022.5, "novw1": 49024.5, "novw2": 50025, "novw3": 40020, "novw4": 45022.5, "novw5": 49024.5, "decw1": 50025, "decw2": 40020, "decw3": 45022.5, "decw4": 49024.5, "ttlJanuary": 184092, "ttlFebrurary": 184092, "ttlMarch": 234117, "ttlApril": 184092, "ttlMay": 184092, "ttlJune": 224112, "ttlJuly": 184092, "ttlAugust": 184092, "ttlSeptember": 229114.5, "ttlOctober": 184092, "ttlNovember": 184092, "ttlDecember": 233116.5, "q1": 602301, "q2": 592296, "q3": 597298.5, "q4": 601300.5, "h1": 1194597, "h2": 1198599, "ty": 2393196 }, { "columnValue": "Quest 128GB", "secondValue": "DC Retailer Count", "janw1": 6, "janw2": 6, "janw3": 6, "janw4": 6, "febw1": 6, "febw2": 6, "febw3": 6, "febw4": 6, "marchw1": 6, "marchw2": 6, "marchw3": 6, "marchw4": 6, "marchw5": 6, "aprilw1": 6, "aprilw2": 6, "aprilw3": 6, "aprilw4": 6, "mayw1": 6, "mayw2": 6, "mayw3": 6, "mayw4": 6, "mayw5": 6, "junew1": 6, "junew2": 6, "junew3": 6, "junew4": 6, "julyw1": 6, "julyw2": 6, "julyw3": 6, "julyw4": 6, "augw1": 6, "augw2": 6, "augw3": 6, "augw4": 6, "augw5": 6, "sepw1": 6, "sepw2": 6, "sepw3": 6, "sepw4": 6, "octw1": 6, "octw2": 6, "octw3": 6, "octw4": 6, "novw1": 6, "novw2": 6, "novw3": 6, "novw4": 6, "novw5": 6, "decw1": 6, "decw2": 6, "decw3": 6, "decw4": 6 }, { "columnValue": "Quest 128GB", "secondValue": "Door Count", "janw1": 998, "janw2": 998, "janw3": 998, "janw4": 998, "febw1": 998, "febw2": 998, "febw3": 998, "febw4": 998, "marchw1": 998, "marchw2": 998, "marchw3": 998, "marchw4": 998, "marchw5": 998, "aprilw1": 998, "aprilw2": 998, "aprilw3": 998, "aprilw4": 998, "mayw1": 998, "mayw2": 998, "mayw3": 998, "mayw4": 998, "mayw5": 998, "junew1": 998, "junew2": 998, "junew3": 998, "junew4": 998, "julyw1": 998, "julyw2": 998, "julyw3": 998, "julyw4": 998, "augw1": 998, "augw2": 998, "augw3": 998, "augw4": 998, "augw5": 998, "sepw1": 998, "sepw2": 998, "sepw3": 998, "sepw4": 998, "octw1": 998, "octw2": 998, "octw3": 998, "octw4": 998, "novw1": 998, "novw2": 998, "novw3": 998, "novw4": 998, "novw5": 998, "decw1": 998, "decw2": 998, "decw3": 998, "decw4": 998 }, { "columnValue": "Quest 128GB", "secondValue": "Delivery method", "janw1": "Air", "janw2": "Sea", "janw3": "Sea", "janw4": "Ground", "febw1": "Air", "febw2": "Sea", "febw3": "Ground", "febw4": "Air", "marchw1": "Sea", "marchw2": "Sea", "marchw3": "Ground", "marchw4": "Air", "marchw5": "Sea", "aprilw1": "Ground", "aprilw2": "Air", "aprilw3": "Sea", "aprilw4": "Sea", "mayw1": "Ground", "mayw2": "Air", "mayw3": "Sea", "mayw4": "Ground", "mayw5": "Air", "junew1": "Sea", "junew2": "Sea", "junew3": "Ground", "junew4": "Air", "julyw1": "Sea", "julyw2": "Ground", "julyw3": "Air", "julyw4": "Sea", "augw1": "Sea", "augw2": "Ground", "augw3": "Air", "augw4": "Sea", "augw5": "Ground", "sepw1": "Air", "sepw2": "Sea", "sepw3": "Sea", "sepw4": "Ground", "octw1": "Air", "octw2": "Sea", "octw3": "Ground", "octw4": "Air", "novw1": "Sea", "novw2": "Sea", "novw3": "Ground", "novw4": "Air", "novw5": "Sea", "decw1": "Ground", "decw2": "Air", "decw3": "Sea", "decw4": "Ground" }, { "columnValue": "Calculation", "secondValue": "Linear", "janw1": 998.1437199999999, "janw2": 1015.47894, "janw3": 866.761, "janw4": 1010.00466, "febw1": 714.3935399999999, "febw2": 987.1951599999999, "febw3": 809.2810599999999, "febw4": 1376.7814199999998, "marchw1": 1145.9492799999998, "marchw2": 1260.5442079999998, "marchw3": 1386.5986288, "marchw4": 1525.2584916800001, "marchw5": 793.0863149999999, "aprilw1": 946.146439, "aprilw2": 976.839647, "aprilw3": 1074.5236117000002, "aprilw4": 1093.94362, "mayw1": 1028.25226, "mayw2": 1149.5988, "mayw3": 1264.5586799999999, "mayw4": 1391.014548, "mayw5": 1530.1160028000002, "junew1": 1683.1276030800004, "junew2": 1851.4403633880004, "junew3": 1082.08268, "junew4": 1082.08268, "julyw1": 1190.2909479999998, "julyw2": 1014.5665599999999, "julyw3": 1051.97414, "julyw4": 1157.1715540000002, "augw1": 1272.8887094000004, "augw2": 1057.44842, "augw3": 1780.9657599999998, "augw4": 1602.869184, "augw5": 1442.5822655999998, "sepw1": 1298.32403904, "sepw2": 1168.4916351359998, "sepw3": 1051.6424716224, "sepw4": 1041.1260469061758, "octw1": 1030.7147864371143, "octw2": 1020.4076385727429, "octw3": 1010.2035621870156, "octw4": 1000.1015265651455, "novw1": 990.100511299494, "novw2": 980.199506186499, "novw3": 970.3975111246339, "novw4": 960.6935360133875, "novw5": 951.0866006532536, "decw1": 941.5757346467211, "decw2": 932.1599773002539, "decw3": 922.8383775272514, "decw4": 913.6099937519789 }, { "columnValue": "Calculation", "secondValue": "Curve", "janw1": 988.1622828, "janw2": 1005.3241505999999, "janw3": 858.09339, "janw4": 999.9046133999999, "febw1": 707.2496045999999, "febw2": 977.3232083999999, "febw3": 801.1882493999999, "febw4": 1363.0136057999998, "marchw1": 1134.4897872, "marchw2": 1247.9387659199997, "marchw3": 1372.732642512, "marchw4": 1510.0059067632, "marchw5": 785.1554518499998, "aprilw1": 936.6849746099999, "aprilw2": 967.07125053, "aprilw3": 1063.778375583, "aprilw4": 1083.0041838, "mayw1": 1017.9697374, "mayw2": 1138.102812, "mayw3": 1251.9130931999998, "mayw4": 1377.1044025200001, "mayw5": 1514.8148427720002, "junew1": 1666.2963270492005, "junew2": 1832.9259597541204, "junew3": 1071.2618532, "junew4": 1071.2618532, "julyw1": 1178.3880385199998, "julyw2": 1004.4208943999998, "julyw3": 1041.4543986, "julyw4": 1145.5998384600002, "augw1": 1260.1598223060005, "augw2": 1046.8739358, "augw3": 1763.1561023999998, "augw4": 1586.84049216, "augw5": 1428.1564429439998, "sepw1": 1285.3407986496, "sepw2": 1156.8067187846398, "sepw3": 1041.126046906176, "sepw4": 1030.714786437114, "octw1": 1020.4076385727432, "octw2": 1010.2035621870155, "octw3": 1000.1015265651454, "octw4": 990.100511299494, "novw1": 980.199506186499, "novw2": 970.397511124634, "novw3": 960.6935360133875, "novw4": 951.0866006532536, "novw5": 941.5757346467211, "decw1": 932.1599773002539, "decw2": 922.8383775272514, "decw3": 913.6099937519789, "decw4": 904.4738938144591 }, { "columnValue": "Calculation", "secondValue": "Exponential", "janw1": 958.517414316, "janw2": 975.1644260819999, "janw3": 832.3505883, "janw4": 969.9074749979999, "febw1": 686.0321164619999, "febw2": 948.0035121479999, "febw3": 777.1526019179998, "febw4": 1322.1231976259999, "marchw1": 1100.4550935839998, "marchw2": 1210.5006029423996, "marchw3": 1331.55066323664, "marchw4": 1464.705729560304, "marchw5": 761.6007882944998, "aprilw1": 908.5844253716999, "aprilw2": 938.0591130141, "aprilw3": 1031.86502431551, "aprilw4": 1050.514058286, "mayw1": 987.4306452779999, "mayw2": 1103.95972764, "mayw3": 1214.355700404, "mayw4": 1335.7912704444, "mayw5": 1469.3703974888401, "junew1": 1616.3074372377243, "junew2": 1777.9381809614968, "junew3": 1039.123997604, "junew4": 1039.123997604, "julyw1": 1143.0363973643998, "julyw2": 974.2882675679998, "julyw3": 1010.2107666420001, "julyw4": 1111.2318433062003, "augw1": 1222.3550276368205, "augw2": 1015.467717726, "augw3": 1710.2614193279996, "augw4": 1539.2352773952, "augw5": 1385.3117496556797, "sepw1": 1246.780574690112, "sepw2": 1122.1025172211005, "sepw3": 1009.8922654989907, "sepw4": 999.7933428440007, "octw1": 989.7954094155608, "octw2": 979.897455321405, "octw3": 970.0984807681909, "octw4": 960.3974959605091, "novw1": 950.793521000904, "novw2": 941.285585790895, "novw3": 931.8727299329859, "novw4": 922.554002633656, "novw5": 913.3284626073195, "decw1": 904.1951779812463, "decw2": 895.1532262014339, "decw3": 886.2016939394196, "decw4": 877.3396770000253 }, { "columnValue": "Calculation", "secondValue": "Logarithmic", "janw1": 948.2365339999999, "janw2": 964.704993, "janw3": 823.4229499999999, "janw4": 959.5044269999999, "febw1": 678.6738629999999, "febw2": 937.8354019999998, "febw3": 768.8170069999999, "febw4": 1307.9423489999997, "marchw1": 1088.6518159999998, "marchw2": 1197.5169975999997, "marchw3": 1317.2686973599998, "marchw4": 1448.995567096, "marchw5": 753.4319992499999, "aprilw1": 898.8391170499999, "aprilw2": 927.9976646499999, "aprilw3": 1020.7974311150001, "aprilw4": 1039.246439, "mayw1": 976.8396469999999, "mayw2": 1092.11886, "mayw3": 1201.3307459999999, "mayw4": 1321.4638206, "mayw5": 1453.6102026600001, "junew1": 1598.9712229260003, "junew2": 1758.8683452186003, "junew3": 1027.9785459999998, "junew4": 1027.9785459999998, "julyw1": 1130.7764005999998, "julyw2": 963.8382319999998, "julyw3": 999.3754329999999, "julyw4": 1099.3129763000002, "augw1": 1209.2442739300004, "augw2": 1004.5759989999999, "augw3": 1691.9174719999999, "augw4": 1522.7257247999999, "augw5": 1370.4531523199998, "sepw1": 1233.4078370879997, "sepw2": 1110.0670533791997, "sepw3": 999.06034804128, "sepw4": 989.069744560867, "octw1": 979.1790471152585, "octw2": 969.3872566441057, "octw3": 959.6933840776647, "octw4": 950.0964502368881, "novw1": 940.5954857345192, "novw2": 931.189530877174, "novw3": 921.8776355684022, "novw4": 912.6588592127181, "novw5": 903.5322706205909, "decw1": 894.496947914385, "decw2": 885.5519784352412, "decw3": 876.6964586508888, "decw4": 867.9294940643799 }, { "columnValue": "Calculation", "secondValue": "Power", "janw1": 1097.958092, "janw2": 1117.026834, "janw3": 953.4371, "janw4": 1111.005126, "febw1": 785.832894, "febw2": 1085.9146759999999, "febw3": 890.209166, "febw4": 1514.459562, "marchw1": 1260.5442079999998, "marchw2": 1386.5986288, "marchw3": 1525.2584916800001, "marchw4": 1677.7843408480003, "marchw5": 872.3949465, "aprilw1": 1040.7610829, "aprilw2": 1074.5236117000002, "aprilw3": 1181.9759728700003, "aprilw4": 1203.337982, "mayw1": 1131.0774860000001, "mayw2": 1264.55868, "mayw3": 1391.0145479999999, "mayw4": 1530.1160028000002, "mayw5": 1683.1276030800002, "junew1": 1851.4403633880006, "junew2": 2036.5843997268005, "junew3": 1190.290948, "junew4": 1190.290948, "julyw1": 1309.3200428, "julyw2": 1116.023216, "julyw3": 1157.1715540000002, "julyw4": 1272.8887094000004, "augw1": 1400.1775803400005, "augw2": 1163.193262, "augw3": 1959.062336, "augw4": 1763.1561024, "augw5": 1586.84049216, "sepw1": 1428.156442944, "sepw2": 1285.3407986496, "sepw3": 1156.8067187846402, "sepw4": 1145.2386515967935, "octw1": 1133.7862650808258, "octw2": 1122.4484024300173, "octw3": 1111.2239184057173, "octw4": 1100.11167922166, "novw1": 1089.1105624294435, "novw2": 1078.2194568051489, "novw3": 1067.4372622370972, "novw4": 1056.7628896147264, "novw5": 1046.195260718579, "decw1": 1035.7333081113934, "decw2": 1025.3759750302793, "decw3": 1015.1222152799767, "decw4": 1004.9709931271768 }, { "columnValue": "Calculation", "secondValue": "Parabola", "janw1": 1008.1251571999999, "janw2": 1025.6337294, "janw3": 875.4286099999999, "janw4": 1020.1047066, "febw1": 721.5374754, "febw2": 997.0671115999999, "febw3": 817.3738705999999, "febw4": 1390.5492341999998, "marchw1": 1157.4087727999997, "marchw2": 1273.14965008, "marchw3": 1400.4646150879998, "marchw4": 1540.5110765968002, "marchw5": 801.01717815, "aprilw1": 955.60790339, "aprilw2": 986.60804347, "aprilw3": 1085.2688478170003, "aprilw4": 1104.8830562, "mayw1": 1038.5347826, "mayw2": 1161.0947879999999, "mayw3": 1277.2042668, "mayw4": 1404.92469348, "mayw5": 1545.417162828, "junew1": 1699.9588791108004, "junew2": 1869.9547670218803, "junew3": 1092.9035068, "junew4": 1092.9035068, "julyw1": 1202.19385748, "julyw2": 1024.7122255999998, "julyw3": 1062.4938814, "julyw4": 1168.7432695400003, "augw1": 1285.6175964940003, "augw2": 1068.0229041999999, "augw3": 1798.7754175999999, "augw4": 1618.8978758399999, "augw5": 1457.0080882559998, "sepw1": 1311.3072794303998, "sepw2": 1180.1765514873598, "sepw3": 1062.1588963386241, "sepw4": 1051.5373073752376, "octw1": 1041.0219343014855, "octw2": 1030.6117149584704, "octw3": 1020.3055978088858, "octw4": 1010.102541830797, "novw1": 1000.001516412489, "novw2": 990.001501248364, "novw3": 980.1014862358802, "novw4": 970.3004713735214, "novw5": 960.5974666597862, "decw1": 950.9914919931883, "decw2": 941.4815770732564, "decw3": 932.0667613025239, "decw4": 922.7460936894987 }, { "columnValue": "Calculation", "secondValue": "Moving Average", "janw1": 998.043905628, "janw2": 1015.377392106, "janw3": 866.6743239, "janw4": 1009.9036595339999, "febw1": 714.3221006459999, "febw2": 987.0964404839999, "febw3": 809.2001318939999, "febw4": 1376.6437418579999, "marchw1": 1145.834685072, "marchw2": 1260.4181535791997, "marchw3": 1386.45996893712, "marchw4": 1525.105965830832, "marchw5": 793.0070063684999, "aprilw1": 946.0518243560999, "aprilw2": 976.7419630353, "aprilw3": 1074.41615933883, "aprilw4": 1093.834225638, "mayw1": 1028.149434774, "mayw2": 1149.4838401200002, "mayw3": 1264.4322241319999, "mayw4": 1390.8754465452002, "mayw5": 1529.9629911997204, "junew1": 1682.9592903196926, "junew2": 1851.2552193516617, "junew3": 1081.974471732, "junew4": 1081.974471732, "julyw1": 1190.1719189051998, "julyw2": 1014.4651033439999, "julyw3": 1051.868942586, "julyw4": 1157.0558368446002, "augw1": 1272.7614205290604, "augw2": 1057.342675158, "augw3": 1780.787663424, "augw4": 1602.7088970815998, "augw5": 1442.4380073734399, "sepw1": 1298.194206636096, "sepw2": 1168.3747859724863, "sepw3": 1051.5373073752378, "sepw4": 1041.0219343014853, "octw1": 1030.6117149584707, "octw2": 1020.3055978088856, "octw3": 1010.1025418307969, "octw4": 1000.001516412489, "novw1": 990.001501248364, "novw2": 980.1014862358803, "novw3": 970.3004713735214, "novw4": 960.5974666597862, "novw5": 950.9914919931883, "decw1": 941.4815770732564, "decw2": 932.0667613025239, "decw3": 922.7460936894987, "decw4": 913.5186327526037 }, { "columnValue": "Calculation", "secondValue": "Single Expotential Smoothing", "janw1": 968.10258845916, "janw2": 984.9160703428199, "janw3": 840.6740941830001, "janw4": 979.6065497479799, "febw1": 692.8924376266199, "febw2": 957.4835472694799, "febw3": 784.9241279371798, "febw4": 1335.3444296022599, "marchw1": 1111.4596445198397, "marchw2": 1222.6056089718236, "marchw3": 1344.8661698690064, "marchw4": 1479.352786855907, "marchw5": 769.2167961774448, "aprilw1": 917.670269625417, "aprilw2": 947.4397041442411, "aprilw3": 1042.1836745586652, "aprilw4": 1061.01919886886, "mayw1": 997.30495173078, "mayw2": 1114.9993249164, "mayw3": 1226.49925740804, "mayw4": 1349.149183148844, "mayw5": 1484.0641014637285, "junew1": 1632.4705116101015, "junew2": 1795.7175627711117, "junew3": 1049.5152375800399, "junew4": 1049.5152375800399, "julyw1": 1154.4667613380439, "julyw2": 984.0311502436798, "julyw3": 1020.3128743084201, "julyw4": 1122.3441617392623, "augw1": 1234.5785779131888, "augw2": 1025.62239490326, "augw3": 1727.3640335212797, "augw4": 1554.627630169152, "augw5": 1399.1648671522364, "sepw1": 1259.248380437013, "sepw2": 1133.3235423933115, "sepw3": 1019.9911881539806, "sepw4": 1009.7912762724407, "octw1": 999.6933635097164, "octw2": 989.6964298746191, "octw3": 979.7994655758729, "octw4": 970.0014709201142, "novw1": 960.301456210913, "novw2": 950.698441648804, "novw3": 941.1914572323158, "novw4": 931.7795426599926, "novw5": 922.4617472333927, "decw1": 913.2371297610588, "decw2": 904.1047584634482, "decw3": 895.0637108788137, "decw4": 886.1130737700255 }, { "columnValue": "Calculation", "secondValue": "Adaptive Smoothing", "janw1": 957.7188993399999, "janw2": 974.3520429299999, "janw3": 831.6571794999999, "janw4": 969.0994712699999, "febw1": 685.4606016299999, "febw2": 947.2137560199998, "febw3": 776.5051770699998, "febw4": 1321.0217724899996, "marchw1": 1099.5383341599997, "marchw2": 1209.4921675759997, "marchw3": 1330.4413843336, "marchw4": 1463.48552276696, "marchw5": 760.9663192424999, "aprilw1": 907.8275082204999, "aprilw2": 937.2776412965, "aprilw3": 1031.0054054261502, "aprilw4": 1049.63890339, "mayw1": 986.6080434699999, "mayw2": 1103.0400486, "mayw3": 1213.34405346, "mayw4": 1334.678458806, "mayw5": 1468.1463046866002, "junew1": 1614.9609351552604, "junew2": 1776.4570286707863, "junew3": 1038.25833146, "junew4": 1038.25833146, "julyw1": 1142.0841646059998, "julyw2": 973.4766143199998, "julyw3": 1009.3691873299999, "julyw4": 1110.3061060630002, "augw1": 1221.3367166693004, "augw2": 1014.6217589899999, "augw3": 1708.8366467199999, "augw4": 1537.952982048, "augw5": 1384.1576838432, "sepw1": 1245.7419154588797, "sepw2": 1121.1677239129917, "sepw3": 1009.0509515216928, "sepw4": 998.9604420064757, "octw1": 988.9708375864111, "octw2": 979.0811292105468, "octw3": 969.2903179184414, "octw4": 959.597414739257, "novw1": 950.0014405918645, "novw2": 940.5014261859458, "novw3": 931.0964119240862, "novw4": 921.7854478048453, "novw5": 912.5675933267968, "decw1": 903.4419173935289, "decw2": 894.4074982195935, "decw3": 885.4634232373977, "decw4": 876.6087890050237 }, { "columnValue": "Calculation", "secondValue": "Holts Linear Trend", "janw1": 1108.93767292, "janw2": 1128.1971023400001, "janw3": 962.971471, "janw4": 1122.11517726, "febw1": 793.69122294, "febw2": 1096.7738227599998, "febw3": 899.11125766, "febw4": 1529.60415762, "marchw1": 1273.14965008, "marchw2": 1400.4646150879998, "marchw3": 1540.5110765968002, "marchw4": 1694.5621842564804, "marchw5": 881.118895965, "aprilw1": 1051.168693729, "aprilw2": 1085.2688478170003, "aprilw3": 1193.7957325987004, "aprilw4": 1215.37136182, "mayw1": 1142.3882608600002, "mayw2": 1277.2042668000001, "mayw3": 1404.9246934799999, "mayw4": 1545.417162828, "mayw5": 1699.9588791108001, "junew1": 1869.9547670218806, "junew2": 2056.9502437240685, "junew3": 1202.1938574800001, "junew4": 1202.1938574800001, "julyw1": 1322.413243228, "julyw2": 1127.1834481600001, "julyw3": 1168.7432695400003, "julyw4": 1285.6175964940003, "augw1": 1414.1793561434006, "augw2": 1174.82519462, "augw3": 1978.65295936, "augw4": 1780.7876634240001, "augw5": 1602.7088970815998, "sepw1": 1442.43800737344, "sepw2": 1298.194206636096, "sepw3": 1168.3747859724867, "sepw4": 1156.6910381127614, "octw1": 1145.1241277316342, "octw2": 1133.6728864543174, "octw3": 1122.3361575897745, "octw4": 1111.1127960138767, "novw1": 1100.0016680537378, "novw2": 1089.0016513732003, "novw3": 1078.1116348594683, "novw4": 1067.3305185108736, "novw5": 1056.6572133257648, "decw1": 1046.0906411925073, "decw2": 1035.629734780582, "decw3": 1025.2734374327765, "decw4": 1015.0207030584486 }, { "columnValue": "Calculation", "secondValue": "Period Percentage Change", "janw1": 1018.2064087719999, "janw2": 1035.890066694, "janw3": 884.1828961, "janw4": 1030.305753666, "febw1": 728.7528501539999, "febw2": 1007.0377827159999, "febw3": 825.5476093059999, "febw4": 1404.454726542, "marchw1": 1168.9828605279997, "marchw2": 1285.8811465807999, "marchw3": 1414.4692612388799, "marchw4": 1555.9161873627681, "marchw5": 809.0273499315, "aprilw1": 965.1639824239, "aprilw2": 996.4741239047, "aprilw3": 1096.1215362951702, "aprilw4": 1115.931886762, "mayw1": 1048.920130426, "mayw2": 1172.7057358799998, "mayw3": 1289.976309468, "mayw4": 1418.9739404148002, "mayw5": 1560.87133445628, "junew1": 1716.9584679019083, "junew2": 1888.6543146920992, "junew3": 1103.8325418680001, "junew4": 1103.8325418680001, "julyw1": 1214.2157960548, "julyw2": 1034.9593478559998, "julyw3": 1073.118820214, "julyw4": 1180.4307022354003, "augw1": 1298.4737724589404, "augw2": 1078.703133242, "augw3": 1816.7631717759998, "augw4": 1635.0868545984, "augw5": 1471.5781691385598, "sepw1": 1324.420352224704, "sepw2": 1191.9783170022333, "sepw3": 1072.7804853020104, "sepw4": 1062.05268044899, "octw1": 1051.4321536445004, "octw2": 1040.917832108055, "octw3": 1030.5086537869747, "octw4": 1020.2035672491049, "novw1": 1010.0015315766138, "novw2": 999.9015162608476, "novw3": 989.902501098239, "novw4": 980.0034760872567, "novw5": 970.203441326384, "decw1": 960.5014069131203, "decw2": 950.896392843989, "decw3": 941.3874289155491, "decw4": 931.9735546263937 }, { "columnValue": "Calculation", "secondValue": "Seasonal Smoothing Method", "janw1": 1008.02434468428, "janw2": 1025.53116602706, "janw3": 875.341067139, "janw4": 1020.0026961293398, "febw1": 721.4653216524598, "febw2": 996.96740488884, "febw3": 817.2921332129399, "febw4": 1390.4101792765798, "marchw1": 1157.29303192272, "marchw2": 1273.0223351149916, "marchw3": 1400.3245686264913, "marchw4": 1540.3570254891404, "marchw5": 800.9370764321849, "aprilw1": 955.5123425996609, "aprilw2": 986.5093826656531, "aprilw3": 1085.1603209322184, "aprilw4": 1104.77256789438, "mayw1": 1038.4309291217398, "mayw2": 1160.9786785212002, "mayw3": 1277.0765463733198, "mayw4": 1404.7842010106522, "mayw5": 1545.2626211117176, "junew1": 1699.7888832228896, "junew2": 1869.7677715451784, "junew3": 1092.79421644932, "junew4": 1092.79421644932, "julyw1": 1202.073638094252, "julyw2": 1024.60975437744, "julyw3": 1062.38763201186, "julyw4": 1168.6263952130462, "augw1": 1285.489034734351, "augw2": 1067.91610190958, "augw3": 1798.59554005824, "augw4": 1618.735986052416, "augw5": 1456.8623874471743, "sepw1": 1311.1761487024569, "sepw2": 1180.0585338322112, "sepw3": 1062.0526804489903, "sepw4": 1051.4321536445002, "octw1": 1040.9178321080553, "octw2": 1030.5086537869745, "octw3": 1020.2035672491048, "octw4": 1010.0015315766138, "novw1": 999.9015162608476, "novw2": 989.9025010982391, "novw3": 980.0034760872567, "novw4": 970.203441326384, "novw5": 960.5014069131203, "decw1": 950.896392843989, "decw2": 941.3874289155491, "decw3": 931.9735546263937, "decw4": 922.6538190801298 }, { "columnValue": "Calculation", "secondValue": "Seasonal Smoothing Average", "janw1": 977.7836143437515, "janw2": 994.7652310462481, "janw3": 849.0808351248301, "janw4": 989.4026152454597, "febw1": 699.8213620028861, "febw2": 967.0583827421747, "febw3": 792.7733692165516, "febw4": 1348.6978738982825, "marchw1": 1122.5742409650381, "marchw2": 1234.8316650615418, "marchw3": 1358.3148315676965, "marchw4": 1494.146314724466, "marchw5": 776.9089641392193, "aprilw1": 926.8469723216712, "aprilw2": 956.9141011856835, "aprilw3": 1052.6055113042519, "aprilw4": 1071.6293908575487, "mayw1": 1007.2780012480878, "mayw2": 1126.149318165564, "mayw3": 1238.7642499821204, "mayw4": 1362.6406749803325, "mayw5": 1498.9047424783657, "junew1": 1648.7952167262026, "junew2": 1813.674738398823, "junew3": 1060.0103899558403, "junew4": 1060.0103899558403, "julyw1": 1166.0114289514243, "julyw2": 993.8714617461167, "julyw3": 1030.5160030515042, "julyw4": 1133.567603356655, "augw1": 1246.9243636923206, "augw2": 1035.8786188522927, "augw3": 1744.6376738564925, "augw4": 1570.1739064708436, "augw5": 1413.1565158237588, "sepw1": 1271.8408642413833, "sepw2": 1144.6567778172446, "sepw3": 1030.1911000355203, "sepw4": 1019.889189035165, "octw1": 1009.6902971448136, "octw2": 999.5933941733653, "octw3": 989.5974602316317, "octw4": 979.7014856293154, "novw1": 969.9044707730221, "novw2": 960.205426065292, "novw3": 950.603371804639, "novw4": 941.0973380865925, "novw5": 931.6863647057266, "decw1": 922.3695010586694, "decw2": 913.1458060480827, "decw3": 904.0143479876018, "decw4": 894.9742045077257 }, { "columnValue": "Calculation", "secondValue": "Seasonal Percentage Change", "janw1": 967.2960883333999, "janw2": 984.0955633593, "janw3": 839.9737512949998, "janw4": 978.7904659826999, "febw1": 692.3152076462999, "febw2": 956.6858935801998, "febw3": 784.2702288406998, "febw4": 1334.2319902148997, "marchw1": 1110.5337175015998, "marchw2": 1221.5870892517596, "marchw3": 1343.745798176936, "marchw4": 1478.1203779946295, "marchw5": 768.575982434925, "aprilw1": 916.9057833027049, "aprilw2": 946.6504177094649, "aprilw3": 1041.3154594804116, "aprilw4": 1060.1352924239, "mayw1": 996.4741239046999, "mayw2": 1114.070449086, "mayw3": 1225.4774939945999, "mayw4": 1348.02524339406, "mayw5": 1482.827767733466, "junew1": 1631.110544506813, "junew2": 1794.221598957494, "junew3": 1048.6409147745999, "junew4": 1048.6409147745999, "julyw1": 1153.5050062520597, "julyw2": 983.2113804631998, "julyw3": 1019.4628792033, "julyw4": 1121.4091671236304, "augw1": 1233.5500838359933, "augw2": 1024.7679765798998, "augw3": 1725.9250131872, "augw4": 1553.33251186848, "augw5": 1397.999260681632, "sepw1": 1258.1993346134684, "sepw2": 1132.3794011521218, "sepw3": 1019.1414610369097, "sepw4": 1008.9500464265404, "octw1": 998.8605459622752, "octw2": 988.8719405026523, "octw3": 978.9832210976258, "octw4": 969.1933888866496, "novw1": 959.5014549977832, "novw2": 949.9064404478053, "novw3": 940.4073760433271, "novw4": 931.0033022828937, "novw5": 921.6932692600648, "decw1": 912.4763365674642, "decw2": 903.3515732017895, "decw3": 894.3180574697717, "decw4": 885.374876895074 }, { "columnValue": "Calculation", "secondValue": "Additive Decomposition", "janw1": 1120.0270496492, "janw2": 1139.4790733634002, "janw3": 972.60118571, "janw4": 1133.3363290326001, "febw1": 801.6281351694, "febw2": 1107.7415609875998, "febw3": 908.1023702366, "febw4": 1544.9001991962, "marchw1": 1285.8811465807999, "marchw2": 1414.4692612388799, "marchw3": 1555.9161873627681, "marchw4": 1711.5078060990452, "marchw5": 889.93008492465, "aprilw1": 1061.6803806662901, "aprilw2": 1096.1215362951702, "aprilw3": 1205.7336899246875, "aprilw4": 1227.5250754382, "mayw1": 1153.8121434686002, "mayw2": 1289.9763094680002, "mayw3": 1418.9739404148, "mayw4": 1560.87133445628, "mayw5": 1716.958467901908, "junew1": 1888.6543146920994, "junew2": 2077.5197461613093, "junew3": 1214.2157960548002, "junew4": 1214.2157960548002, "julyw1": 1335.63737566028, "julyw2": 1138.4552826416002, "julyw3": 1180.4307022354003, "julyw4": 1298.4737724589404, "augw1": 1428.3211497048346, "augw2": 1186.5734465662001, "augw3": 1998.4394889536002, "augw4": 1798.5955400582402, "augw5": 1618.735986052416, "sepw1": 1456.8623874471746, "sepw2": 1311.1761487024569, "sepw3": 1180.0585338322117, "sepw4": 1168.257948493889, "octw1": 1156.5753690089505, "octw2": 1145.0096153188606, "octw3": 1133.5595191656723, "octw4": 1122.2239239740154, "novw1": 1111.0016847342752, "novw2": 1099.8916678869323, "novw3": 1088.892751208063, "novw4": 1078.0038236959824, "novw5": 1067.2237854590226, "decw1": 1056.5515476044325, "decw2": 1045.986032128388, "decw3": 1035.5261718071042, "decw4": 1025.170910089033 }, { "columnValue": "Calculation", "secondValue": "Winters Additive", "janw1": 1028.38847285972, "janw2": 1046.24896736094, "janw3": 893.024725061, "janw4": 1040.60881120266, "febw1": 736.0403786555399, "febw2": 1017.1081605431599, "febw3": 833.8030853990599, "febw4": 1418.49927380742, "marchw1": 1180.6726891332796, "marchw2": 1298.7399580466079, "marchw3": 1428.6139538512687, "marchw4": 1571.475349236396, "marchw5": 817.117623430815, "aprilw1": 974.8156222481391, "aprilw2": 1006.4388651437471, "aprilw3": 1107.0827516581219, "aprilw4": 1127.09120562962, "mayw1": 1059.40933173026, "mayw2": 1184.4327932387998, "mayw3": 1302.87607256268, "mayw4": 1433.1636798189481, "mayw5": 1576.4800478008428, "junew1": 1734.1280525809275, "junew2": 1907.5408578390202, "junew3": 1114.87086728668, "junew4": 1114.87086728668, "julyw1": 1226.357954015348, "julyw2": 1045.30894133456, "julyw3": 1083.8500084161399, "julyw4": 1192.2350092577544, "augw1": 1311.4585101835298, "augw2": 1089.4901645744199, "augw3": 1834.9308034937599, "augw4": 1651.4377231443839, "augw5": 1486.2939508299455, "sepw1": 1337.664555746951, "sepw2": 1203.8981001722557, "sepw3": 1083.5082901550306, "sepw4": 1072.6732072534799, "octw1": 1061.9464751809455, "octw2": 1051.3270104291357, "octw3": 1040.8137403248445, "octw4": 1030.405602921596, "novw1": 1020.10154689238, "novw2": 1009.9005314234561, "novw3": 999.8015261092214, "novw4": 989.8035108481292, "novw5": 979.9054757396478, "decw1": 970.1064209822515, "decw2": 960.405356772429, "decw3": 950.8013032047046, "decw4": 941.2932901726576 }]
    this.rowList = this.rowList.map(row => ({
      ...row,
      secondValue: row.secondValue ? row.secondValue.trim() : row.secondValue
    }));
    this.tempList = JSON.parse(JSON.stringify(this.rowList));
    this.calculateListValues();
  }
  public calculateListValues = (event?, changedList?) => {
    if (event) {
      const index = this.rowList.findIndex(row => row.secondValue === event.data.secondValue && row.columnValue === event.data.columnValue);
      if (index > -1) {
        event.newValue = +event.newValue;
        this.tempList[index][event.colDef.field] = Number(event.newValue);
      }
    }

    this.tempList.forEach(row => {

      const sellThroughFlag = (row.secondValue === 'Algo Final Fcst (ST)'
        || row.secondValue === 'FB Channel Ops Manual Adjustment Fcst (ST)')
        && row.columnValue === 'Sell-Through';
      const sellThroughVarianceFlag = row.secondValue === 'Sell-Through Variance';
      const sellThroughAccuracyFlag = row.secondValue === 'Sell-Through Accuracy';
      const sellInVarianceFlag = row.secondValue === 'Sell In Variance';
      const sellInAccuracyFlag = row.secondValue === 'Sell In Accuracy';
      const sellInInventoryFlag = row.secondValue === 'Sell In Inventory' && (row.secondValue === 'Customer Target Inventory OH'
        || row.secondValue === 'Projected WOS');
      if (sellThroughFlag || sellThroughVarianceFlag || sellThroughAccuracyFlag || sellInVarianceFlag || sellInAccuracyFlag || sellInInventoryFlag) {
        Object.keys(row).forEach(key => {
          if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue') {
            row[key] = 0;
          }
        });
      }
    });
    this.tempList.forEach(row => {
      const sellThroughFlag = (row.secondValue === 'Algo Final Fcst (ST)'
        || row.secondValue === 'FB Channel Ops Manual Adjustment Fcst (ST)')
        && row.columnValue === 'Sell-Through';
      const sellThroughVarianceFlag = row.columnValue === 'Sell-Through Variance';
      const sellThroughAccuracyFlag = row.columnValue === 'Sell-Through Accuracy';
      const sellInVarianceFlag = row.columnValue === 'Sell In Variance';
      const sellInAccuracyFlag = row.columnValue === 'Sell In Accuracy';
      const sellInInventoryFlag = row.columnValue === 'Sell In Inventory' && (row.secondValue === 'Customer Target Inventory OH'
        || row.secondValue === 'Projected WOS');
      // const selectedColumnList = this.chooserList.filter(row => !row.checked).map(el => el.name);
      const selectedColumnList = [];
      if (sellThroughFlag && row.secondValue === 'Algo Final Fcst (ST)') {
        // Algo Final Fcst (ST)
        let list = ['Algo Base Fcst (ST)', 'Algo Promo lift (ST)', 'Linear',
          'Curve',
          'Exponential',
          'Logarithmic',
          'Power',
          'Parabola',
          'Moving Average',
          'Single Expotential Smoothing',
          'Adaptive Smoothing',
          'Holts Linear Trend',
          'Period Percentage Change',
          'Seasonal Smoothing Method',
          'Seasonal Smoothing Average',
          'Seasonal Percentage Change',
          'Additive Decomposition',
          'Winters Additive'];
        if (selectedColumnList.length > 0) {
          list = list.filter(item => !selectedColumnList.includes(item));
        }
        let toFindList = changedList ? changedList : this.tempList;
        const calculationList = toFindList.filter(item => list.includes(item.secondValue) && item.columnValue !== 'Calculation');
        calculationList.forEach(element => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              row[key] = +row[key];
              element[key] = element[key] ? +element[key] : 0;
              row[key] += +element[key];
            }
          });
        });
        calculationList.forEach(element => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (flag) {
                row[key] = +row[key];
                element[key] = element[key] ? +element[key] : 0;
                row[key] += +element[key];
              }
            }
          });
        });
      }
      // FB Channel Ops Manual Adjustment Fcst (ST)
      if (sellThroughFlag && row.secondValue === 'FB Channel Ops Manual Adjustment Fcst (ST)') {
        let channelList = ['Algo Final Fcst (ST)', 'FB Channel Ops Fcst (ST)'];
        if (selectedColumnList.length > 0) {
          channelList = channelList.filter(item => !selectedColumnList.includes(item));
        }
        let toColumnFindList = changedList ? changedList : this.tempList;
        const calculationColumnList = toColumnFindList.filter(item => channelList.includes(item.secondValue));
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              row[key] = +row[key];
              if (index < calculationColumnList.length - 1) {
                calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                row[key] = calculationColumnList[index + 1][key] - calculationColumnList[index][key];
              }

            }
          });
        });
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (flag) {
                row[key] = +row[key];
                if (index < calculationColumnList.length - 1) {
                  calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                  calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                  row[key] = calculationColumnList[index + 1][key] - calculationColumnList[index][key];
                }
              }
            }
          });
        });
      }
      if (sellThroughVarianceFlag && row.secondValue === 'Algo Fcst to Consensus (ST Var)') {
        let channelList = ['Algo Final Fcst (ST)', 'FB Consensus Fcst (ST)',];
        if (selectedColumnList.length > 0) {
          channelList = channelList.filter(item => !selectedColumnList.includes(item));
        }
        let toColumnFindList = changedList ? changedList : this.tempList;
        const calculationColumnList = toColumnFindList.filter(item => channelList.includes(item.secondValue));
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              row[key] = +row[key];
              if (index < calculationColumnList.length - 1) {
                calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                row[key] = calculationColumnList[index][key] - calculationColumnList[index + 1][key];
              }

            }
          });
        });
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (flag) {
                row[key] = +row[key];
                if (index < calculationColumnList.length - 1) {
                  calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                  calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                  row[key] = calculationColumnList[index + 1][key] - calculationColumnList[index][key];
                }
              }
            }
          });
        });
      }
      if (sellThroughVarianceFlag && row.secondValue === 'Algo Fcst to Actual (ST Var)') {
        let channelList = ['Algo Final Fcst (ST)', 'TY Actual (ST)',];
        if (selectedColumnList.length > 0) {
          channelList = channelList.filter(item => !selectedColumnList.includes(item));
        }
        let toColumnFindList = changedList ? changedList : this.tempList;
        const calculationColumnList = toColumnFindList.filter(item => channelList.includes(item.secondValue));
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              row[key] = +row[key];
              if (index < calculationColumnList.length - 1) {
                calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                row[key] = calculationColumnList[index][key] - calculationColumnList[index + 1][key];
              }

            }
          });
        });
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (flag) {
                row[key] = +row[key];
                if (index < calculationColumnList.length - 1) {
                  calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                  calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                  row[key] = calculationColumnList[index + 1][key] - calculationColumnList[index][key];
                }
              }
            }
          });
        });
      }
      if (sellThroughVarianceFlag && row.secondValue === 'Customer ST Fcst to Actual (ST Var)') {
        let channelList = ['Customer Fcst (ST)', 'TY Actual (ST)',];
        if (selectedColumnList.length > 0) {
          channelList = channelList.filter(item => !selectedColumnList.includes(item));
        }
        let toColumnFindList = changedList ? changedList : this.tempList;
        const calculationColumnList = toColumnFindList.filter(item => channelList.includes(item.secondValue));
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              row[key] = +row[key];
              if (index < calculationColumnList.length - 1) {
                calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                row[key] = calculationColumnList[index][key] - calculationColumnList[index + 1][key];
              }

            }
          });
        });
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (flag) {
                row[key] = +row[key];
                if (index < calculationColumnList.length - 1) {
                  calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                  calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                  row[key] = calculationColumnList[index + 1][key] - calculationColumnList[index][key];
                }
              }
            }
          });
        });
      }
      if (sellThroughVarianceFlag && row.secondValue === 'FB Channel Ops Fcst to Actual (ST Var)') {
        let channelList = ['FB Channel Ops Fcst (ST)', 'TY Actual (ST)',];
        if (selectedColumnList.length > 0) {
          channelList = channelList.filter(item => !selectedColumnList.includes(item));
        }
        let toColumnFindList = changedList ? changedList : this.tempList;
        const calculationColumnList = toColumnFindList.filter(item => channelList.includes(item.secondValue));
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              row[key] = +row[key];
              if (index < calculationColumnList.length - 1) {
                calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                row[key] = calculationColumnList[index][key] - calculationColumnList[index + 1][key];
              }

            }
          });
        });
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (flag) {
                row[key] = +row[key];
                if (index < calculationColumnList.length - 1) {
                  calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                  calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                  row[key] = calculationColumnList[index + 1][key] - calculationColumnList[index][key];
                }
              }
            }
          });
        });
      }
      if (sellThroughVarianceFlag && row.secondValue === 'FB CDP to Actual (ST Var)') {
        let channelList = ['FB CDP (ST)', 'TY Actual (ST)',];
        if (selectedColumnList.length > 0) {
          channelList = channelList.filter(item => !selectedColumnList.includes(item));
        }
        let toColumnFindList = changedList ? changedList : this.tempList;
        const calculationColumnList = toColumnFindList.filter(item => channelList.includes(item.secondValue));
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              row[key] = +row[key];
              if (index < calculationColumnList.length - 1) {
                calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                row[key] = calculationColumnList[index][key] - calculationColumnList[index + 1][key];
              }

            }
          });
        });
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (flag) {
                row[key] = +row[key];
                if (index < calculationColumnList.length - 1) {
                  calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                  calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                  row[key] = calculationColumnList[index + 1][key] - calculationColumnList[index][key];
                }
              }
            }
          });
        });
      }
      if (sellThroughVarianceFlag && row.secondValue === 'FB UDP to Actual (ST Var)') {
        let channelList = ['FB UDP (ST)', 'TY Actual (ST)',];
        if (selectedColumnList.length > 0) {
          channelList = channelList.filter(item => !selectedColumnList.includes(item));
        }
        let toColumnFindList = changedList ? changedList : this.tempList;
        const calculationColumnList = toColumnFindList.filter(item => channelList.includes(item.secondValue));
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              row[key] = +row[key];
              if (index < calculationColumnList.length - 1) {
                calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                row[key] = calculationColumnList[index][key] - calculationColumnList[index + 1][key];
              }

            }
          });
        });
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (flag) {
                row[key] = +row[key];
                if (index < calculationColumnList.length - 1) {
                  calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                  calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                  row[key] = calculationColumnList[index + 1][key] - calculationColumnList[index][key];
                }
              }
            }
          });
        });
      }
      if (sellThroughVarianceFlag && row.secondValue === 'FB Consensus Fcst to Actual (ST Var)') {
        let channelList = ['FB Consensus Fcst (ST)', 'TY Actual (ST)',];
        if (selectedColumnList.length > 0) {
          channelList = channelList.filter(item => !selectedColumnList.includes(item));
        }
        let toColumnFindList = changedList ? changedList : this.tempList;
        const calculationColumnList = toColumnFindList.filter(item => channelList.includes(item.secondValue));
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              row[key] = +row[key];
              if (index < calculationColumnList.length - 1) {
                calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                row[key] = calculationColumnList[index][key] - calculationColumnList[index + 1][key];
              }

            }
          });
        });
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (flag) {
                row[key] = +row[key];
                if (index < calculationColumnList.length - 1) {
                  calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                  calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                  row[key] = calculationColumnList[index + 1][key] - calculationColumnList[index][key];
                }
              }
            }
          });
        });
      }

      if (sellThroughAccuracyFlag && row.secondValue === 'Algo Fcst vs. Act. (ST Acc)') {
        let channelList = ['Algo Final Fcst (ST)', 'TY Actual (ST)',];
        if (selectedColumnList.length > 0) {
          channelList = channelList.filter(item => !selectedColumnList.includes(item));
        }
        let toColumnFindList = changedList ? changedList : this.tempList;
        const calculationColumnList = toColumnFindList.filter(item => channelList.includes(item.secondValue));
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              row[key] = +row[key];
              if (index < calculationColumnList.length - 1) {
                calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                row[key] = (calculationColumnList[index][key] / calculationColumnList[index + 1][key]) * 100;
              }

            }
          });
        });
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (flag) {
                row[key] = +row[key];
                if (index < calculationColumnList.length - 1) {
                  calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                  calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                  row[key] = (calculationColumnList[index + 1][key] / calculationColumnList[index][key]) * 100;
                }
              }
            }
          });
        });
      }
      if (sellThroughAccuracyFlag && row.secondValue === 'Customer Fcst vs. Act. (ST Acc)') {
        let channelList = ['Customer Fcst (ST)', 'TY Actual (ST)',];
        if (selectedColumnList.length > 0) {
          channelList = channelList.filter(item => !selectedColumnList.includes(item));
        }
        let toColumnFindList = changedList ? changedList : this.tempList;
        const calculationColumnList = toColumnFindList.filter(item => channelList.includes(item.secondValue));
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              row[key] = +row[key];
              if (index < calculationColumnList.length - 1) {
                calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                row[key] = (calculationColumnList[index][key] / calculationColumnList[index + 1][key]) * 100;
              }

            }
          });
        });
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (flag) {
                row[key] = +row[key];
                if (index < calculationColumnList.length - 1) {
                  calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                  calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                  row[key] = calculationColumnList[index + 1][key] / calculationColumnList[index][key];
                }
              }
            }
          });
        });
      }
      if (sellThroughAccuracyFlag && row.secondValue === 'FB Channel Ops Fcst vs. Act. (ST Acc)') {
        let channelList = ['FB Channel Ops Fcst (ST)', 'TY Actual (ST)',];
        if (selectedColumnList.length > 0) {
          channelList = channelList.filter(item => !selectedColumnList.includes(item));
        }
        let toColumnFindList = changedList ? changedList : this.tempList;
        const calculationColumnList = toColumnFindList.filter(item => channelList.includes(item.secondValue));
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              row[key] = +row[key];
              if (index < calculationColumnList.length - 1) {
                calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                row[key] = (calculationColumnList[index][key] / calculationColumnList[index + 1][key]) * 100;
              }

            }
          });
        });
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (flag) {
                row[key] = +row[key];
                if (index < calculationColumnList.length - 1) {
                  calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                  calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                  row[key] = calculationColumnList[index + 1][key] / calculationColumnList[index][key];
                }
              }
            }
          });
        });
      }
      if (sellThroughAccuracyFlag && row.secondValue === 'FB UDP vs Act. (ST Acc)') {
        let channelList = ['FB UDP (ST)', 'TY Actual (ST)',];
        if (selectedColumnList.length > 0) {
          channelList = channelList.filter(item => !selectedColumnList.includes(item));
        }
        let toColumnFindList = changedList ? changedList : this.tempList;
        const calculationColumnList = toColumnFindList.filter(item => channelList.includes(item.secondValue));
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              row[key] = +row[key];
              if (index < calculationColumnList.length - 1) {
                calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                row[key] = (calculationColumnList[index][key] / calculationColumnList[index + 1][key]) * 100;
              }

            }
          });
        });
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (flag) {
                row[key] = +row[key];
                if (index < calculationColumnList.length - 1) {
                  calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                  calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                  row[key] = calculationColumnList[index + 1][key] / calculationColumnList[index][key];
                }
              }
            }
          });
        });
      }
      if (sellThroughAccuracyFlag && row.secondValue === 'FB ODP vs. Act. (ST Acc)') {
        let channelList = ['FB CDP (ST)', 'TY Actual (ST)',];
        if (selectedColumnList.length > 0) {
          channelList = channelList.filter(item => !selectedColumnList.includes(item));
        }
        let toColumnFindList = changedList ? changedList : this.tempList;
        const calculationColumnList = toColumnFindList.filter(item => channelList.includes(item.secondValue));
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              row[key] = +row[key];
              if (index < calculationColumnList.length - 1) {
                calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                row[key] = (calculationColumnList[index][key] / calculationColumnList[index + 1][key]) * 100;
              }

            }
          });
        });
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (flag) {
                row[key] = +row[key];
                if (index < calculationColumnList.length - 1) {
                  calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                  calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                  row[key] = calculationColumnList[index + 1][key] / calculationColumnList[index][key];
                }
              }
            }
          });
        });
      }
      if (sellThroughAccuracyFlag && row.secondValue === 'FB Consensus vs. Act. (ST Acc)') {
        let channelList = ['FB Consensus Fcst (ST)', 'TY Actual (ST)',];
        if (selectedColumnList.length > 0) {
          channelList = channelList.filter(item => !selectedColumnList.includes(item));
        }
        let toColumnFindList = changedList ? changedList : this.tempList;
        const calculationColumnList = toColumnFindList.filter(item => channelList.includes(item.secondValue));
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              row[key] = +row[key];
              if (index < calculationColumnList.length - 1) {
                calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                row[key] = (calculationColumnList[index][key] / calculationColumnList[index + 1][key]) * 100;
              }

            }
          });
        });
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (flag) {
                row[key] = +row[key];
                if (index < calculationColumnList.length - 1) {
                  calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                  calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                  row[key] = calculationColumnList[index + 1][key] / calculationColumnList[index][key];
                }
              }
            }
          });
        });
      }

      if (sellInInventoryFlag && row.secondValue === 'Customer Target Inventory OH') {
        let channelList = ['Customer TGT Inventory WOS', 'Customer Fcst (ST)',];
        if (selectedColumnList.length > 0) {
          channelList = channelList.filter(item => !selectedColumnList.includes(item));
        }
        let toColumnFindList = changedList ? changedList : this.tempList;
        const calculationColumnList = toColumnFindList.filter(item => channelList.includes(item.secondValue));
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              row[key] = +row[key];
              if (index < calculationColumnList.length - 1) {
                calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                row[key] = calculationColumnList[index][key] * calculationColumnList[index + 1][key];
              }

            }
          });
        });
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (flag) {
                row[key] = +row[key];
                if (index < calculationColumnList.length - 1) {
                  calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                  calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                  row[key] = calculationColumnList[index + 1][key] * calculationColumnList[index][key];
                }
              }
            }
          });
        });
      }
      if (sellInInventoryFlag && row.secondValue === 'Projected WOS') {
        let channelList = ['Customer Act. Total DC OH', 'TY Actual (ST)',];
        if (selectedColumnList.length > 0) {
          channelList = channelList.filter(item => !selectedColumnList.includes(item));
        }
        let toColumnFindList = changedList ? changedList : this.tempList;
        const calculationColumnList = toColumnFindList.filter(item => channelList.includes(item.secondValue));
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              row[key] = +row[key];
              if (index < calculationColumnList.length - 1) {
                calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                row[key] = (calculationColumnList[index][key] / calculationColumnList[index + 1][key]) * 100;
              }

            }
          });
        });
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (flag) {
                row[key] = +row[key];
                if (index < calculationColumnList.length - 1) {
                  calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                  calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                  row[key] = calculationColumnList[index + 1][key] / calculationColumnList[index][key];
                }
              }
            }
          });
        });
      }

      if (sellInVarianceFlag && row.secondValue === 'Algo Fcst to Override (SI Var)') {
        let channelList = ['Algo Total Fcst (SI)', 'FB Channel Ops Constrained Fcst (SI)',];
        if (selectedColumnList.length > 0) {
          channelList = channelList.filter(item => !selectedColumnList.includes(item));
        }
        let toColumnFindList = changedList ? changedList : this.tempList;
        const calculationColumnList = toColumnFindList.filter(item => channelList.includes(item.secondValue));
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              row[key] = +row[key];
              if (index < calculationColumnList.length - 1) {
                calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                row[key] = calculationColumnList[index][key] - calculationColumnList[index + 1][key];
              }

            }
          });
        });
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (flag) {
                row[key] = +row[key];
                if (index < calculationColumnList.length - 1) {
                  calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                  calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                  row[key] = calculationColumnList[index + 1][key] - calculationColumnList[index][key];
                }
              }
            }
          });
        });
      }
      if (sellInVarianceFlag && row.secondValue === 'Algo Fcst to Actual (SI Var)') {
        let channelList = ['Algo Total Fcst (SI)', 'Actual (SI)',];
        if (selectedColumnList.length > 0) {
          channelList = channelList.filter(item => !selectedColumnList.includes(item));
        }
        let toColumnFindList = changedList ? changedList : this.tempList;
        const calculationColumnList = toColumnFindList.filter(item => channelList.includes(item.secondValue));
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              row[key] = +row[key];
              if (index < calculationColumnList.length - 1) {
                calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                row[key] = calculationColumnList[index][key] - calculationColumnList[index + 1][key];
              }

            }
          });
        });
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (flag) {
                row[key] = +row[key];
                if (index < calculationColumnList.length - 1) {
                  calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                  calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                  row[key] = calculationColumnList[index + 1][key] - calculationColumnList[index][key];
                }
              }
            }
          });
        });
      }
      if (sellInVarianceFlag && row.secondValue === 'Customer Fcst to Actual (SI Var)') {
        let channelList = ['Customer Fcst (SI)', 'Actual (SI)',];
        if (selectedColumnList.length > 0) {
          channelList = channelList.filter(item => !selectedColumnList.includes(item));
        }
        let toColumnFindList = changedList ? changedList : this.tempList;
        const calculationColumnList = toColumnFindList.filter(item => channelList.includes(item.secondValue));
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              row[key] = +row[key];
              if (index < calculationColumnList.length - 1) {
                calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                row[key] = calculationColumnList[index][key] - calculationColumnList[index + 1][key];
              }

            }
          });
        });
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (flag) {
                row[key] = +row[key];
                if (index < calculationColumnList.length - 1) {
                  calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                  calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                  row[key] = calculationColumnList[index + 1][key] - calculationColumnList[index][key];
                }
              }
            }
          });
        });
      }
      if (sellInVarianceFlag && row.secondValue === 'FB Channel Ops Fcst to Actual (SI Var)') {
        let channelList = ['FB Channel Ops Unstrained Fcst (SI)', 'Actual (SI)',];
        if (selectedColumnList.length > 0) {
          channelList = channelList.filter(item => !selectedColumnList.includes(item));
        }
        let toColumnFindList = changedList ? changedList : this.tempList;
        const calculationColumnList = toColumnFindList.filter(item => channelList.includes(item.secondValue));
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              row[key] = +row[key];
              if (index < calculationColumnList.length - 1) {
                calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                row[key] = calculationColumnList[index][key] - calculationColumnList[index + 1][key];
              }

            }
          });
        });
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (flag) {
                row[key] = +row[key];
                if (index < calculationColumnList.length - 1) {
                  calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                  calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                  row[key] = calculationColumnList[index + 1][key] - calculationColumnList[index][key];
                }
              }
            }
          });
        });
      }
      if (sellInVarianceFlag && row.secondValue === 'FB CPFR Fcst to Actual (SI Var)') {
        let channelList = ['FB Channel Ops Constrained Fcst (SI)', 'Actual (SI)',];
        if (selectedColumnList.length > 0) {
          channelList = channelList.filter(item => !selectedColumnList.includes(item));
        }
        let toColumnFindList = changedList ? changedList : this.tempList;
        const calculationColumnList = toColumnFindList.filter(item => channelList.includes(item.secondValue));
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              row[key] = +row[key];
              if (index < calculationColumnList.length - 1) {
                calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                row[key] = calculationColumnList[index][key] - calculationColumnList[index + 1][key];
              }

            }
          });
        });
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (flag) {
                row[key] = +row[key];
                if (index < calculationColumnList.length - 1) {
                  calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                  calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                  row[key] = calculationColumnList[index + 1][key] - calculationColumnList[index][key];
                }
              }
            }
          });
        });
      }

      if (sellInAccuracyFlag && row.secondValue === 'Algo Fcst vs. Act. (SI Acc)') {
        let channelList = ['Algo Total Fcst (SI)', 'Actual (SI)',];
        if (selectedColumnList.length > 0) {
          channelList = channelList.filter(item => !selectedColumnList.includes(item));
        }
        let toColumnFindList = changedList ? changedList : this.tempList;
        const calculationColumnList = toColumnFindList.filter(item => channelList.includes(item.secondValue));
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              row[key] = +row[key];
              if (index < calculationColumnList.length - 1) {
                calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                row[key] = (calculationColumnList[index][key] / calculationColumnList[index + 1][key]) * 100;
              }

            }
          });
        });
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (flag) {
                row[key] = +row[key];
                if (index < calculationColumnList.length - 1) {
                  calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                  calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                  row[key] = calculationColumnList[index + 1][key] / calculationColumnList[index][key];
                }
              }
            }
          });
        });
      }
      if (sellInAccuracyFlag && row.secondValue === 'Customer Fcst vs. Act. (SI Acc)') {
        let channelList = ['Customer Fcst (SI)', 'Actual (SI)',];
        if (selectedColumnList.length > 0) {
          channelList = channelList.filter(item => !selectedColumnList.includes(item));
        }
        let toColumnFindList = changedList ? changedList : this.tempList;
        const calculationColumnList = toColumnFindList.filter(item => channelList.includes(item.secondValue));
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              row[key] = +row[key];
              if (index < calculationColumnList.length - 1) {
                calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                row[key] = (calculationColumnList[index][key] / calculationColumnList[index + 1][key]) * 100;
              }

            }
          });
        });
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (flag) {
                row[key] = +row[key];
                if (index < calculationColumnList.length - 1) {
                  calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                  calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                  row[key] = calculationColumnList[index + 1][key] / calculationColumnList[index][key];
                }
              }
            }
          });
        });
      }
      if (sellInAccuracyFlag && row.secondValue === 'FB Channel Ops Fcst vs. Act. (SI Acc)') {
        let channelList = ['FB Channel Ops Unstrained Fcst (SI)', 'Actual (SI)',];
        if (selectedColumnList.length > 0) {
          channelList = channelList.filter(item => !selectedColumnList.includes(item));
        }
        let toColumnFindList = changedList ? changedList : this.tempList;
        const calculationColumnList = toColumnFindList.filter(item => channelList.includes(item.secondValue));
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              row[key] = +row[key];
              if (index < calculationColumnList.length - 1) {
                calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                row[key] = (calculationColumnList[index][key] / calculationColumnList[index + 1][key]) * 100;
              }

            }
          });
        });
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (flag) {
                row[key] = +row[key];
                if (index < calculationColumnList.length - 1) {
                  calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                  calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                  row[key] = calculationColumnList[index + 1][key] / calculationColumnList[index][key];
                }
              }
            }
          });
        });
      }
      if (sellInAccuracyFlag && row.secondValue === 'FB CPFR Fcst vs. Act. (SI Acc)') {
        let channelList = ['FB Channel Ops Constrained Fcst (SI)', 'Actual (SI)',];
        if (selectedColumnList.length > 0) {
          channelList = channelList.filter(item => !selectedColumnList.includes(item));
        }
        let toColumnFindList = changedList ? changedList : this.tempList;
        const calculationColumnList = toColumnFindList.filter(item => channelList.includes(item.secondValue));
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              row[key] = +row[key];
              if (index < calculationColumnList.length - 1) {
                calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                row[key] = (calculationColumnList[index][key] / calculationColumnList[index + 1][key]) * 100;
              }

            }
          });
        });
        calculationColumnList.forEach((element, index) => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (flag) {
                row[key] = +row[key];
                if (index < calculationColumnList.length - 1) {
                  calculationColumnList[index][key] = calculationColumnList[index][key] ? +calculationColumnList[index][key] : 0;
                  calculationColumnList[index + 1][key] = calculationColumnList[index + 1][key] ? +calculationColumnList[index + 1][key] : 0;
                  row[key] = calculationColumnList[index + 1][key] / calculationColumnList[index][key];
                }
              }
            }
          });
        });
      }
      row['ttlJanuary'] = 0;
      row['ttlFebruary'] = 0;
      row['ttlMarch'] = 0;
      row['ttlApril'] = 0;
      row['ttlMay'] = 0;
      row['ttlJune'] = 0;
      row['ttlJuly'] = 0;
      row['ttlAugust'] = 0;
      row['ttlSeptember'] = 0;
      row['ttlOctober'] = 0;
      row['ttlNovember'] = 0;
      row['ttlDecember'] = 0;
      Object.keys(row).forEach(key => {
        const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
        if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && row.secondValue !== 'Notes' && columns.length < 1) {
          if (key.startsWith('jan')) {
            row['ttlJanuary'] += +row[key];
          }
          if (key.startsWith('feb')) {
            row['ttlFebruary'] += +row[key];
          }
          if (key.startsWith('march')) {
            row['ttlMarch'] += +row[key];
          }
          if (key.startsWith('april')) {
            row['ttlApril'] += +row[key];
          }
          if (key.startsWith('may')) {
            row['ttlMay'] += +row[key];
          }
          if (key.startsWith('june')) {
            row['ttlJune'] += +row[key];
          }
          if (key.startsWith('july')) {
            row['ttlJuly'] += +row[key];
          }
          if (key.startsWith('aug')) {
            row['ttlAugust'] += +row[key];
          }
          if (key.startsWith('sep')) {
            row['ttlSeptember'] += +row[key];
          }
          if (key.startsWith('oct')) {
            row['ttlOctober'] += +row[key];
          }
          if (key.startsWith('nov')) {
            row['ttlNovember'] += +row[key];
          }
          if (key.startsWith('dec')) {
            row['ttlDecember'] += +row[key];
          }
          row['q1'] = row['ttlJanuary'] + row['ttlFebruary'] + row['ttlMarch'];
          row['q2'] = row['ttlApril'] + row['ttlMay'] + row['ttlJune'];
          row['q3'] = row['ttlJuly'] + row['ttlAugust'] + row['ttlSeptember'];
          row['q4'] = row['ttlOctober'] + row['ttlNovember'] + row['ttlDecember'];
          row['totalYear'] = row['q1'] + row['q2'] + row['q3'] + row['q4'];
        }
        if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && row.secondValue !== 'Notes' && columns.length > 0) {
          const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
          if (key.startsWith('jan') && flag) {
            row['ttlJanuary'] += +row[key];
          }
          if (key.startsWith('feb') && flag) {
            row['ttlFebruary'] += +row[key];
          }
          if (key.startsWith('march') && flag) {
            row['ttlMarch'] += +row[key];
          }
          if (key.startsWith('april') && flag) {
            row['ttlApril'] += +row[key];
          }
          if (key.startsWith('may') && flag) {
            row['ttlMay'] += +row[key];
          }
          if (key.startsWith('june') && flag) {
            row['ttlJune'] += +row[key];
          }
          if (key.startsWith('july') && flag) {
            row['ttlJuly'] += +row[key];
          }
          if (key.startsWith('aug') && flag) {
            row['ttlAugust'] += +row[key];
          }
          if (key.startsWith('sep') && flag) {
            row['ttlSeptember'] += +row[key];
          }
          if (key.startsWith('oct') && flag) {
            row['ttlOctober'] += +row[key];
          }
          if (key.startsWith('nov') && flag) {
            row['ttlNovember'] += +row[key];
          }
          if (key.startsWith('dec') && flag) {
            row['ttlDecember'] += +row[key];
          }
          row['q1'] = row['ttlJanuary'] + row['ttlFebruary'] + row['ttlMarch'];
          row['q2'] = row['ttlApril'] + row['ttlMay'] + row['ttlJune'];
          row['q3'] = row['ttlJuly'] + row['ttlAugust'] + row['ttlSeptember'];
          row['q4'] = row['ttlOctober'] + row['ttlNovember'] + row['ttlDecember'];
          row['totalYear'] = row['q1'] + row['q2'] + row['q3'] + row['q4'];
          if (row.secondValue === 'Seasonality') {
            row['ttlJanuary'] = +row['ttlJanuary'].toFixed(2);
            row['ttlFebruary'] = +row['ttlFebruary'].toFixed(2);
            row['ttlMarch'] = +row['ttlMarch'].toFixed(2);
            row['ttlApril'] = +row['ttlApril'].toFixed(2);
            row['ttlMay'] = +row['ttlMay'].toFixed(2);
            row['ttlJune'] = +row['ttlJune'].toFixed(2);
            row['ttlJuly'] = +row['ttlJuly'].toFixed(2);
            row['ttlAugust'] = +row['ttlAugust'].toFixed(2);
            row['ttlSeptember'] = +row['ttlSeptember'].toFixed(2);
            row['ttlOctober'] = +row['ttlOctober'].toFixed(2);
            row['ttlNovember'] = +row['ttlNovember'].toFixed(2);
            row['ttlDecember'] = +row['ttlDecember'].toFixed(2);
            row['q1'] = +row['q1'].toFixed(2);
            row['q2'] = +row['q2'].toFixed(2);
            row['q3'] = +row['q3'].toFixed(2);
            row['q4'] = +row['q4'].toFixed(2);
          }
        }
      });
    });
    // const selectedColumnList = this.chooserList.filter(row => !row.checked).map(el => el.name);
    const selectedColumnList = [];
    let list = this.tempList;
    if (selectedColumnList.length > 0) {
      list = this.tempList.filter(row => !selectedColumnList.includes(row.secondValue));
    }
    for (let index = 0; index < list.length; index++) {
      Object.keys(list[index]).forEach(key => {
        if (!isNaN(list[index][key])) {
          if (list[index].secondValue !== 'Seasonality') {
            list[index][key] = list[index][key] ? Number(list[index][key]).toFixed(0) : 0;
          }
        }
      })
    }
    list = list.filter(row => row.columnValue !== 'Calculation');
    setTimeout(() => {
      if (this.gridOptions && this.gridOptions.api) {
        this.gridOptions.api.setRowData(list);
      }
    }, 100);
    for (let index = 0; index < this.rowList.length; index++) {
      Object.keys(this.rowList[index]).forEach(key => {
        if (!isNaN(this.rowList[index][key])) {
          if (this.rowList[index].secondValue !== 'Seasonality') {
            this.rowList[index][key] = this.rowList[index][key] ? Number(this.rowList[index][key]).toFixed(0) : 0;
          }
        }
      })
    }
    const graphList = [];
    this.chooserList.forEach(row => {
      if (row.checked) {
        const element = list.find(el => el.secondValue === row.name);
        if (element) {
          graphList.push(element);
        }
      }
    });
    if (graphList.length > 0) {
      this.applyGraph(graphList);

    }
    // this.rowList = list;
  }
  getSeries = (object) => {
    const objList = [];
    Object.keys(object).forEach(key => {
      if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue') {
        const newObject = {
          name: key,
          value: Number(object[key])
        }
        objList.push(newObject)
      }
    });
    return objList;
  }
  openExcelImportDialog(data, templateRef?: TemplateRef<any>): void {
    this.dialogRef = this.dialog.open(this.excelImport, { width: '500px', data: data || {} });
  }
  onCellValueChanged = (value) => {
    this.calculateListValues(value);
  }
  onFilterTextBoxChanged(event) {
    this.gridOptions.api.setQuickFilter(event.target.value);
  }
  onGridReady(params) {
    this.gridApi = params.api;
  }
  public onSubmit = () => {
  }
  selectAllSelected(flag: boolean): void {
    if (flag) {
      this.chooserList = this.chooserList.map(row => ({ ...row, checked: true }))
    } else {
      this.chooserList = this.chooserList.map(row => ({ ...row, checked: false }))
    }
  }
  public onSave = () => {
    // let newColumnDefs = this.columnDefs.filter(column => column.show);
    // const cols = JSON.parse(JSON.stringify(this.tempColDefs));
    // const list = cols.map(column => {
    //   if (column.children) {
    //     column.children = column.children.filter(col => col.show);
    //     column.children = column.children.map(col => ({ ...col, editable: params => { return params.data['secondValue'] !== 'Total Forecast' } }))
    //   }
    //   return column;
    // });
    // newColumnDefs = newColumnDefs.length > 0 ? list.push(...newColumnDefs) : list as any;
    // this.gridOptions.api.setColumnDefs(newColumnDefs);
    this.calculateListValues();
    this.dialogRef.close();
  }
  onSelect(event) {
    console.log(event);
    this.files.push(...event.addedFiles);
  }
  exportToExcel = () => {
    this.gridApi.exportDataAsCsv();
  }
  onRemove(event) {
    console.log(event);
    this.files.splice(this.files.indexOf(event), 1);
  }
  loadFile(res) {

    /* wire up file reader */
    this.spinner.show();
    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(res);
    reader.onload = (e: any) => {
      /* create workbook */
      const binarystr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary', cellDates: true });
      /* selected the first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      /* save data */
      const data = XLSX.utils.sheet_to_json(ws); // to get 2d array pass 2nd parameter as object {header: 1}
      console.log(data);
      this.rowList = data;
      console.log(JSON.stringify(this.rowList));
      // for (let i = 0; i < this.ItemMasterList.length; i++) {
      //   if (this.ItemMasterList[i]['']) {
      //     this.ItemMasterList[i][''] =
      //   }
      // }
      this.spinner.hide();
    };
  }
  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.itemSeletedList.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }

    this.searchItem.setValue('');
  }

  remove(fruit: string): void {
    const index = this.itemSeletedList.indexOf(fruit);

    if (index >= 0) {
      this.itemSeletedList.splice(index, 1);
    }
  }
  selected(event: MatAutocompleteSelectedEvent): void {
    this.itemSeletedList.push(event.option.viewValue);
    this.searchItemInput.nativeElement.value = '';
    this.searchItem.setValue(null);
  }
  selectedCustomer(event: MatAutocompleteSelectedEvent): void {
    this.customerSelectedList.push(event.option.viewValue);
    this.searchCustomerInput.nativeElement.value = '';
    this.searchCustomer.setValue(null);
  }
  removeCustomer(fruit: string): void {
    const index = this.customerSelectedList.indexOf(fruit);

    if (index >= 0) {
      this.customerSelectedList.splice(index, 1);
    }
  }
  addCustomer(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our Customer
    if ((value || '').trim()) {
      this.customerSelectedList.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }

    this.searchCustomer.setValue('');
  }
  onItemSelect(item?: boolean, items?) {
    var columns = [];
    var newColumnDefs = [];
    columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
    // const columnDefs = this.columnDefs;
    if (columns && columns.length > 0 && !item) {
      const columnDefs = JSON.parse(JSON.stringify(this.tempColDefs));
      const list = columnDefs.map(column => {
        if (column.children) {
          // || col.field.startsWith('q') || col.field.startsWith('totalYear')
          if (column.headerName !== 'Quest 128GB') {
            column.children = column.children.filter(col => columns.findIndex((a, b) => col.field.indexOf(a) > -1) > -1);
            column.children = column.children.map(col => ({ ...col, editable: params => { return params.data['secondValue'] !== 'Total Forecast' } }));
          }

        }
        return column;
      });
      newColumnDefs = newColumnDefs.length > 0 ? list.push(...newColumnDefs) : list as any;
      newColumnDefs = newColumnDefs.filter(col => columns.findIndex((a, b) => ((col.field === '' || col.pinned))) > -1);
      // newColumnDefs = newColumnDefs.filter(col => (col.field === '' || col.pinned));
      newColumnDefs = newColumnDefs.map(col => ({ ...col, cellRenderer: col.field === 'firstValue' ? params => `<b>${params.value ? params.value : ''}</b>` : null }))
      for (let i = 0; i < newColumnDefs.length; i++) {
        if (newColumnDefs[i].headerName === 'Quest 128GB') {
          newColumnDefs[i].children[0] = {
            ...newColumnDefs[i].children[0],
            cellRenderer: 'dropdownRenderer',
            cellStyle: params => params.rowData && params.rowData.rowIndex % 2 === 0 ? { 'background-color': 'white' } : { 'background-color': 'white' },
            cellRendererParams: (params) => {
              const items = ['Algo Base Fcst (ST)', 'Linear',
                'Curve',
                'Exponential',
                'Logarithmic',
                'Power',
                'Parabola',
                'Moving Average',
                'Single Expotential Smoothing',
                'Adaptive Smoothing',
                'Holts Linear Trend',
                'Period Percentage Change',
                'Seasonal Smoothing Method',
                'Seasonal Smoothing Average',
                'Seasonal Percentage Change',
                'Additive Decomposition',
                'Winters Additive'];
              const obj = {
                items: items,
                isDropDown: items.includes(params.data.secondValue) ? true : false, // pass the field value here
                onChange: this.filterData.bind(this),
              }
              return obj;
            },
          }
        }
      }
      this.gridOptions.api.setColumnDefs(newColumnDefs);
    } else {
      if (item) {
        this.timeframeSelectedList = items
      }
      this.gridOptions.api.setColumnDefs(this.columnDefs);
    }
    this.calculateListValues();
  }
  onSelectAll(items: any) {
    this.onItemSelect(true, items)
  }
  openFullScreen = (id: string) => {
    const domGrid = document.getElementById(id) as any;
    if (domGrid) {
      domGrid.webkitRequestFullscreen();
    }
  }
  applyGraph(totalCalculatedList) {
    const data = {
      chart: {
        caption: "",
        yaxisname: "",
        subcaption: "",
        showhovereffect: "1",
        lineThickness: "4",
        "width": "100%",
        "height": "150px",
        numbersuffix: "",
        "paletteColors": "#8D009D,#F8486E, #1C9FAD, #2480D3",
        drawcrossline: "1",
        plottooltext: "<b>$dataValue</b>",
        theme: "fusion"
      },
      categories: [
        {
          category: this.getLabels(totalCalculatedList)
        }
      ],
      dataset: totalCalculatedList.map(item => ({ seriesname: item.secondValue, data: this.getList(item) }))
    };
    this.dataSource = data as any;
  }
  public getLabels = (totalCalculatedList) => {
    const el = totalCalculatedList[0];
    const list = [];
    Object.keys(el).forEach(key => {
      const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
      if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
        list.push({ label: this.getKeyValue(key) });
      }
      if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
        const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
        if (flag) {
          list.push({ label: this.getKeyValue(key) });
        }
      }
    });
    return list;
  }
  getKeyValue(key) {
    const list = [
      { key: 'janw1', value: '01/05/2020' },
      { key: 'janw2', value: '01/12/2020' },
      { key: 'janw3', value: '01/19/2020' },
      { key: 'janw4', value: '01/26/2020' },
      { key: 'ttlJanuary', value: 'Total January' },
      { key: 'febw1', value: '02/02/2020' },
      { key: 'febw2', value: '02/09/2020' },
      { key: 'febw3', value: '02/16/2020' },
      { key: 'febw4', value: '02/23/2020' },
      { key: 'ttlFebruary', value: 'Total February' },
      { key: 'marchw1', value: '03/01/2020' },
      { key: 'marchw2', value: '03/08/2020' },
      { key: 'marchw3', value: '03/15/2020' },
      { key: 'marchw4', value: '03/22/2020' },
      { key: 'marchw5', value: '03/29/2020' },
      { key: 'ttlMarch', value: 'Total March' },
      { key: 'q1', value: 'Q1' },
      { key: 'aprilw1', value: '04/05/2020' },
      { key: 'aprilw2', value: '04/12/2020' },
      { key: 'aprilw3', value: '04/19/2020' },
      { key: 'aprilw4', value: '04/26/2020' },
      { key: 'ttlApril', value: 'Total April' },
      { key: 'mayw1', value: '05/03/2020' },
      { key: 'mayw2', value: '05/10/2020' },
      { key: 'mayw3', value: '05/17/2020' },
      { key: 'mayw4', value: '05/24/2020' },
      { key: 'ttlMay', value: 'Total May' },
      { key: 'junew1', value: '05/31/2020' },
      { key: 'junew2', value: '06/07/2020' },
      { key: 'junew3', value: '06/14/2020' },
      { key: 'junew4', value: '06/21/2020' },
      { key: 'junew5', value: '06/28/2020' },
      { key: 'ttlJune', value: 'Total June' },
      { key: 'q2', value: 'Q2' },
      { key: 'julyw1', value: '07/05/2020' },
      { key: 'julyw2', value: '07/12/2020' },
      { key: 'julyw3', value: '07/19/2020' },
      { key: 'julyw4', value: '07/26/2020' },
      { key: 'ttlJuly', value: 'Total July' },
      { key: 'augw1', value: '08/02/2020' },
      { key: 'augw2', value: '08/09/2020' },
      { key: 'augw3', value: '08/16/2020' },
      { key: 'augw4', value: '08/23/2020' },
      { key: 'ttlAugust', value: 'Total August' },
      { key: 'sepw1', value: '09/30/2020' },
      { key: 'sepw2', value: '09/06/2020' },
      { key: 'sepw3', value: '09/13/2020' },
      { key: 'sepw4', value: '09/20/2020' },
      { key: 'sepw5', value: '09/27/2020' },
      { key: 'ttlSeptember', value: 'Total September' },
      { key: 'q3', value: 'Q3' },
      { key: 'octw1', value: '10/04/2020' },
      { key: 'octw2', value: '10/11/2020' },
      { key: 'octw3', value: '10/18/2020' },
      { key: 'octw4', value: '10/25/2020' },
      { key: 'ttlOctober', value: 'Total October' },
      { key: 'novw1', value: '11/01/2020' },
      { key: 'novw2', value: '11/08/2020' },
      { key: 'novw3', value: '11/15/2020' },
      { key: 'novw4', value: '11/22/2020' },
      { key: 'ttlNovember', value: 'Total November' },
      { key: 'novw5', value: '11/29/2020' },
      { key: 'decw1', value: '12/06/2020' },
      { key: 'decw2', value: '12/13/2020' },
      { key: 'decw3', value: '12/20/2020' },
      { key: 'decw4', value: '12/27/2020' },
      { key: 'ttlDecember', value: 'Total December' },
      { key: 'q4', value: 'Q4' },
      { key: 'totalYear', value: 'Total Year' },
    ];
    return list.find(item => item.key === key) ? list.find(item => item.key === key).value : '';
  }
  getList = (row) => {
    const list = [];
    Object.keys(row).forEach(key => {
      if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue') {
        list.push(row[key]);
      }
    });
    return list.map(item => ({ value: item }))
  }
  filterData = (value) => {
    const list = JSON.parse(JSON.stringify(this.tempList));
    let index = list.findIndex(row => row.secondValue === value.event.value);
    if (index > -1) {
      list[0] = JSON.parse(JSON.stringify(list[index]));
      list[0].columnValue = 'Sell-Through';
    } else if (value.event.value === 'Algo Base Fcst (ST)') {
      index = list.findIndex(row => row.secondValue === 'Linear');
      list[0] = JSON.parse(JSON.stringify(list[index]));
      list[0].columnValue = 'Sell-Through';
    }
    this.tempList = [...list];
    this.calculateListValues(null, list);
  }
}
